/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */

import { Box } from "@mui/system";
import { debounce, set } from "lodash";
import axios, { AxiosError } from "axios";
import { toast } from "react-toastify";
import { ocultarAcoes } from "../../../services/acesso";
import { crudDe } from "../../../services/acesso";
import api from "../../../services/api";
import { Tooltip, Typography } from "@mui/material";
import { useHistory, useLocation } from "react-router-dom";
import { useContext } from "react";
import styled from "styled-components";
import { OnboardingContext } from "../../onboarding/OnboardingContext";
import { pareceMensagemTecnica } from "../../../services/onboarding";
import { rastrearTeste } from "../../../services/rastreamentoTeste";
import BotaoLerCnh, { CnhLida, formatarCpf, validadeCnhParaIso } from "../../../components/ler-cnh";
import { AvisoGuia, GuiaFormulario } from "../../../components/modal-form/types";
import TextField from '@mui/material/TextField';
import { FiTruck, FiUser } from "react-icons/fi";
import Listagem, { ConfiguracaoFiltros, FiltroDropdownOpcao } from "../../../components/listagem";
import ModalAlerta from "../../../components/modal";
import ModalRelatorioLocacao from "../../../components/modal-relatorio-locacao";
import { useAppSelector } from "../../../store/hooks";
import { GridFilterOperator } from "@mui/x-data-grid";
import { confirm } from "../../../components/confirm";
import { AlteracaoPagamento, confirmarEdicaoComRegeracaoDePagamentos } from "../../../components/confirm/edicao-pagamentos";
import ModalLancamentosPendentes, { LancamentoPendente, PagamentoPendente } from "../../../components/modal-lancamentos-pendentes";
import ModalForm from "../../../components/modal-form";
import EscolhaAssinaturaAsaas, { ClassificacaoAssinaturas, ResumoEscolhaAssinatura, datasSugeridasPelaAssinatura, sugerirAssinaturaDoAluguel } from "../../../components/escolha-assinatura-asaas";
import ConciliacaoCobrancasAsaasView, { ConciliacaoCobrancas, ChaveItem, TipoItemConciliacao, AcaoConciliacao, chaveDaCategoria, ehChaveDeCategoria } from "../../../components/conciliacao-cobrancas-asaas";
import { ClassificacaoCobrancas, EscolhaCobranca, sugerirClassificacao, LinhaCobranca, ResumoClassificacao, AvisoCobrancasIndisponiveis, TextoDeAbertura } from "../../../components/classificacao-cobrancas-criacao";
import ToggleSwitch, { LinhaToggleComAjuda } from "../../../components/toggle-switch";
import Ajudinha from "../../../components/ajudinha";
import { LocaSmartLayout } from "../../../components/locasmart-layout";
import { FaMoneyBill1Wave, FaMoneyBillTransfer, FaTimeline } from "react-icons/fa6";
import { useEffect, useState, useCallback, useMemo, useRef } from "react";
import { TipoFormulario, TipoVeiculo, ESTADOS_BRASIL } from "../../../services/constantes";
import { FipeMarca, FipeModelo, FipeService, consultarPorPlaca } from "../../../services/veiculoService";
import { ehPlanoGratuito, estaEmPeriodoDeTeste, obterEhAdmin, obterIdTenent, obterIdUsuario, usuarioTemPermissao } from "../../../services/seguranca";
import { FaCalendar, FaCarSide, FaCheckCircle, FaDollarSign, FaExchangeAlt, FaFileAlt, FaFileArchive, FaFileContract, FaFileDownload, FaFilePdf, FaHandshake, FaInfo, FaMobileAlt, FaMoneyBill, FaMotorcycle, FaSearchLocation, FaSignature, FaTimes, FaUniversity, FaUser, FaEye, FaSyncAlt, FaFileSignature, FaSign } from "react-icons/fa";
import { ApiError, Banco, Campo, Opcao, Servico, Locacao, StatusLocacao, OpcoesPeriodicidadePagamento, TipoPeriodicidadePagamento, DiaDaSemana, CoresVeiculo, BillingTypeOptions, BillingTypeOptionsComHeranca, BillingTypeAsaas } from "../../../services/tipos";
import { calcularDiaria, converterDiaSemanaParaTexto, converterStatusLocacaoParaTexto, extrairMensagemErroApi, formatDateToISOWithZeroTime, formatarData, formatarDataHora, obterNumeroDoDia, formatarParaReais, handleDownloadFile, converterPeriodicidadePagamentoParaTexto, converterPeriodicidadeTempoParaTexto, parseDateFromString, formatarEndereco, retornarDinheiroPorExtenso } from "../../../services/utilitarios";
import { useFiliais } from "../../../hooks/useFiliais";
import { OPCOES_PRAZO_TODAS, OpcaoComMaximo } from "../../../components/select-number";
import { ContratoViewer } from "../../../components/docx-preview";
import ModalLink from "../../../components/modal-link";
import { Modal, Form, Button, Row, Col } from 'react-bootstrap';
import { showButtonList } from "../../../components/button-list";
import asaasLogo from "../../../assets/asaas.png";
import ModalResumoLocacao from "../../../components/modal-resumo-locacao";
import ModalConciliarBanco from "../../../components/modal-conciliar-banco";
import ModalDocumentosLocacao from "../../../components/modal-documentos-locacao";
import ModalLoginApp from "../../../components/modal-login-app";
import ModalEscolhaGerarContrato from "../../../components/modal-escolha-gerar-contrato";
import ParcelasCaucaoEditor from "../../../components/parcelas-caucao-editor";
import LancamentosLocacaoEditor, { LancamentoAvulso } from "../../../components/lancamentos-locacao-editor";
import { NomeCaucao, useNomeCaucao } from "../../../hooks/useNomeCaucao";
import { calcularFimDoPrazoContratado, prepararLocacaoParaFormulario, separarEmMesesEDias } from './prazo';
import { montarPayloadMudancaStatus } from './statusPayload';

const AvisoMaisDados = styled.div`
    margin-top: -4px;
    span { font-size: 0.85rem; color: #1F467E; }
`;

const BotaoRetomarOnboarding = styled.button`
    display: block;
    margin: 120px auto;
    padding: 14px 28px;
    border: none;
    border-radius: 10px;
    background: #1F467E;
    color: #ffffff;
    font-weight: 600;
    font-size: 15px;
    cursor: pointer;
`;

// Criação guiada da primeira locação (onboarding). Os campos obrigatórios vêm na ordem da tela;
// aqui ficam só os textos, os avisos que o usuário confirma e o que dizer no Avançar/Salvar.
// Recebe o nome da caução: a categoria pode ter sido renomeada (ex.: "ADESÃO").
const criarGuiaPrimeiraLocacao = (caucao: NomeCaucao): GuiaFormulario => ({
    dicas: {
        idVeiculo: { titulo: 'Escolha o veículo', texto: 'Estes são os veículos que você acabou de cadastrar. Escolha o que vai ser alugado.' },
        // Sem veículo livre, o veículo é cadastrado aqui mesmo, junto com a locação.
        placa: { titulo: 'Placa do veículo', texto: 'Digite a placa do veículo que vai ser alugado. Se acharmos a placa, completamos os outros dados.' },
        tipoVeiculo: { titulo: 'Tipo do veículo', texto: 'Escolha se é carro, moto ou caminhão.' },
        marca: { titulo: 'Marca', texto: 'Escolha ou digite a marca do veículo.' },
        modelo: { titulo: 'Modelo', texto: 'Escolha ou digite o modelo do veículo.' },
        ano: { titulo: 'Ano', texto: 'Digite o ano do veículo.' },
        cor: { titulo: 'Cor', texto: 'Escolha a cor do veículo.' },
        idLocatario: { titulo: 'Escolha o cliente', texto: 'Escolha quem vai alugar o veículo, ou clique em "Cadastrar Locatário" acima para cadastrar um cliente novo.' },
        nome: { titulo: 'Nome do cliente', texto: 'Digite o nome completo do cliente, como está no documento.' },
        tipoDocumento: { titulo: 'CPF ou CNPJ', texto: 'Diga se o cliente é pessoa física (CPF) ou empresa (CNPJ).' },
        documento: { titulo: 'Documento do cliente', texto: 'Digite o CPF do cliente.' },
        periodicidadePagamento: { titulo: 'De quanto em quanto tempo ele paga?', texto: 'Escolha se o cliente paga por dia, semana, quinzena ou mês. O sistema monta os pagamentos a partir disso.' },
        tempoContratoEmMeses: { titulo: 'Prazo mínimo', texto: 'Por quanto tempo, no mínimo, vale o contrato. Dá para prorrogar depois.' },
        valorAluguel: { titulo: 'Valor do aluguel', texto: 'Quanto o cliente paga a cada período que você escolheu.' },
        dataInicio: { titulo: 'Retirada do veículo', texto: 'O dia em que o cliente pegou (ou vai pegar) o veículo.' },
        dataPagamento: { titulo: 'Primeiro pagamento', texto: 'A data do primeiro pagamento. Os próximos seguem a periodicidade que você escolheu.' },
    },
    // Os opcionais e os que já vêm preenchidos também ganham balão, na ordem da tela: saem com
    // "Entendi" ou quando a pessoa mexe no campo.
    avisos: (pagina, entidade) => {
        const avisos: AvisoGuia[] = [];
        if (pagina === 'Dados' && entidade?.locatarioEscolha === 'novoLocatario' && !entidade?.nome && !entidade?.documento)
            avisos.push({
                alvo: '_lerCnhLocatario', botao: 'Vou digitar',
                titulo: 'Cadastre o cliente pela CNH',
                texto: 'Clique em "Preencher pela CNH" e envie a foto ou o PDF da CNH do cliente. A gente preenche nome, CPF, RG e CNH para você só conferir.',
            });
        if (pagina === 'Dados' && entidade?.locatarioEscolha === 'novoLocatario')
            avisos.push({
                alvo: 'cep', titulo: 'Endereço do cliente',
                texto: 'O endereço do cliente aparece em praticamente todo contrato. Digite o CEP e a gente completa rua, bairro, cidade e estado. Depois é só informar o número.',
            });
        if (pagina === 'Contrato')
            avisos.push(
                { alvo: 'kmInicial', titulo: 'Quilometragem na entrega', texto: 'Quantos km o veículo marca quando vai para o cliente. É opcional, mas ajuda a controlar revisões e troca de óleo.' },
                { alvo: 'locacaoEmAndamento', titulo: 'O veículo já está com o cliente?', texto: 'Se esta locação começou antes de você usar o LocaSmartPro, marque esta opção. Os pagamentos antigos entram como já recebidos.' },
                { alvo: 'tempoContratoEmMeses', titulo: 'Prazo mínimo do contrato', texto: 'Já vem com 1 mês. É o tempo mínimo da locação e define quantos pagamentos o sistema gera agora. Dá para prorrogar depois.' },
            );
        if (pagina === 'Valores')
            avisos.push({ alvo: 'valorCaucao', titulo: `${caucao.titulo} (opcional)`, texto: `Se você cobra ${caucao.minusculo} na entrega do veículo, informe aqui. Se não cobra, deixe em branco.` });
        if (pagina === 'Juros e Multa')
            avisos.push(
                { alvo: 'jurosEscolha', titulo: 'Juros por atraso', texto: 'Escolha se os juros são um valor por dia de atraso ou um percentual ao mês.' },
                { alvo: entidade?.jurosEscolha === 'jurosPorMes' ? 'jurosAoMes' : 'valorJurosAoDia', titulo: 'Valor dos juros', texto: 'Quanto cobrar de juros quando o cliente atrasar. Se não cobra, deixe em branco.' },
                { alvo: 'multaEscolha', titulo: 'Multa por atraso', texto: 'A multa é cobrada uma vez quando o pagamento atrasa, em percentual ou em valor fixo.' },
                { alvo: entidade?.multaEscolha === 'multaFixo' ? 'multaFixa' : 'multaPercentual', titulo: 'Valor da multa', texto: 'Quanto cobrar de multa. Se não cobra, deixe em branco.' },
            );
        if (pagina === 'Lançamentos Iniciais')
            avisos.push(
                { alvo: 'gerarPagamentoInicialComoPago', titulo: 'Primeiro pagamento já recebido?', texto: 'Marque se o cliente já pagou o primeiro aluguel, para o sistema não cobrar de novo.' },
                { alvo: 'gerarLancamentoCaucaoComoPago', titulo: `${caucao.titulo} já recebida?`, texto: `Marque se o cliente já pagou a ${caucao.minusculo}.` },
                { alvo: 'definirPagamentosAnteriorAHojeComoPago', titulo: 'Pagamentos de antes de hoje', texto: 'Na locação em andamento, marque para dar como recebidos os pagamentos anteriores a hoje.' },
                { alvo: 'desejoGerarPagamentoUnico', titulo: 'Pagamento único', texto: 'Marque se prefere um pagamento só com todos os dias locados, em vez de um por período.' },
            );
        if (pagina === 'Arquivo')
            avisos.push(entidade?.modeloContrato
                ? { alvo: 'modeloContrato', titulo: 'Seu contrato', texto: 'É o contrato que você mandou. Ao salvar, ele sai preenchido com os dados do cliente, do veículo e dos valores desta locação.' }
                : { alvo: 'contratoEscolha', titulo: 'Contrato da locação', texto: 'Gere o contrato a partir de um modelo ou anexe o contrato assinado. É opcional.' });
        return avisos;
    },
    fimDaPagina: (pagina, entidade, ultima) => {
        if (ultima)
            return entidade?.contratoEscolha === 'gerarContrato' && entidade?.modeloContrato
                ? { titulo: 'Tudo pronto!', texto: 'Clique em "Salvar" para criar a sua primeira locação. O sistema gera os pagamentos e o contrato com o seu modelo.' }
                : { titulo: 'Tudo pronto!', texto: 'Se tiver o contrato assinado em arquivo, anexe acima (é opcional). Depois clique em "Salvar" para criar a sua primeira locação.' };
        return { titulo: 'Esta parte está completa', texto: 'Clique em "Avançar" para seguir.' };
    },
});

function LocacaoListagem() {
    const { empresaTemFiliais, filiaisOptions, filialSelecionada, getCampoFilial, getAcaoEmLoteFilial, labelComFilial } = useFiliais();
    const token = useAppSelector(state => state.token);
    const isAdmin = obterEhAdmin(token);
    const [usuariosEmpresa, setUsuariosEmpresa] = useState<{ id: string; nome: string }[]>([]);
    const [messagem, setMensagem] = useState<string[]>([]);
    const [dataAPartir, setDataAPartir] = useState<Date>();
    const [locacoes, setLocacoes] = useState<Servico[]>([]);
    const [carregandoPagamentos] = useState<boolean>(false);
    const [carregandoGerarContrato, setCarregandoGerarContrato] = useState<boolean>(false);
    const [isSaving, setIsSaving] = useState<boolean>(false);
    const [carregando, setCarregando] = useState<boolean>(true);
    const [exibirFormModal, setExibirFormModal] = useState(false);
    const [showAlertaSimNao, setShowAlertaSimNao] = useState(false);
    const [veiculosOptions, setVeiculosOptions] = useState<Opcao[]>([]);
    const [veiculosRaw, setVeiculosRaw] = useState<any[]>([]);
    const [geraPagamentoUnico, setGeraPagamentoUnico] = useState(false);
    const [diaSegundoPagamento, setDiaSegundoPagamento] = useState<Date>();
    const [locatariosOptions, setLocatariosOptions] = useState<Opcao[]>([]);
    const [locatariosRaw, setLocatariosRaw] = useState<any[]>([]);
    const [modelosContratoOptions, setModelosContratoOptions] = useState<Opcao[]>([]);
    const [realizarConsulta, setRealizarConsulta] = useState<boolean>(true);
    const [diaPrimeiroPagamento, setDiaPrimeiroPagamento] = useState<Date>();
    const [modo, setModo] = useState<TipoFormulario>(TipoFormulario.tpNenhum);
    const [desejoDefinirDias, setDesejoDefinirDias] = useState<boolean>(false);
    const [isSavingPagamentos, setIsSavingPagamentos] = useState<boolean>(false);
    const [entidadeDoSimNao, setEntidadeDoSimNao] = useState<Locacao>({} as Locacao);
    const [exibirFormModalPagamentos, setExibirFormModalPagamentos] = useState(false);
    const [exibirGerarContrato, setExibirGerarContrato] = useState(false);
    const [geraPagamentoDiferencaDias, setGeraPagamentoDiferencaDias] = useState(false);
    const [locacaoSelecionado, setLocacaoSelecionado] = useState<any>({});
    const locacaoSelecionadoRef = useRef<any>({});
    // Marcado no ponto em que o PUT da locação deu certo: o onSave trata o erro no catch sem relançar, e o
    // encerramento precisa saber se a locação foi mesmo encerrada antes de abrir o modal de pendentes (DL-194).
    const ultimoSalvamentoOkRef = useRef<boolean>(false);
    locacaoSelecionadoRef.current = locacaoSelecionado;
    const [limiteKmEncerramento, setLimiteKmEncerramento] = useState<number>(0);
    const [kmExcedenteInfo, setKmExcedenteInfo] = useState<string | null>(null);
    const [carregandoEncerramento, setCarregandoEncerramento] = useState<boolean>(false);
    const [showAlertaConfirmarRegeracao, setShowAlertaConfirmarRegeracao] = useState(false);
    const [messagemConfirmarRegeracao, setMessagemConfirmarRegeracao] = useState<string[]>([]);
    const [exibirFormModalEncerramento, setExibirFormModalEncerramento] = useState<boolean>(false);
    const [exibirModalPendentes, setExibirModalPendentes] = useState<boolean>(false);
    const [lancamentosPendentes, setLancamentosPendentes] = useState<LancamentoPendente[]>([]);
    const [pagamentosPendentes, setPagamentosPendentes] = useState<PagamentoPendente[]>([]);
    const [locacaoEncerradaId, setLocacaoEncerradaId] = useState<string | null>(null);
    const [carregandoRemocaoPendentes, setCarregandoRemocaoPendentes] = useState<boolean>(false);
    const [entidadeParaAtualizarPagamentos, setEntidadeParaAtualizarPagamentos] = useState<any>({});
    const [entidadeParaAtualizarGerarContrato, setEntidadeParaAtualizarGerarContrato] = useState<any>({});
    const [entidadeParaAtualizarLocacao, setEntidadeParaAtualizarLocacao] = useState<any>({});
    const [entidadeParaAtualizarAlterarData, setEntidadeParaAtualizarAlterarData] = useState<any>({});
    const [entidadeParaAtualizarEncerramento, setEntidadeParaAtualizarEncerramento] = useState<any>({});
    const [carregandoAlterarDataPagamento, setCarregandoAlterarDataPagamento] = useState<boolean>(false);
    const [carregandoAtualizarContrato, setCarregandoAtualizarContrato] = useState<boolean>(false);
    const [carregandoAlterarValorPagamento, setCarregandoAlterarValorPagamento] = useState<boolean>(false);
    const [exibirFormModalAlterarDataPagamento, setExibirFormModalAlterarDataPagamento] = useState(false);
    const [exibirFormModalAlterarValorPagamento, setExibirFormModalAlterarValorPagamento] = useState(false);
    const [exibirModalVincularAsaas, setExibirModalVincularAsaas] = useState(false);
    // Conciliação manual das cobranças do cliente no Asaas com os itens da locação.
    const [exibirModalConciliacao, setExibirModalConciliacao] = useState(false);
    const [dadosConciliacao, setDadosConciliacao] = useState<ConciliacaoCobrancas | null>(null);
    const [carregandoConciliacao, setCarregandoConciliacao] = useState(false);
    const [salvandoConciliacao, setSalvandoConciliacao] = useState(false);
    const [vinculosConciliacao, setVinculosConciliacao] = useState<Record<string, ChaveItem>>({});
    const [locacaoConciliacaoAsaas, setLocacaoConciliacaoAsaas] = useState<Locacao | null>(null);
    // Escolha de assinatura (reaproveitar x criar nova), decidida ANTES de qualquer escrita.
    const [classificacaoAssinaturas, setClassificacaoAssinaturas] = useState<ClassificacaoAssinaturas | null>(null);
    const [carregandoAssinaturasAsaas, setCarregandoAssinaturasAsaas] = useState(false);
    const [assinaturaEscolhida, setAssinaturaEscolhida] = useState<string | null>(null);
    const [atualizarFaturasEmAberto, setAtualizarFaturasEmAberto] = useState(false);
    const [importarPagasAnterioresAoInicio, setImportarPagasAnterioresAoInicio] = useState(false);
    const [previewVinculacao, setPreviewVinculacao] = useState<any>(null);
    const ultimoLocatarioConsultado = useRef<string | null>(null);
    const requisicaoAssinaturasRef = useRef(0);
    const camposNovoLocatarioRef = useRef<Record<string, any>>({});
    // Locatário que está no formulário, para reconsultar quando periodicidade/quinzena/filial mudarem.
    const locatarioDaClassificacao = useRef<any>(null);
    // Espelho da escolha atual: a reclassificação precisa lê-la sem se recriar a cada seleção.
    const escolhaAssinaturaRef = useRef<string | null>(null);
    const escolhaAplicadaAoFormularioRef = useRef<string | null>(null);
    const [exibirModalEscolhaAssinatura, setExibirModalEscolhaAssinatura] = useState(false);
    // Cobranças que o cliente já tem no Asaas e que o operador classifica no MESMO momento da assinatura,
    // antes de a locação existir. O que ele decide aqui alimenta o cadastro (caução, lançamentos) e o
    // casamento das cobranças de aluguel, sem nada ser criado em duplicidade.
    const [cobrancasDisponiveisCriacao, setCobrancasDisponiveisCriacao] = useState<any[]>([]);
    const [categoriasCobrancasCriacao, setCategoriasCobrancasCriacao] = useState<any[]>([]);
    // Nome que o locador deu à categoria de caução (ex.: "ADESÃO"): vale para os rótulos desta tela.
    const nomeCaucao = useNomeCaucao();
    const guiaPrimeiraLocacao = useMemo((): GuiaFormulario => ({
        ...criarGuiaPrimeiraLocacao(nomeCaucao),
        aoExibirPasso: ({ chave, ordem }) => rastrearTeste('onboarding_guia_passo', { passo: chave, indice: ordem }),
    }), [nomeCaucao.maiusculo]);
    const [cobrancasIndisponiveisCriacao, setCobrancasIndisponiveisCriacao] = useState(false);
    const [classificacaoCobrancas, setClassificacaoCobrancas] = useState<ClassificacaoCobrancas>({});
    const [carregandoVincularAsaas, setCarregandoVincularAsaas] = useState<boolean>(false);
    const [definirEncerramentoAsaas, setDefinirEncerramentoAsaas] = useState<boolean>(true);
    const [entidadeParaAtualizarVincularAsaas, setEntidadeParaAtualizarVincularAsaas] = useState<any>({});
    const [forcarAtualizacaoDeEntidadeVincularAsaas, setForcarAtualizacaoDeEntidadeVincularAsaas] = useState<boolean>(false);
    const [exibirFormModalSubstituirVeiculo, setExibirFormModalSubstituirVeiculo] = useState(false);
    const [exibirResumoLocacao, setExibirResumoLocacao] = useState(false);
    const [showRelatorioLocacao, setShowRelatorioLocacao] = useState(false);
    const [locacaoSelecionadaParaRelatorio, setLocacaoSelecionadaParaRelatorio] = useState<any>(null);
    const [idLocacaoResumo, setIdLocacaoResumo] = useState<string | null>(null);
    const [carregandoSubstituirVeiculo, setCarregandoSubstituirVeiculo] = useState(false);
    const [veiculosParaSubstituicao, setVeiculosParaSubstituicao] = useState<Opcao[]>([]);
    const [entidadeParaSubstituirVeiculo, setEntidadeParaSubstituirVeiculo] = useState<any>({});
    const [forcarAtualizacaoSubstituirVeiculo, setForcarAtualizacaoSubstituirVeiculo] = useState(false);
    const [historicoSubstituicao, setHistoricoSubstituicao] = useState<any[]>([]);
    const [novoVeiculoSelecionado, setNovoVeiculoSelecionado] = useState('');
    const [dataSubstituicao, setDataSubstituicao] = useState('');
    const [kmFinalVeiculoAtual, setKmFinalVeiculoAtual] = useState('');
    const [kmInicialNovoVeiculo, setKmInicialNovoVeiculo] = useState('');
    const [forcarAtualizacaoDeEntidadeNoModal, setForcarAtualizacaoDeEntidadeNoModal] = useState<boolean>(false);
    const [forcarAtualizacaoDeEntidadeNoModalGerarContrato, setForcarAtualizacaoDeEntidadeNoModalGerarContrato] = useState<boolean>(false);
    const [exibirModalVariaveisManuais, setExibirModalVariaveisManuais] = useState(false);
    const [variaveisPendentes, setVariaveisPendentes] = useState<{ chave: string; descricao: string; isCustomizada?: boolean; isRequired?: boolean }[]>([]);
    const camposVariaveisManuais = useMemo(() => {
        const fixas = variaveisPendentes.filter(v => !v.isCustomizada);
        const customs = variaveisPendentes.filter(v => v.isCustomizada);
        const campos: any[] = [];
        let linha = 1;

        const seccaoLabel = (label: string, subLabel: string | undefined, nome: string) => ({
            label,
            ...(subLabel ? { subLabel } : {}),
            nome,
            tipo: 'label' as const,
            largura: 12,
            coluna: 1,
            linha: linha++,
            visible: true,
        });

        // Nenhuma variável é obrigatória: deixar em branco é permitido e sai em branco no contrato.
        const variavelCampo = (chave: string, descricao: string) => ({
            label: descricao,
            nome: chave,
            required: false,
            tipo: 'memo' as const,
            maximoCaracteres: 1000,
            extraProps: { autoGrow: true },
            largura: 12,
            coluna: 1,
            linha: linha++,
            visible: true,
        });

        if (fixas.length > 0) {
            if (customs.length > 0) {
                campos.push(seccaoLabel('Observações do contrato', undefined, '__secao_fixas__'));
            }
            fixas.forEach(v => campos.push(variavelCampo(v.chave, v.descricao)));
        }
        if (customs.length > 0) {
            if (fixas.length > 0) {
                campos.push(seccaoLabel('Variáveis personalizadas', 'Variáveis customizadas que você criou no modelo de contrato', '__secao_customs__'));
            }
            customs.forEach(v => campos.push(variavelCampo(v.chave, v.descricao)));
        }

        return campos;
    }, [variaveisPendentes]);
    const [modeloContratoSelecionadoId, setModeloContratoSelecionadoId] = useState<string>('');
    const [exibirModalNovaPrevisaoEncerramento, setExibirModalNovaPrevisaoEncerramento] = useState(false);
    const [salvandoNovaPrevisao, setSalvandoNovaPrevisao] = useState(false);
    const [entidadeParaAtualizarNovaPrevisao, setEntidadeParaAtualizarNovaPrevisao] = useState<any>({});
    const [forcarAtualizacaoNovaPrevisao, setForcarAtualizacaoNovaPrevisao] = useState(false);
    // Data digitada na edição comum que foi redirecionada para "Nova Previsão de Encerramento":
    // pré-preenche o modal para a pessoa não digitar de novo.
    const dataSugeridaNovaPrevisao = useRef<string | null>(null);
    const [forcarAtualizacaoDeEntidadeLocacao, setForcarAtualizacaoDeEntidadeLocacao] = useState<boolean>(false);
    const [forcarAtualizacaoDeEntidadeAlterarData, setForcarAtualizacaoDeEntidadeAlterarData] = useState<boolean>(false);
    const [forcarAtualizacaoDeEntidadeNoModalPagamentos, setForcarAtualizacaoDeEntidadeNoModalPagamentos] = useState<boolean>(false);
    const [forcarAtualizacaoDeEntidadeNoModalEncerramento, setForcarAtualizacaoDeEntidadeNoModalEncerramento] = useState<boolean>(false);
    const [tipoPeriodicidadePagamento, setTipoPeriodicidadePagamento] = useState<TipoPeriodicidadePagamento>(TipoPeriodicidadePagamento.Diario);
    const novoDiaRef = useRef<number | null>(null);
    const [arquivoRemovido, setArquivoRemovido] = useState<boolean>(false);
    const [novoVeiculo, setNovoVeiculo] = useState<boolean>(false);
    const [multaPercentual, setMultaPercentual] = useState<boolean>(false);
    const [jurosPorDia, setJurosPorDia] = useState<boolean>(false);
    const [novoLocatario, setNovoLocatario] = useState<boolean>(false);
    const [marcas, setMarcas] = useState<FipeMarca[]>([]);
    const [modelos, setModelos] = useState<FipeModelo[]>([]);
    const [tipoVeiculo, setTipoVeiculo] = useState<TipoVeiculo>(TipoVeiculo.tpNenhum);
    const [carregandoSelect, setCarregandoSelect] = useState<boolean>(false);
    const [consultandoPlaca, setConsultandoPlaca] = useState<boolean>(false);
    const [opcoesPrazoMinimo, setOpcoesPrazoMinimo] = useState<OpcaoComMaximo[]>(OPCOES_PRAZO_TODAS);
    const [mascaraDocumento, setMascaraDocumento] = useState<string>('999.999.999-99');
    const [estado, setEstado] = useState<string>('');
    const [estados, setEstados] = useState<any[]>([]);
    const [cidades, setCidades] = useState<any[]>([]);
    const [carregandoSelectCidades, setCarregandoSelectCidades] = useState<boolean>(false);
    const temPermissao = useMemo(() => usuarioTemPermissao(token, 'locacao_visualizar'), [token]);
    const [exibirVisualizadorContrato, setExibirVisualizadorContrato] = useState<boolean>(false);
    const [linkContratoPreview, setLinkContratoPreview] = useState<string>("");
    const [tituloContratoVisualizador, setTituloContratoVisualizador] = useState<string>("");
    const fipeService = useMemo(() => new FipeService(), []);
    const location = useLocation();
    const onboarding = useContext(OnboardingContext);
    // Onboarding sem veículo livre (a pessoa pulou a frota ou o veículo já está alugado): libera
    // "Cadastrar Veículo" para ela cadastrar o veículo aqui mesmo, em vez de ficar sem opção.
    const [semVeiculoLivre, setSemVeiculoLivre] = useState<boolean>(Boolean(onboarding.semVeiculoLivre));
    const [geraContrato, setGeraContrato] = useState(false);
    const [integradoAsaas, setIntegradoAsaas] = useState<boolean>(false);

    // Decisão por locação de enviar (ou não) as cobranças ao Asaas, mesmo com a conta integrada.
    // Nasce marcada: quem integrou a conta quer cobrar por lá na maioria dos contratos, e o opt-out
    // é a exceção (acerto em dinheiro, contrato antigo, cliente que paga por fora).
    const [enviarParaAsaas, setEnviarParaAsaas] = useState<boolean>(true);

    // O que de fato liga os campos e as regras de Asaas do formulário: a conta precisa estar
    // integrada E esta locação não pode ter sido marcada como fora. Todo lugar que antes olhava
    // `integradoAsaas` para decidir comportamento de cobrança passou a olhar este valor.
    const asaasNestaLocacao = integradoAsaas && enviarParaAsaas;

    // Decisão e forma de pagamento da CAUÇÃO, independentes do aluguel: é comum receber o aluguel
    // por fora e cobrar só a caução pelo Asaas (ou parcelá-la no cartão enquanto o aluguel é Pix).
    const [cobrarCaucaoNoAsaas, setCobrarCaucaoNoAsaas] = useState<boolean>(true);

    // Espelho do select da caução no estado: o editor de parcelas precisa dele para avisar, na hora,
    // que cartão com parcelas desiguais não vira parcelamento de verdade.
    const [caucaoTipoNoForm, setCaucaoTipoNoForm] = useState<string>('');
    const [integradoAutentique, setIntegradoAutentique] = useState<boolean>(false);
    const [linkAssinatura, setLinkAssinatura] = useState<string>("");
    const [exibirLinkAssinaturaModal, setExibirLinkAssinaturaModal] = useState<boolean>(false);
    const [exibirModalLoginApp, setExibirModalLoginApp] = useState<boolean>(false);
    const [loginAppLocatarioId, setLoginAppLocatarioId] = useState<string>('');
    const [valorAluguel, setValorAluguel] = useState<number>(0);
    // Espelho para a consulta de assinaturas ler o valor sem depender dele: como dependência, cada
    // dígito do aluguel refaria a consulta ao Asaas.
    const valorAluguelRef = useRef<number>(0);
    valorAluguelRef.current = valorAluguel;
    const [mostrarAvancadoLocacao, setMostrarAvancadoLocacao] = useState(false);
    const [mostrarAvancadoContrato, setMostrarAvancadoContrato] = useState(false);
    const [bancosOpcoes, setBancosOpcoes] = useState<Opcao[]>([]);
    // Parcelamento da caução (opções avançadas)
    const [valorCaucaoState, setValorCaucaoState] = useState<number>(0);
    const [caucaoParcelada, setCaucaoParcelada] = useState<boolean>(false);
    // Comissão da filial (opções avançadas). Sugerida a partir da filial, editável na locação.
    const [definirComissaoFilial, setDefinirComissaoFilial] = useState<boolean>(false);
    const [comissaoFilialTipo, setComissaoFilialTipo] = useState<number>(0);
    const [filiaisComissao, setFiliaisComissao] = useState<any[]>([]);
    // Parcelas vivem em ref — atualizadas pelo ParcelasCaucaoEditor sem causar re-render do pai.
    // Isso evita perda de foco a cada keystroke (CustomFieldRenderer remountava o componente
    // se a referência de campo.component mudasse).
    const parcelasCaucaoRef = useRef<{ data: string; valor: number; pago: boolean }[]>([]);
    const handleParcelasCaucaoChange = useCallback((parcelas: { data: string; valor: number; pago: boolean }[]) => {
        parcelasCaucaoRef.current = parcelas;
    }, []);

    // Lançamentos avulsos (opções avançadas). null = seção não tocada → backend não reconcilia.
    const lancamentosLocacaoRef = useRef<LancamentoAvulso[] | null>(null);
    const handleLancamentosLocacaoChange = useCallback((lancamentos: LancamentoAvulso[]) => {
        lancamentosLocacaoRef.current = lancamentos;
    }, []);

    // Reseta o estado de parcelamento da caução sempre que o modal de locação é aberto.
    useEffect(() => {
        if (exibirFormModal) {
            // Semeado com o valor persistido: este estado só era alimentado ao DIGITAR no campo, então
            // ao abrir uma locação existente ele nascia 0 e tudo que depende de "tem caução" ficava
            // escondido (parcelamento, cobrança no Asaas, forma de pagamento) até alguém tocar no campo.
            setValorCaucaoState(Number(locacaoSelecionado?.valorCaucao) || 0);
            setCaucaoParcelada(false);
            parcelasCaucaoRef.current = [];
            lancamentosLocacaoRef.current = null;
            const tipoCom = Number(locacaoSelecionado?.comissaoFilialTipoCalculo) || 0;
            setDefinirComissaoFilial(tipoCom !== 0);
            setComissaoFilialTipo(tipoCom);

            // O checkbox da caução é campo de UI (prefixo _), então seu estado marcado vem do form,
            // não do React. Sem semear aqui ele nasceria DESMARCADO enquanto a lógica já considerava
            // a caução como "vai para o Asaas" — a tela diria uma coisa e o salvamento faria outra.
            const caucaoNoAsaasInicial = locacaoSelecionado?.cobrarCaucaoNoAsaas ?? (locacaoSelecionado?.integrarAoAsaas !== false);
            const tipoCaucaoInicial = locacaoSelecionado?.caucaoTipoDePagamento;
            setEntidadeParaAtualizarLocacao((prev: any) => ({
                ...prev,
                ...(tipoCom !== 0 ? { _definirComissaoFilial: true } : {}),
                _cobrarCaucaoNoAsaasCheck: caucaoNoAsaasInicial,
                caucaoTipoDePagamento: tipoCaucaoInicial ?? '',
            }));
            setForcarAtualizacaoDeEntidadeLocacao(true);
        }
        // Dependência SÓ em exibirFormModal, de propósito. `locacaoSelecionado` também é escrito pela
        // grade atrás do modal (handleSelecionarEntidade), então incluí-lo faria este efeito rodar no
        // meio do preenchimento e zerar valorCaucaoState/caucaoParcelada — a seção de caução sumia da
        // tela depois de o operador já ter digitado o valor. Ler o valor atual aqui é seguro: quem abre
        // o modal chama setLocacaoSelecionado antes de setExibirFormModal, e o React agrupa os dois.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [exibirFormModal]);

    // Carrega as filiais com a comissão padrão, para sugerir na locação.
    useEffect(() => {
        if (!empresaTemFiliais) return;
        api.get(`/Filial/PorEmpresa/${obterIdTenent(token)}`)
            .then(r => setFiliaisComissao(Array.isArray(r.data) ? r.data : []))
            .catch(() => setFiliaisComissao([]));
    }, [empresaTemFiliais, token]);
    const [exibirModalConciliar, setExibirModalConciliar] = useState(false);
    const [locacaoConciliacao, setLocacaoConciliacao] = useState<Locacao | null>(null);
    const [exibirModalDocumentos, setExibirModalDocumentos] = useState(false);
    const [locacaoDocumentos, setLocacaoDocumentos] = useState<Locacao | null>(null);

    // Modal de escolha "Substituir contrato vs Adicionar como novo documento"
    // Mantemos só o flag de exibição + id do modelo. O state do form (modo, nome, descricao)
    // vive dentro do componente filho ModalEscolhaGerarContrato — assim o re-render por keystroke
    // fica isolado e não derruba a árvore inteira do LocacaoListagem.
    const [exibirEscolhaContrato, setExibirEscolhaContrato] = useState(false);
    const [escolhaContratoModeloId, setEscolhaContratoModeloId] = useState<string | null>(null);
    // Ref persiste a escolha do usuário para o fluxo de variáveis manuais (que ainda usa onSave do ModalForm)
    const escolhaGerarContratoRef = useRef<{ adicionarComoNovo: boolean; nome: string; descricao: string; naoEnviarAssinatura: boolean }>({
        adicionarComoNovo: false,
        nome: '',
        descricao: '',
        naoEnviarAssinatura: false,
    });

    // Modal de variáveis manuais durante salvamento da locação:
    // quando o usuário escolhe um modelo de contrato no form e o template tem
    // {observacao}/{negociacao}, abrimos o mesmo modal de variáveis pendentes ANTES
    // de submeter — assim o contrato sai já preenchido na primeira geração.
    //
    // Bifurcação do onSave do modal: o ref abaixo indica qual cenário acionou o modal.
    const cenarioVariaveisManuaisRef = useRef<'gerar-contrato' | 'salvar-locacao'>('gerar-contrato');
    // Quando o cenário é "salvar-locacao", guardamos a entidade do form em uma ref para
    // re-chamar onSave após o usuário preencher as variáveis.
    const entidadeLocacaoPendenteRef = useRef<any>(null);
    // E os valores manuais coletados ficam aqui — lidos no segundo passe do onSave.
    const valoresManuaisContratoRef = useRef<Record<string, string> | null>(null);

    const [rowCount, setRowCount] = useState(0);
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 50,
    });

    const [dataInicio, setDataInicio] = useState<Date | null>(null);
    const [dataFim, setDataFim] = useState<Date | null>(null);
    const [idVeiculoEscolhido, setIdVeiculoEscolhido] = useState<string>("");
    const [idLocatarioEscolhido, setIdLocatarioEscolhido] = useState<string>("");
    const [statusFiltro, setStatusFiltro] = useState<string>("");
    const [periodicidadeFiltro, setPeriodicidadeFiltro] = useState<string>("");
    const [filialFiltro, setFilialFiltro] = useState<string>("");
    const [veiculosFormatados, setVeiculosFormatados] = useState<FiltroDropdownOpcao[]>([]);

    const locatariosFormatados = locatariosOptions.map(op => ({
        label: op.label,
        value: String(op.valor)
    }));

    useEffect(() => {
        const fetchVeiculos = async () => {
            const response = await api.get(`/VeiculoPorEmpresa/${obterIdTenent(token)}`);
            const formatados = response.data.map((veiculo: any) => ({
                value: veiculo.id,
                label: labelComFilial(`${veiculo.placa}:  ${veiculo.marca} ${veiculo.modelo} ${veiculo.ano}`, veiculo.idFilial),
            }));

            setVeiculosFormatados(formatados);
        }

        fetchVeiculos();
    }, [])

    useEffect(() => {
        api.get(`/bancoPorEmpresa/${obterIdTenent(token)}?apenasAtivos=true`)
            .then(r => setBancosOpcoes(
                r.data.map((b: Banco) => ({ label: b.apelido, valor: b.id }))
            ))
            .catch(() => setBancosOpcoes([]));
    }, [token]);

    useEffect(() => {
        api.get(`/UsuarioPorEmpresa/${obterIdTenent(token)}`)
            .then(r => setUsuariosEmpresa(r.data))
            .catch(() => setUsuariosEmpresa([]));
    }, [token]);

    const fetchLocacoes = useCallback(async (page: number, pageSize: number) => {
        if (!temPermissao) {
            setCarregando(false);
            return;
        }

        setCarregando(true);
        try {
            const pageToSend = page + 1;
            const idEmpresa = obterIdTenent(token);

            const params = new URLSearchParams();
            params.append('page', String(pageToSend));
            params.append('pageSize', String(pageSize));
            params.append('idEmpresa', idEmpresa);

            if (idVeiculoEscolhido) params.append('idVeiculo', idVeiculoEscolhido);
            if (idLocatarioEscolhido) params.append('idLocatario', idLocatarioEscolhido);
            if (dataInicio) params.append('dataInicial', dataInicio.toISOString());
            if (dataFim) params.append('dataFinal', dataFim.toISOString());
            if (statusFiltro) params.append('status', statusFiltro);
            if (periodicidadeFiltro) params.append('periodicidade', periodicidadeFiltro);
            if (filialFiltro) params.append('idFilial', filialFiltro);

            const response = await api.get(`/locacao/filtrar?${params.toString()}`);

            if (response.data.items) {
                setLocacoes(response.data.items);
                setRowCount(response.data.totalCount);
            } else {
                setLocacoes(Array.isArray(response.data) ? response.data : [response.data]);
                setRowCount(response.data.length || 0);
            }
            setRealizarConsulta(false);
        } catch (error: any) {
            tratarErro(error);
        } finally {
            setCarregando(false);
        }
    }, [idVeiculoEscolhido, idLocatarioEscolhido, dataInicio, dataFim, statusFiltro, periodicidadeFiltro, filialFiltro, temPermissao, token]);

    useEffect(() => {
        fetchLocacoes(paginationModel.page, paginationModel.pageSize);
    }, [realizarConsulta, paginationModel, fetchLocacoes]);

    const handleBuscar = () => {
        setPaginationModel(prev => ({ ...prev, page: 0 }));
        setRealizarConsulta(true);
    }

    const configFiltros: ConfiguracaoFiltros = {
        carregando: carregando,
        aoBuscar: handleBuscar,
        datas: {
            labelInicio: "De",
            labelFim: "Até",
            dataInicio: dataInicio,
            dataFim: dataFim,
            onChangeDataInicio: setDataInicio,
            onChangeDataFim: setDataFim
        },
        dropdowns: [
            {
                key: 'veiculo',
                label: 'Veículo',
                placeholder: 'Selecione um veículo',
                multiSelect: false,
                opcoes: veiculosFormatados,
                value: idVeiculoEscolhido,
                onChange: (val) => setIdVeiculoEscolhido(val)
            },
            {
                key: 'Locatário',
                label: 'Locatário',
                placeholder: 'Selecione um Locatário',
                multiSelect: false,
                opcoes: locatariosFormatados,
                value: idLocatarioEscolhido,
                onChange: (val) => setIdLocatarioEscolhido(val)
            },
            {
                key: 'status',
                label: 'Status',
                placeholder: 'Todos',
                multiSelect: false,
                opcoes: [
                    { label: 'Todos', value: '' },
                    { label: 'Ativa', value: String(StatusLocacao.Ativa) },
                    { label: 'Inativa', value: String(StatusLocacao.Inativa) },
                    { label: 'Encerrada', value: String(StatusLocacao.Encerrada) },
                ],
                value: statusFiltro,
                onChange: (val) => setStatusFiltro(val)
            },
            {
                key: 'periodicidade',
                label: 'Recorrência',
                placeholder: 'Todas',
                multiSelect: false,
                opcoes: [
                    { label: 'Todas', value: '' },
                    { label: 'Diário', value: String(TipoPeriodicidadePagamento.Diario) },
                    { label: 'Semanal', value: String(TipoPeriodicidadePagamento.Semanal) },
                    { label: 'Quinzenal', value: String(TipoPeriodicidadePagamento.Quinzenal) },
                    { label: 'Mensal', value: String(TipoPeriodicidadePagamento.Mensal) },
                ],
                value: periodicidadeFiltro,
                onChange: (val) => setPeriodicidadeFiltro(val)
            },
            ...(empresaTemFiliais ? [{
                key: 'filial',
                label: 'Unidade',
                placeholder: 'Todas',
                multiSelect: false,
                opcoes: [
                    { label: 'Todas', value: '' },
                    ...filiaisOptions.map(f => ({ label: f.label, value: f.valor })),
                ],
                value: filialFiltro,
                onChange: (val: any) => setFilialFiltro(val)
            }] : []),
        ]
    };

    useEffect(() => {
        if (linkContratoPreview) {
            setExibirVisualizadorContrato(true);
        }
    }, [linkContratoPreview]);

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const criar = searchParams.get('criar');
        if (criar == "true") {
            handleCadastrar();
        }
    }, [location.search])

    const buscarMarcas = useCallback(async (tpVeiculo: TipoVeiculo) => {
        if (!tpVeiculo) return;

        setCarregandoSelect(true);
        try {
            const marcasData = await fipeService.getMarcas(tpVeiculo);
            setMarcas(marcasData);
        } catch (error) {
            tratarErro(error as AxiosError<ApiError>);
        } finally {
            setCarregandoSelect(false);
        }
    }, [fipeService]);

    const buscarModelosPorMarca = useCallback(async (marcaNome: string) => {
        if (!marcaNome || !tipoVeiculo) return;

        try {
            const marca = marcas.find(m => m.nome.toLowerCase().trim() === marcaNome.toLowerCase().trim());
            if (!marca) return;

            setCarregandoSelect(true);
            const modelosData = await fipeService.getModelos(tipoVeiculo, marca.codigo);
            setModelos(modelosData);
        } catch (error) {
            tratarErro(error as AxiosError<ApiError>);
        } finally {
            setCarregandoSelect(false);
        }
    }, [tipoVeiculo, marcas, fipeService]);

    const mapearTipoVeiculoPlaca = (tipo: string | undefined): TipoVeiculo => {
        if (!tipo) return TipoVeiculo.tpCarro;
        const t = tipo.toLowerCase();
        if (t.includes('moto') || t.includes('ciclomotor') || t.includes('triciclo')) return TipoVeiculo.tpMoto;
        if (t.includes('caminh') || t.includes('reboque') || t.includes('semi-reboque')) return TipoVeiculo.tpCaminhao;
        return TipoVeiculo.tpCarro;
    };

    const mapearCorVeiculoPlaca = (cor: string | undefined): string | undefined => {
        if (!cor) return undefined;
        const mapa: Record<string, string> = {
            'PRATA': 'Prata', 'PRETO': 'Preto', 'PRETA': 'Preto',
            'BRANCO': 'Branco', 'BRANCA': 'Branco', 'CINZA': 'Cinza',
            'VERMELHO': 'Vermelho', 'VERMELHA': 'Vermelho', 'AZUL': 'Azul',
            'VERDE': 'Verde', 'AMARELO': 'Amarelo', 'AMARELA': 'Amarelo',
            'MARROM': 'Marrom', 'BEGE': 'Bege', 'LARANJA': 'Laranja',
            'DOURADO': 'Dourado', 'DOURADA': 'Dourado', 'ROXO': 'Roxo', 'ROXA': 'Roxo', 'ROSA': 'Rosa',
        };
        return mapa[cor.toUpperCase().trim()] || undefined;
    };

    const buscarDadosPorPlaca = useCallback(async (placa: string) => {
        setConsultandoPlaca(true);
        setCarregandoSelect(true);
        try {
            const resultado = await consultarPorPlaca(placa);
            if (resultado.sucesso && resultado.marca) {
                const tp = mapearTipoVeiculoPlaca(resultado.tipoVeiculo);
                setTipoVeiculo(tp);

                let marcasData: FipeMarca[] = [];
                try {
                    marcasData = await fipeService.getMarcas(tp);
                    setMarcas(marcasData);
                } catch { }

                const updateData: any = { tipoVeiculo: tp };

                const marcaApi = resultado.marca.toLowerCase().trim();
                const marcaMatch = marcasData.find(m => {
                    const fipe = m.nome.toLowerCase().trim();
                    return fipe === marcaApi || marcaApi.includes(fipe) || fipe.includes(marcaApi);
                });

                if (marcaMatch) {
                    updateData.marca = marcaMatch.nome;
                    try {
                        const modelosData = await fipeService.getModelos(tp, marcaMatch.codigo);
                        setModelos(modelosData);
                        if (resultado.modelo) {
                            const modeloApi = resultado.modelo.toLowerCase().trim();
                            const modeloMatch = modelosData.find(m => {
                                const fipe = m.nome.toLowerCase().trim();
                                return fipe === modeloApi || modeloApi.includes(fipe) || fipe.includes(modeloApi);
                            });
                            updateData.modelo = modeloMatch ? modeloMatch.nome : resultado.modelo;
                        }
                    } catch {
                        if (resultado.modelo) updateData.modelo = resultado.modelo;
                    }
                } else {
                    updateData.marca = resultado.marca;
                    if (resultado.modelo) updateData.modelo = resultado.modelo;
                }

                const anoTexto = resultado.anoModelo || resultado.ano;
                if (anoTexto) updateData.ano = anoTexto;
                const corMapeada = mapearCorVeiculoPlaca(resultado.cor);
                if (corMapeada) updateData.cor = corMapeada;
                if (resultado.chassi) updateData.chassi = resultado.chassi;

                setEntidadeParaAtualizarLocacao(updateData);
                setForcarAtualizacaoDeEntidadeLocacao(true);
            }
        } catch {
            toast.info('Placa não encontrada na base de dados.');
        } finally {
            setCarregandoSelect(false);
            setConsultandoPlaca(false);
        }
    }, [fipeService]);

    useEffect(() => {
        const fetchConfiguracaoEmpresa = async () => {
            await api.get('ConfiguracaoFilial/ResolvidaAtual').then((res) => {
                const config = res.data;
                if (config.asaasConfigurado) {
                    setIntegradoAsaas(true);
                } else {
                    setIntegradoAsaas(false);
                }

                if (config.autentiqueConfigurado) {
                    setIntegradoAutentique(true);
                } else {
                    setIntegradoAutentique(false);
                }
            }).catch((error) => {
                tratarErro(error);
            })
        }

        fetchConfiguracaoEmpresa();
    }, [])

    const statusFilterOperators: GridFilterOperator[] = useMemo(() => [
        {
            label: 'contém',
            value: 'contains',
            getApplyFilterFn: (filterItem) => {
                if (!filterItem.value) {
                    return null;
                }
                const filterValue = filterItem.value.toLowerCase();
                return ({ value }) => {
                    const statusText = converterStatusLocacaoParaTexto(value);
                    return statusText ? statusText.toLowerCase().includes(filterValue) : false;
                };
            },
            InputComponent: (props) => (
                <TextField
                    variant="standard"
                    value={props.item.value || ''}
                    onChange={(event) => props.applyValue({ ...props.item, value: event.target.value })}
                    placeholder="Digite para buscar"
                    fullWidth
                    style={{ marginTop: '16px' }}
                />
            ),
        },
        {
            label: 'é igual a',
            value: 'equals',
            getApplyFilterFn: (filterItem) => {
                if (!filterItem.value) {
                    return null;
                }
                const filterValue = filterItem.value.toLowerCase();
                return ({ value }) => {
                    const statusText = converterStatusLocacaoParaTexto(value);
                    return statusText ? statusText.toLowerCase() === filterValue : false;
                };
            },
            InputComponent: (props) => (
                <TextField
                    variant="standard"
                    value={props.item.value || ''}
                    onChange={(event) => props.applyValue({ ...props.item, value: event.target.value })}
                    placeholder="Digite para buscar"
                    fullWidth
                    style={{ marginTop: '16px' }}
                />
            ),
        },
    ], []);

    const colunas = useMemo(() => [
        {
            field: 'locacao',
            headerName: 'Locação',
            flex: 2,
            sortable: false,
            filterable: false,
            renderCell: (params: any) => {
                const { locatario, veiculo, qtdPagamentosEmAtraso, valorTotalEmAtraso } = params.row;

                const getVehicleIcon = () => {
                    switch (Number(veiculo.tipoVeiculo)) {
                        case 1: return <FaCarSide size={16} />;
                        case 2: return <FaMotorcycle size={16} />;
                        case 3: return <FiTruck size={16} />;
                        default: return <FaCarSide size={16} />;
                    }
                };

                const veiculoLabel = `${veiculo.placa}: ${veiculo.marca} ${veiculo.modelo}`;

                const inadimplente = qtdPagamentosEmAtraso > 0;
                const cnhVencida = locatario.vencimentoHabilitacao && new Date(locatario.vencimentoHabilitacao) < new Date();
                const iconColor = inadimplente ? '#d32f2f' : cnhVencida ? '#ed6c02' : undefined;

                const tooltipLines: string[] = [];
                if (inadimplente) {
                    tooltipLines.push(`${qtdPagamentosEmAtraso} pagamento(s) em atraso - ${formatarParaReais(valorTotalEmAtraso)}`);
                }
                if (cnhVencida) {
                    tooltipLines.push(`CNH vencida em ${formatarData(locatario.vencimentoHabilitacao)}`);
                }
                const tooltipText = tooltipLines.join(' | ');

                const userIcon = (
                    <FiUser size={16} style={iconColor ? { color: iconColor } : undefined} />
                );

                return (
                    <Box display="flex" flexDirection="column" py={0.5}>
                        <Box display="flex" alignItems="center" gap={1}>
                            {tooltipText ? (
                                <Tooltip title={tooltipText} arrow>
                                    <span style={{ display: 'flex', alignItems: 'center' }}>{userIcon}</span>
                                </Tooltip>
                            ) : userIcon}
                            <Typography variant="body2">{locatario.nome}</Typography>
                        </Box>
                        <Box display="flex" alignItems="center" gap={1} mt={0.5}>
                            {getVehicleIcon()}
                            <Typography variant="body2">{veiculoLabel}</Typography>
                        </Box>
                    </Box>
                );
            }
        },
        {
            field: 'dataInicio', headerName: 'Data de Início', flex: 1, valueGetter: (params: any) => {
                return new Date(params.value);
            },
            // Com hora quando a retirada foi registrada com hora; locações antigas mostram só o dia.
            renderCell: (params: any) => formatarDataHora(params.value),
        },
        {
            field: 'tempoRestante',
            headerName: 'Prazo',
            flex: 1.2,
            minWidth: 160,
            sortComparator: (a: number, b: number) => a - b,
            valueGetter: (params: any) => {
                const row = params.row;
                const integradoAsaas = !!row.asaasSubscriptionId || (row.periodicidadePagamento === TipoPeriodicidadePagamento.Diario && row.dataUltimoPagamentoPrevisto && !row.tempoContratoEmMeses);
                let dataFim: Date | null = null;

                if (integradoAsaas) {
                    // Asaas: usar DataTermino se definida, senão indeterminado
                    if (row.dataTermino) {
                        dataFim = new Date(row.dataTermino);
                    } else {
                        return 'INDETERMINADO';
                    }
                } else {
                    // Sem Asaas: o maior entre o último pagamento em aberto e o fim do prazo contratado
                    // (início da locação + prazo). Usar só o vencimento mostrava "Encerra hoje" para um
                    // contrato de vários dias; somar o prazo ao vencimento (DL-203) empurrava o fim para
                    // depois do contrato quando o pagamento único vence no último dia.
                    const ultimoPagamento = row.dataUltimoPagamentoPrevisto ? new Date(row.dataUltimoPagamentoPrevisto) : null;
                    // Só locação ativa segue o prazo contratado; encerrada ou inativa fica no último vencimento.
                    const fimDoPrazo = row.status === StatusLocacao.Ativa ? calcularFimDoPrazoContratado(row) : null;
                    const hojeRef = new Date();
                    hojeRef.setHours(0, 0, 0, 0);
                    if (ultimoPagamento) {
                        dataFim = fimDoPrazo && fimDoPrazo > ultimoPagamento ? fimDoPrazo : ultimoPagamento;
                    } else if (row.status === StatusLocacao.Ativa && fimDoPrazo && fimDoPrazo >= hojeRef) {
                        // Pagamento único já quitado: o contrato segue até o fim do prazo.
                        dataFim = fimDoPrazo;
                    } else if (row.status === StatusLocacao.Ativa) {
                        // Ativa mas sem pagamentos pendentes: sinalizar ao usuário
                        return 'SEM_PAGAMENTOS';
                    } else if (row.dataTermino) {
                        dataFim = new Date(row.dataTermino);
                    }
                }

                if (!dataFim || isNaN(dataFim.getTime())) return Number.MAX_SAFE_INTEGER;
                const hoje = new Date();
                hoje.setHours(0, 0, 0, 0);
                dataFim.setHours(0, 0, 0, 0);
                return Math.ceil((dataFim.getTime() - hoje.getTime()) / (1000 * 60 * 60 * 24));
            },
            renderCell: (params: any) => {
                const diffDias = params.value;
                if (diffDias === Number.MAX_SAFE_INTEGER) return '';

                if (diffDias === 'INDETERMINADO') {
                    return (
                        <span style={{
                            backgroundColor: '#2196F3',
                            color: 'white',
                            padding: '5px 10px',
                            borderRadius: '5px',
                            fontWeight: 'bold',
                            textAlign: 'center',
                            fontSize: '0.8rem',
                        }}>
                            Indeterminado
                        </span>
                    );
                }

                if (diffDias === 'SEM_PAGAMENTOS') {
                    return (
                        <Tooltip title="Todos os pagamentos foram quitados. Gere novos pagamentos ou encerre a locação.">
                            <span style={{
                                backgroundColor: '#FF9800',
                                color: 'white',
                                padding: '5px 10px',
                                borderRadius: '5px',
                                fontWeight: 'bold',
                                textAlign: 'center',
                                fontSize: '0.8rem',
                                cursor: 'help',
                            }}>
                                Sem previsão
                            </span>
                        </Tooltip>
                    );
                }

                let label = '';
                let backgroundColor = '#4CAF50';
                const status = params.row.status as StatusLocacao;
                const estaAtiva = status === StatusLocacao.Ativa;

                if (diffDias < 0) {
                    const { meses: m, dias } = separarEmMesesEDias(diffDias);
                    if (estaAtiva) {
                        label = m > 0
                            ? `Vencido há ${m} ${m === 1 ? 'mês' : 'meses'}${dias > 0 ? ` e ${dias}d` : ''}`
                            : `Vencido há ${dias}d`;
                        backgroundColor = '#f44336';
                    } else {
                        label = m > 0
                            ? `Encerrou há ${m} ${m === 1 ? 'mês' : 'meses'}${dias > 0 ? ` e ${dias}d` : ''}`
                            : `Encerrou há ${dias}d`;
                        backgroundColor = '#9E9E9E';
                    }
                } else if (diffDias === 0) {
                    label = estaAtiva ? 'Encerra hoje' : 'Encerrou hoje';
                    backgroundColor = estaAtiva ? '#FF9800' : '#9E9E9E';
                } else {
                    const { meses: m, dias } = separarEmMesesEDias(diffDias);
                    label = m > 0
                        ? `${m} ${m === 1 ? 'mês' : 'meses'}${dias > 0 ? ` e ${dias}d` : ''}`
                        : `${dias}d`;
                    backgroundColor = diffDias <= 7 ? '#f44336' : diffDias <= 30 ? '#FF9800' : '#4CAF50';
                }

                return (
                    <span style={{
                        backgroundColor,
                        color: 'white',
                        padding: '4px 8px',
                        borderRadius: '5px',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        fontSize: '0.75rem',
                        whiteSpace: 'nowrap',
                    }}>
                        {label}
                    </span>
                );
            },
        },
        {
            field: 'kmInicial', headerName: 'Km Inicial', flex: 0.5, renderCell(params: any) {
                return params.value
            }
        },
        {
            field: 'periodicidadePagamento', headerName: 'Recorrência', flex: 0.5, renderCell(params: any) {
                const recorrencia = params.value as TipoPeriodicidadePagamento;
                switch (recorrencia) {
                    case TipoPeriodicidadePagamento.Diario:
                        return "Diário";
                    case TipoPeriodicidadePagamento.Quinzenal:
                        return "Quinzenal";
                    case TipoPeriodicidadePagamento.Semanal:
                        return "Semanal";
                    case TipoPeriodicidadePagamento.Mensal:
                        return "Mensal"
                    default:
                        return "Outros";
                }
                return params.value
            }
        },
        {
            field: 'valorAluguel',
            headerName: 'Valor',
            flex: 0.7,
            minWidth: 130,
            renderCell: (params: any) => {
                return (
                    <Box display="flex" alignItems="center" gap={0.5} flexWrap="nowrap" overflow="hidden">
                        <span style={{ whiteSpace: 'nowrap' }}>{formatarParaReais(params.value)}</span>
                        {params.row.asaasSubscriptionId && (
                            <Tooltip title="Integrado ao Asaas" arrow>
                                <img
                                    src={asaasLogo}
                                    alt="Asaas"
                                    style={{ width: 18, height: 18, minWidth: 18, objectFit: "contain", cursor: "pointer" }}
                                />
                            </Tooltip>
                        )}
                    </Box>
                );
            }
        },
        {
            field: 'status',
            headerName: 'Status',
            flex: 0.8,
            valueGetter: (params: any) => params.value,
            filterOperators: statusFilterOperators,
            renderCell: (params: any) => {
                const status = params.value;
                const statusText = converterStatusLocacaoParaTexto(status) ?? 'Indefinido';

                let backgroundColor;
                if (status === StatusLocacao.Ativa) {
                    backgroundColor = '#4CAF50';
                } else if (status === StatusLocacao.Encerrada) {
                    backgroundColor = '#FFC107';
                } else {
                    backgroundColor = '#f44336';
                }

                const labelStyle: React.CSSProperties = {
                    backgroundColor,
                    color: 'white',
                    padding: '5px 10px',
                    borderRadius: '5px',
                    fontWeight: 'bold',
                    textAlign: 'center' as 'center',
                };

                return (
                    <span style={labelStyle}>
                        {statusText}
                    </span>
                );
            }
        },
        ...(empresaTemFiliais ? [{ field: 'idFilial', headerName: 'Unidade', flex: 1, renderCell: (params: any) => { if (!params.value) return ''; const f = filiaisOptions.find((x: any) => x.valor === params.value); return f?.label || ''; } }] : []),
    ], [statusFilterOperators, empresaTemFiliais, filiaisOptions.length]);

    // Os selects dos modais da locação usam veiculosOptions, que vem de /VeiculoPorEmpresaESemLocacao e
    // não traz o veículo já locado: cada modal fixa as opções no locatário e no veículo da locação.
    const fixarLocatarioEVeiculoDaLocacao = useCallback(() => {
        const veiculoId = locacaoSelecionado.veiculo?.id ?? locacaoSelecionado.idVeiculo;
        const locatarioId = locacaoSelecionado.locatario?.id ?? locacaoSelecionado.idLocatario;
        if (!veiculoId || !locatarioId) return null;

        const veiculoLabel = locacaoSelecionado.veiculo
            ? labelComFilial(`${locacaoSelecionado.veiculo.placa} - ${locacaoSelecionado.veiculo.marca} - ${locacaoSelecionado.veiculo.modelo} - ${locacaoSelecionado.veiculo.ano}`, locacaoSelecionado.veiculo.idFilial)
            : 'Veículo da locação';

        const locatarioLabel = locacaoSelecionado.locatario
            ? labelComFilial(`${locacaoSelecionado.locatario.documento} - ${locacaoSelecionado.locatario.nome}`, locacaoSelecionado.locatario.idFilial)
            : 'Locatário da locação';

        setVeiculosOptions([{ label: veiculoLabel, valor: veiculoId }]);
        setLocatariosOptions([{ label: locatarioLabel, valor: locatarioId }]);
        return { veiculoId, locatarioId };
    }, [locacaoSelecionado]);

    const atualizarCamposPagamentos = useCallback(() => {
        const ids = fixarLocatarioEVeiculoDaLocacao();
        if (!ids) return;
        const { veiculoId, locatarioId } = ids;

        setEntidadeParaAtualizarPagamentos({
            tipoPeriodicidadeTempoContrato: locacaoSelecionado.tipoPeriodicidadeTempoContrato,
            tempoContratoEmMeses: locacaoSelecionado.tempoContratoEmMeses,
            idLocatario: locatarioId,
            idVeiculo: veiculoId,
        });

        setForcarAtualizacaoDeEntidadeNoModalPagamentos(true);
    }, [locacaoSelecionado, fixarLocatarioEVeiculoDaLocacao]);

    const atualizarCamposNovaPrevisao = useCallback(() => {
        const veiculoId = locacaoSelecionado.veiculo?.id ?? locacaoSelecionado.idVeiculo;
        const locatarioId = locacaoSelecionado.locatario?.id ?? locacaoSelecionado.idLocatario;
        if (!veiculoId || !locatarioId) return;

        const veiculoLabel = locacaoSelecionado.veiculo
            ? labelComFilial(`${locacaoSelecionado.veiculo.placa} - ${locacaoSelecionado.veiculo.marca} - ${locacaoSelecionado.veiculo.modelo} - ${locacaoSelecionado.veiculo.ano}`, locacaoSelecionado.veiculo.idFilial)
            : 'Veículo da locação';

        const locatarioLabel = locacaoSelecionado.locatario
            ? labelComFilial(`${locacaoSelecionado.locatario.documento} - ${locacaoSelecionado.locatario.nome}`, locacaoSelecionado.locatario.idFilial)
            : 'Locatário da locação';

        setVeiculosOptions([{ label: veiculoLabel, valor: veiculoId }]);
        setLocatariosOptions([{ label: locatarioLabel, valor: locatarioId }]);

        setEntidadeParaAtualizarNovaPrevisao({
            idLocatario: locatarioId,
            idVeiculo: veiculoId,
            ...(dataSugeridaNovaPrevisao.current ? { novaDataEncerramento: dataSugeridaNovaPrevisao.current } : {}),
        });
        dataSugeridaNovaPrevisao.current = null;

        setForcarAtualizacaoNovaPrevisao(true);
    }, [locacaoSelecionado]);

    const atualizarCamposGerarContrato = useCallback(() => {
        if (!locacaoSelecionado.veiculo || !locacaoSelecionado.locatario) return;

        setVeiculosOptions([{
            label: labelComFilial(`${locacaoSelecionado.veiculo.placa} - ${locacaoSelecionado.veiculo.marca} - ${locacaoSelecionado.veiculo.modelo} - ${locacaoSelecionado.veiculo.ano}`, locacaoSelecionado.veiculo.idFilial),
            valor: locacaoSelecionado.veiculo.id
        }]);

        setLocatariosOptions([{
            label: labelComFilial(`${locacaoSelecionado.locatario.documento} - ${locacaoSelecionado.locatario.nome}`, locacaoSelecionado.locatario.idFilial),
            valor: locacaoSelecionado.locatario.id
        }]);

        setEntidadeParaAtualizarGerarContrato({
            idLocatario: locacaoSelecionado.locatario.id,
            idVeiculo: locacaoSelecionado.veiculo.id,
        });

        setForcarAtualizacaoDeEntidadeNoModalGerarContrato(true);
    }, [locacaoSelecionado]);

    const atualizarCamposEncerramento = useCallback(() => {
        // Sugere o momento atual (hora local), que é quando o carro costuma ser devolvido; o getUTC*
        // anterior sugeria o dia seguinte depois das 21h no Brasil.
        const agora = new Date();
        const dois = (n: number) => String(n).padStart(2, '0');
        setEntidadeParaAtualizarEncerramento({
            dataEncerramento: `${agora.getFullYear()}-${dois(agora.getMonth() + 1)}-${dois(agora.getDate())}T${dois(agora.getHours())}:${dois(agora.getMinutes())}`,
            kmInicial: locacaoSelecionado.kmInicial,
            observacao: locacaoSelecionado.observacao || ""
        });

        setForcarAtualizacaoDeEntidadeNoModalEncerramento(true);
    }, [locacaoSelecionado]);


    const atualizarCamposAlterarData = useCallback(() => {
        const hoje = new Date();
        const dataHoje = `${hoje.getFullYear()}-${String(hoje.getMonth() + 1).padStart(2, '0')}-${String(hoje.getDate()).padStart(2, '0')}`;

        const dataPgto = locacaoSelecionado.dataPagamento ? new Date(locacaoSelecionado.dataPagamento) : null;
        const dataPgto2 = locacaoSelecionado.dataSegundoPagamentoQuinzena ? new Date(locacaoSelecionado.dataSegundoPagamentoQuinzena) : null;

        novoDiaRef.current = null;
        // Sem isto o Veículo aparecia vazio, a menos que outro modal da locação tivesse sido aberto antes (DL-169).
        const ids = fixarLocatarioEVeiculoDaLocacao();
        setEntidadeParaAtualizarAlterarData({
            idLocatario: ids?.locatarioId,
            idVeiculo: ids?.veiculoId,
            diaSemanaAtual: locacaoSelecionado.diaPagamento || 0,
            diaMesAtual: dataPgto ? dataPgto.getDate() : 1,
            diaMes2Atual: dataPgto2 ? dataPgto2.getDate() : 1,
            diaMes: dataPgto ? dataPgto.getDate() : 1,
            diaMes2: dataPgto2 ? dataPgto2.getDate() : 1,
            dataPagamento: dataHoje,
        });
        setForcarAtualizacaoDeEntidadeAlterarData(true);
    }, [locacaoSelecionado, fixarLocatarioEVeiculoDaLocacao]);

    const camposConfirmarDataEncerramento: Campo[] = useMemo(() => [
        {
            label: 'Data e hora da devolução', nome: 'dataEncerramento', required: true, tipo: 'datetime-local',
            largura: 4, coluna: 1, linha: 1, visible: true,
            ajudinha: { texto: "Dia e hora em que o veículo foi devolvido. A hora define de quem é uma multa ou uma ocorrência nesse dia, quando o veículo sai com outro locatário logo depois. Os pagamentos agendados após essa data serão excluídos do sistema; os demais permanecem registrados.", autoCloseTime: 3 },
        },
        {
            label: 'Quilometragem Inicial', nome: 'kmInicial', required: false, tipo: 'number', largura: 4, coluna: 2, linha: 1,
            apenasLeitura: true,
            visible: true,
        },
        {
            label: 'Quilometragem Final', nome: 'kmFinal', required: true, tipo: 'number', largura: 4, coluna: 3, linha: 1,
            visible: true, ajudinha: {
                texto: "Este campo corresponde a quilometragem final do veículo no momento em que a locação foi encerrada.",
                autoCloseTime: 3
            },
            onCampoDigitar: (valor: any) => {
                const kmFinal = Number(valor);
                const kmInicial = Number(locacaoSelecionado?.kmInicial || 0);
                if (limiteKmEncerramento > 0 && kmFinal > kmInicial) {
                    const kmRodados = kmFinal - kmInicial;
                    if (kmRodados > limiteKmEncerramento) {
                        const excedente = kmRodados - limiteKmEncerramento;
                        setKmExcedenteInfo(`Limite excedido! Rodados: ${kmRodados.toLocaleString('pt-BR')} km | Limite: ${limiteKmEncerramento.toLocaleString('pt-BR')} km | Excedente: ${excedente.toLocaleString('pt-BR')} km`);
                    } else {
                        setKmExcedenteInfo(null);
                    }
                } else {
                    setKmExcedenteInfo(null);
                }
            },
        },
        {
            label: '', nome: '_alertaKmExcedente', tipo: 'custom', required: false,
            largura: 12, coluna: 1, linha: 2,
            visible: () => !!kmExcedenteInfo,
            component: () => (
                <div style={{
                    padding: '0.7rem 1rem', borderRadius: '8px', background: '#fff3cd',
                    border: '1px solid #ffc107', display: 'flex', alignItems: 'center', gap: '0.5rem',
                    fontSize: '0.85rem', fontWeight: 600, color: '#856404',
                }}>
                    ⚠️ {kmExcedenteInfo}
                </div>
            ),
        },
        {
            label: '', nome: '_btnRelatorio', tipo: 'custom', required: false, largura: 12, coluna: 1, linha: 3, visible: true,
            component: () => (
                <div style={{
                    padding: '0.7rem 1rem', borderRadius: '8px', background: '#e7f5ff',
                    borderLeft: '4px solid #4dabf7', display: 'flex', alignItems: 'center',
                    justifyContent: 'space-between', gap: '1rem',
                }}>
                    <div style={{ color: '#1864ab', fontSize: '0.82rem' }}>
                        <strong>Gerar Relatório Completo?</strong>
                        <br />
                        <span style={{ fontSize: '0.75rem' }}>Emita um laudo com todos os dados desta locação antes de encerrar.</span>
                    </div>
                    <button type="button" onClick={() => {
                        setExibirFormModalEncerramento(false);
                        setLocacaoSelecionadaParaRelatorio(locacaoSelecionado);
                        setShowRelatorioLocacao(true);
                    }} style={{
                        backgroundColor: '#1E3A5F', color: 'white', border: 'none',
                        borderRadius: '6px', padding: '0.5rem 1rem', cursor: 'pointer',
                        fontWeight: 600, fontSize: '0.8rem', whiteSpace: 'nowrap',
                    }}>
                        Gerar PDF
                    </button>
                </div>
            ),
        },
        {
            label: 'Observação', nome: 'observacao', required: false, tipo: 'memo', largura: 12, coluna: 1, linha: 4,
            visible: true, ajudinha: {
                texto: "Adicione aqui uma observação, se desejar, para consultar depois",
                autoCloseTime: 3
            },
        },
        {
            label: 'Vendi este veículo para o locatário: marcar como VENDIDO e tirar da frota (irreversível)', nome: 'vendeuVeiculo', required: false, tipo: 'checkbox', largura: 12, coluna: 1, linha: 5,
            visible: true, ajudinha: {
                texto: "Só para planos com promessa de compra, em que o veículo passa a ser do locatário no fim do contrato. Deixe desmarcado num encerramento comum: o veículo continua na frota, disponível para a próxima locação.",
                autoCloseTime: 3
            },
        },
    ], [locacaoSelecionado, limiteKmEncerramento, kmExcedenteInfo]);

    const camposPagamentos: Campo[] = useMemo(() => [
        { label: 'Informações da Locação', nome: '', required: true, tipo: 'label', largura: 12, coluna: 1, linha: 1, visible: true },
        {
            label: 'Locatário', nome: 'idLocatario', required: true, tipo: 'select', largura: 6, coluna: 1, linha: 2,
            visible: true, opcoes: locatariosOptions, apenasLeitura: true
        },
        {
            label: 'Veículo', nome: 'idVeiculo', required: true, tipo: 'select', largura: 6, coluna: 2, linha: 2,
            visible: true, opcoes: veiculosOptions, apenasLeitura: true,
        },
        { label: 'Informações do Pagamento', nome: '', required: true, tipo: 'label', largura: 12, coluna: 1, linha: 4, visible: true },
        {
            label: 'Deseja prolongar por mais quanto tempo?', nome: 'tempoContratoEmMeses', required: true, tipo: 'selectwithnumber', largura: 8, coluna: 1, linha: 5,
            visible: true, ajudinha: {
                texto: "Este campo representa a duração do contrato, que pode ser expressa em dias, semanas, quinzenas ou meses.",
                autoCloseTime: 3
            }, opcoes: opcoesPrazoMinimo
        },
        {
            label: "Desejo gerar Pagamento único", coluna: 1, largura: 12, linha: 6, visible: () => {
                if (locacaoSelecionado.periodicidadePagamento == TipoPeriodicidadePagamento.Diario) {
                    return true;
                }
                return false;
            },
            nome: 'desejoGerarPagamentoUnico', tipo: 'checkbox', required: false,
            ajudinha: {
                texto: "Utilize esta opção para gerar um único pagamento referente à locação. Mesmo que seja informada uma periodicidade diária, o sistema irá considerar apenas um pagamento.",
            },
            onCampoDigitar: setGeraPagamentoUnico,
        },
        {
            label: 'Data de Pagamento único', nome: 'dataPagamento', required: geraPagamentoUnico, tipo: 'date',
            largura: 4, coluna: 2, linha: 7, visible: () => {
                if (locacaoSelecionado.periodicidadePagamento == TipoPeriodicidadePagamento.Diario) {
                    return true;
                }
                return false;
            },
            ajudinha: { texto: "Este campo indica a data do pagamento único", autoCloseTime: 3 },
            apenasLeitura: !geraPagamentoUnico
        },
    ], [locatariosOptions, veiculosOptions, geraPagamentoUnico]);

    const camposNovaPrevisaoEncerramento: Campo[] = useMemo(() => [
        { label: 'Informações da Locação', nome: '', required: true, tipo: 'label', largura: 12, coluna: 1, linha: 1, visible: true },
        {
            label: 'Locatário', nome: 'idLocatario', required: true, tipo: 'select', largura: 6, coluna: 1, linha: 2,
            visible: true, opcoes: locatariosOptions, apenasLeitura: true
        },
        {
            label: 'Veículo', nome: 'idVeiculo', required: true, tipo: 'select', largura: 6, coluna: 2, linha: 2,
            visible: true, opcoes: veiculosOptions, apenasLeitura: true,
        },
        { label: 'Nova Previsão', nome: '', required: true, tipo: 'label', largura: 12, coluna: 1, linha: 3, visible: true },
        {
            label: 'Nova Previsão de Encerramento', nome: 'novaDataEncerramento', required: true, tipo: 'date', largura: 6, coluna: 1, linha: 4,
            visible: true
        },
    ], [locatariosOptions, veiculosOptions]);

    const camposAlterarValorPagamento: Campo[] = useMemo(() => [
        { label: 'Informações da Locação', nome: '', required: true, tipo: 'label', largura: 12, coluna: 1, linha: 1, visible: true },
        {
            label: 'Locatário', nome: 'idLocatario', required: true, tipo: 'select', largura: 12, coluna: 1, linha: 2,
            visible: true, opcoes: locatariosOptions, apenasLeitura: true
        },
        {
            label: 'Veículo', nome: 'idVeiculo', required: true, tipo: 'select', largura: 12, coluna: 1, linha: 3,
            visible: true, opcoes: veiculosOptions, apenasLeitura: true
        },
        { label: 'Informações do Pagamento', nome: '', required: true, tipo: 'label', largura: 12, coluna: 1, linha: 4, visible: true },
        {
            label: 'A partir da Data', nome: 'dataPagamento', required: true, tipo: 'date', largura: 4, coluna: 1, linha: 7,
            visible: true, ajudinha: {
                texto: "Desta data em diante, as datas previstas dos pagamentos gerados serão alteradas.",
                autoCloseTime: 3
            },
            onCampoDigitar: (e) => setDataAPartir(new Date(e)),
        },
        {
            label: 'Valor Atual', nome: 'valorAluguel', required: true, tipo: 'money', largura: 4, coluna: 2, linha: 7, apenasLeitura: true,
            visible: true,
        },
        {
            label: 'Novo Valor', nome: 'valorAluguelNovo', required: true, tipo: 'money', largura: 4, coluna: 3, linha: 7,
            visible: true,
        },
    ], [locacaoSelecionado, dataAPartir, locatariosOptions, veiculosOptions, geraPagamentoDiferencaDias]);

    const camposVincularAsaas: Campo[] = useMemo(() => [
        {
            label: '', nome: '_infoVincularAsaas', tipo: 'custom', required: false, largura: 12, coluna: 1, linha: 1, visible: true,
            component: () => (
                <div style={{
                    padding: '0.8rem 1rem', borderRadius: '8px', background: '#fff4e6',
                    borderLeft: '5px solid #ffa94d', color: '#8a5a00', fontSize: '0.85rem',
                }}>
                    Esta ação removerá os pagamentos pendentes desta locação. Eles passarão a ser gerenciados pelo Asaas.
                </div>
            ),
        },
        {
            label: '', nome: '_escolhaAssinaturaAsaas', tipo: 'custom', required: false, largura: 12, coluna: 1, linha: 4, visible: true,
            component: () => (
                <EscolhaAssinaturaAsaas
                    compacto
                    classificacao={classificacaoAssinaturas}
                    carregando={carregandoAssinaturasAsaas}
                    valorAluguel={Number(previewVinculacao?.valorAluguel ?? locacaoSelecionado?.valorAluguel) || undefined}
                    cicloAsaas={previewVinculacao?.cicloAsaas}
                    escolha={assinaturaEscolhida}
                    onEscolher={setAssinaturaEscolhida}
                    atualizarFaturas={atualizarFaturasEmAberto}
                    onAtualizarFaturas={setAtualizarFaturasEmAberto}
                    importarPagasAnteriores={importarPagasAnterioresAoInicio}
                    onImportarPagasAnteriores={setImportarPagasAnterioresAoInicio}
                    dataInicio={locacaoSelecionado?.dataInicio}
                />
            ),
        },
        {
            label: 'Desejo definir uma data de encerramento', nome: 'desejoDefinirEncerramentoAsaas', tipo: 'checkbox',
            required: false, largura: 12, coluna: 1, linha: 2, visible: true,
            ajudinha: { texto: "Se desmarcado, o contrato será tratado como indeterminado (sem data de término) no Asaas.", autoCloseTime: 3 },
            onCampoDigitar: (e: any) => setDefinirEncerramentoAsaas(Boolean(e)),
        },
        {
            label: 'Data de encerramento', nome: 'dataEncerramentoAsaas', tipo: 'date',
            // visible lê a ENTIDADE do formulário, não o estado React espelho, que pode ficar defasado
            // um render e deixava o campo exigido depois de desmarcado. A validação só olha o required
            // de campo visível, então é o visible que resolve.
            required: definirEncerramentoAsaas,
            largura: 6, coluna: 1, linha: 3,
            visible: (entidade: any) => !!entidade?.desejoDefinirEncerramentoAsaas,
            ajudinha: { texto: "Sugerida com base na data de início e no prazo do contrato. Você pode alterá-la.", autoCloseTime: 3 },
        },
    ], [definirEncerramentoAsaas, classificacaoAssinaturas, carregandoAssinaturasAsaas, assinaturaEscolhida, atualizarFaturasEmAberto, importarPagasAnterioresAoInicio, locacaoSelecionado, previewVinculacao]);

    const recalcularDiferenca = useCallback((novoDia: number, forcar = false) => {
        if ((!forcar && !geraPagamentoDiferencaDias) || !locacaoSelecionado?.dataPagamento || novoDia == null) return;
        const periodicidade = locacaoSelecionado.periodicidadePagamento;
        const base = dataAPartir || new Date(locacaoSelecionado.dataPagamento);

        let novaData: Date | null = null;
        if (periodicidade === TipoPeriodicidadePagamento.Semanal) {
            const atual = new Date(locacaoSelecionado.dataPagamento);
            const delta = ((novoDia % 7) - (atual.getDay()) + 7) % 7;
            novaData = new Date(atual); novaData.setDate(atual.getDate() + (delta === 0 ? 7 : delta));
        } else {
            const ref = new Date(base);
            const diasNoMes = new Date(ref.getFullYear(), ref.getMonth() + 1, 0).getDate();
            novaData = new Date(ref.getFullYear(), ref.getMonth(), Math.min(novoDia, diasNoMes));
        }

        const msDia = 1000 * 60 * 60 * 24;
        const diferencaDias = Math.max(0, Math.round((novaData.getTime() - new Date(locacaoSelecionado.dataPagamento).getTime()) / msDia));
        const valorDiaria = calcularDiaria(periodicidade, locacaoSelecionado.valorAluguel, base);
        const valorFinal = (diferencaDias === 0) ? '0' : (diferencaDias * valorDiaria).toFixed(2);
        setEntidadeParaAtualizarAlterarData({ valorPagamentoDiferenca: valorFinal });
        setForcarAtualizacaoDeEntidadeAlterarData(true);
    }, [geraPagamentoDiferencaDias, locacaoSelecionado, dataAPartir]);

    const camposAlterarDataPagamento: Campo[] = useMemo(() => {
        const periodicidade = locacaoSelecionado?.periodicidadePagamento;
        const ehSemanal = periodicidade === TipoPeriodicidadePagamento.Semanal;
        const ehMensal = periodicidade === TipoPeriodicidadePagamento.Mensal;
        const ehQuinzenalFixo = periodicidade === TipoPeriodicidadePagamento.Quinzenal && locacaoSelecionado?.dataSegundoPagamentoQuinzena != null;
        const ehQuinzenalFlutuante = periodicidade === TipoPeriodicidadePagamento.Quinzenal && locacaoSelecionado?.dataSegundoPagamentoQuinzena == null;

        const opcoesDiaMes: Opcao[] = Array.from({ length: 31 }, (_, i) => ({ label: String(i + 1), valor: i + 1 }));
        const opcoesDiaSemana: Opcao[] = [
            { label: converterDiaSemanaParaTexto(DiaDaSemana.domingo) || "", valor: DiaDaSemana.domingo },
            { label: converterDiaSemanaParaTexto(DiaDaSemana.segundaFeira) || "", valor: DiaDaSemana.segundaFeira },
            { label: converterDiaSemanaParaTexto(DiaDaSemana.tercaFeira) || "", valor: DiaDaSemana.tercaFeira },
            { label: converterDiaSemanaParaTexto(DiaDaSemana.quartaFeira) || "", valor: DiaDaSemana.quartaFeira },
            { label: converterDiaSemanaParaTexto(DiaDaSemana.quintaFeira) || "", valor: DiaDaSemana.quintaFeira },
            { label: converterDiaSemanaParaTexto(DiaDaSemana.sextaFeira) || "", valor: DiaDaSemana.sextaFeira },
            { label: converterDiaSemanaParaTexto(DiaDaSemana.sabado) || "", valor: DiaDaSemana.sabado },
        ];

        const camposDoDia: Campo[] = [];
        if (ehSemanal) {
            camposDoDia.push(
                { label: 'Atualmente', nome: 'diaSemanaAtual', required: true, tipo: 'select', largura: 4, coluna: 2, linha: 7, visible: true, opcoes: opcoesDiaSemana, apenasLeitura: true },
                { label: 'Novo dia', nome: 'diaSemana', required: true, tipo: 'select', largura: 4, coluna: 3, linha: 7, visible: true, opcoes: opcoesDiaSemana,
                  onCampoDigitar: (e) => { novoDiaRef.current = e; recalcularDiferenca(e); } },
            );
        } else if (ehMensal || ehQuinzenalFlutuante) {
            camposDoDia.push(
                { label: 'Dia do mês atual', nome: 'diaMesAtual', required: true, tipo: 'select', largura: 4, coluna: 2, linha: 7, visible: true, opcoes: opcoesDiaMes, apenasLeitura: true },
                { label: 'Novo dia do mês', nome: 'diaMes', required: true, tipo: 'select', largura: 4, coluna: 3, linha: 7, visible: true, opcoes: opcoesDiaMes,
                  onCampoDigitar: (e) => { novoDiaRef.current = e; recalcularDiferenca(e); } },
            );
        } else if (ehQuinzenalFixo) {
            camposDoDia.push(
                { label: '1º dia do mês', nome: 'diaMes', required: true, tipo: 'select', largura: 4, coluna: 1, linha: 7, visible: true, opcoes: opcoesDiaMes },
                { label: '2º dia do mês', nome: 'diaMes2', required: true, tipo: 'select', largura: 4, coluna: 2, linha: 7, visible: true, opcoes: opcoesDiaMes },
            );
        }

        return [
            { label: 'Informações da Locação', nome: '', required: true, tipo: 'label', largura: 12, coluna: 1, linha: 1, visible: true },
            { label: 'Locatário', nome: 'idLocatario', required: true, tipo: 'select', largura: 12, coluna: 1, linha: 2, visible: true, opcoes: locatariosOptions, apenasLeitura: true },
            { label: 'Veículo', nome: 'idVeiculo', required: true, tipo: 'select', largura: 12, coluna: 1, linha: 3, visible: true, opcoes: veiculosOptions, apenasLeitura: true },
            { label: 'Informações do Pagamento', nome: '', required: true, tipo: 'label', largura: 12, coluna: 1, linha: 4, visible: true },
            {
                label: 'A partir da Data', nome: 'dataPagamento', required: true, tipo: 'date', largura: 4, coluna: 1, linha: 7, visible: true,
                ajudinha: { texto: "A partir desta data, todas as cobranças pendentes terão seu dia de vencimento alterado para o novo dia selecionado.", autoCloseTime: 3 },
                onCampoDigitar: (e) => setDataAPartir(new Date(e)),
            },
            ...camposDoDia,
            {
                label: "Desejo gerar o Pagamento da Diferença de dias", coluna: 1, largura: 12, linha: 8, visible: ehSemanal || ehMensal || ehQuinzenalFlutuante,
                onCampoDigitar: (value: any) => {
                    setGeraPagamentoDiferencaDias(Boolean(value));
                    if (!value) {
                        setEntidadeParaAtualizarAlterarData({ valorPagamentoDiferenca: '0' });
                        setForcarAtualizacaoDeEntidadeAlterarData(true);
                        return;
                    }
                    recalcularDiferenca(novoDiaRef.current!, true);
                },
                nome: 'desejoGerarPagamentoDiferencaDias', tipo: 'checkbox', required: false,
            },
            {
                label: 'Data de Pagmt (Diferença)', nome: 'dataPagamentoDiferenca', required: geraPagamentoDiferencaDias,
                tipo: 'date', largura: 6, coluna: 2, linha: 9, visible: geraPagamentoDiferencaDias,
                ajudinha: { texto: "Este campo indica a data do pagamento único", autoCloseTime: 3 },
                apenasLeitura: !geraPagamentoDiferencaDias,
            },
            {
                label: 'Valor Diferença', nome: 'valorPagamentoDiferenca', required: geraPagamentoDiferencaDias,
                tipo: 'money', largura: 4, coluna: 1, linha: 9, visible: geraPagamentoDiferencaDias,
                apenasLeitura: !geraPagamentoDiferencaDias,
            },
        ];
    }, [locacaoSelecionado, dataAPartir, locatariosOptions, veiculosOptions, geraPagamentoDiferencaDias, recalcularDiferenca]);

    function limparHorario(date: Date): Date {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    }

    const buscarPorCep = async (cep: string) => {
        try {
            const apiGenerica = axios.create({ baseURL: 'https://viacep.com.br/ws/' });
            cep = cep.replace(/\D/g, '');
            let endPoint = `${cep}/json/`;

            const response = await apiGenerica.get(endPoint);
            const infoCep = response.data;
            const camposAtualizados = {
                logradouro: infoCep.logradouro,
                bairro: infoCep.bairro,
                cidade: infoCep.localidade,
                estado: infoCep.uf,
            };

            camposNovoLocatarioRef.current = { ...camposNovoLocatarioRef.current, ...camposAtualizados };
            setEntidadeParaAtualizarLocacao(camposAtualizados);
            await buscarCidades(camposAtualizados.estado);
            setForcarAtualizacaoDeEntidadeLocacao(true);
        } catch (error: any) {
            tratarErro(error);
        }
    };

    const buscarCidades = async (codigoEstado: string) => {
        if (codigoEstado) {
            setCarregandoSelectCidades(true);

            const apiGenerica = axios.create({ baseURL: 'https://brasilapi.com.br/api/' });
            let endPoint = `ibge/municipios/v1/${codigoEstado}`;

            apiGenerica.get(endPoint).then((response) => {
                const novasOpcoes = response.data.map((cidade: any) => ({
                    codigo: cidade.nome,
                    valor: cidade.nome,
                    label: cidade.nome,
                }));

                setCidades(novasOpcoes);
                setCarregandoSelectCidades(false);
            }).catch(tratarErro);
        }
    }

    const editandoAsaas = useMemo(() => modo === TipoFormulario.tpEdicao && !!locacaoSelecionado?.asaasSubscriptionId, [modo, locacaoSelecionado]);

    // `unidadeGarantida`/`valorGarantido` preservam a unidade e o valor persistidos (edição) para o
    // SelectWithNumber não os regravar; só se aplicam quando a recorrência do form é a persistida.
    // `asaasAtivoOverride` existe para quem chama antes do estado do formulário ter sido atualizado
    // (handleEditar/handleVisualizar definem o envio ao Asaas na mesma passada em que chamam aqui, e
    // um setState ainda não se reflete na closure): sem ele, uma locação diária de opt-out abriria com
    // as opções de prazo da versão integrada.
    const calcularOpcoesPrazoMinimo = useCallback((recorrencia: TipoPeriodicidadePagamento, unidadeGarantida?: TipoPeriodicidadePagamento | null, valorGarantido?: number | null, asaasAtivoOverride?: boolean): OpcaoComMaximo[] => {
        let novasOpcoes: OpcaoComMaximo[];
        const asaasAtivo = asaasAtivoOverride ?? asaasNestaLocacao;

        if (recorrencia === TipoPeriodicidadePagamento.Diario && asaasAtivo) {
            novasOpcoes = [
                { label: "Dia(s)", valor: TipoPeriodicidadePagamento.Diario, maximo: 180 },
                { label: "Semana(s)", valor: TipoPeriodicidadePagamento.Semanal, maximo: 26 },
                { label: "Quinzena(s)", valor: TipoPeriodicidadePagamento.Quinzenal, maximo: 12 },
                { label: "Mês(es)", valor: TipoPeriodicidadePagamento.Mensal, maximo: 6 },
            ];
        } else if (recorrencia === TipoPeriodicidadePagamento.Mensal) {
            novasOpcoes = OPCOES_PRAZO_TODAS.filter(opcao =>
                opcao.valor !== TipoPeriodicidadePagamento.Diario &&
                opcao.valor !== TipoPeriodicidadePagamento.Quinzenal
            );
        } else if (recorrencia === TipoPeriodicidadePagamento.Semanal) {
            novasOpcoes = OPCOES_PRAZO_TODAS.filter(opcao =>
                opcao.valor !== TipoPeriodicidadePagamento.Diario
            );
        } else if (recorrencia === TipoPeriodicidadePagamento.Quinzenal) {
            novasOpcoes = OPCOES_PRAZO_TODAS.filter(opcao =>
                opcao.valor !== TipoPeriodicidadePagamento.Diario &&
                opcao.valor !== TipoPeriodicidadePagamento.Semanal
            );
        } else {
            novasOpcoes = [...OPCOES_PRAZO_TODAS];
        }

        if (unidadeGarantida) {
            if (!novasOpcoes.some(opcao => opcao.valor === unidadeGarantida)) {
                const opcaoOriginal = OPCOES_PRAZO_TODAS.find(opcao => opcao.valor === unidadeGarantida);
                if (opcaoOriginal) {
                    novasOpcoes = [...novasOpcoes, opcaoOriginal];
                }
            }

            if (valorGarantido && valorGarantido > 0) {
                novasOpcoes = novasOpcoes.map(opcao =>
                    opcao.valor === unidadeGarantida && opcao.maximo !== undefined && opcao.maximo < valorGarantido
                        ? { ...opcao, maximo: valorGarantido }
                        : opcao
                );
            }
        }

        return novasOpcoes;
    }, [asaasNestaLocacao]);

    const [filialNoForm, setFilialNoForm] = useState<string | null>(null);

    const campoFilialBase = getCampoFilial({ linha: 0, coluna: 1, largura: 6, onCampoDigitar: (idFilial: string) => setFilialNoForm(idFilial || null) });
    // Na EDIÇÃO a filial da locação não é alterável por este campo: o backend
    // (LocacaoService.AtualizarAsync) preserva a filial original e ignora o valor enviado. A
    // (re)atribuição de filial é feita pela ação "Associar à filial" (em lote) ou pelo cascade da
    // troca de filial do veículo. Deixamos o campo apenas-leitura no modo edição para não dar a
    // falsa impressão de que a mudança seria salva.
    const campoFilial = campoFilialBase && modo === TipoFormulario.tpEdicao
        ? { ...campoFilialBase, apenasLeitura: true }
        : campoFilialBase;

    // Filtra veículos e locatários pelo filial selecionado no formulário (sempre com labelComFilial)
    const veiculosOptionsFiltrados = useMemo(() => {
        const base = (filialNoForm
            ? veiculosRaw.filter((v: any) => !v.idFilial || v.idFilial === filialNoForm)
            : veiculosRaw
        ).map((v: any) => ({
            valor: v.id,
            label: labelComFilial(`${v.placa}:  ${v.marca} ${v.modelo} ${v.ano}`, v.idFilial),
        }));
        // Garantir que o veículo da locação selecionada esteja sempre presente
        if (locacaoSelecionado?.idVeiculo && locacaoSelecionado?.veiculo?.placa) {
            if (!base.some(o => o.valor === locacaoSelecionado.idVeiculo)) {
                base.push({
                    valor: locacaoSelecionado.idVeiculo,
                    label: labelComFilial(`${locacaoSelecionado.veiculo.placa}:  ${locacaoSelecionado.veiculo.marca} ${locacaoSelecionado.veiculo.modelo} ${locacaoSelecionado.veiculo.ano}`, locacaoSelecionado.veiculo.idFilial),
                });
            }
        }
        return base;
    }, [veiculosRaw, filialNoForm, locacaoSelecionado?.idVeiculo, locacaoSelecionado?.veiculo]);

    const locatariosOptionsFiltrados = useMemo(() => {
        const base = (filialNoForm
            ? locatariosRaw.filter((l: any) => !l.idFilial || l.idFilial === filialNoForm)
            : locatariosRaw
        ).map((l: any) => ({
            valor: l.id,
            label: labelComFilial(`${l.documento} - ${l.nome}`, l.idFilial),
        }));
        // Garantir que o locatário da locação selecionada esteja sempre presente
        if (locacaoSelecionado?.idLocatario && locacaoSelecionado?.locatario?.documento) {
            if (!base.some(o => o.valor === locacaoSelecionado.idLocatario)) {
                base.push({
                    valor: locacaoSelecionado.idLocatario,
                    label: labelComFilial(`${locacaoSelecionado.locatario.documento} - ${locacaoSelecionado.locatario.nome}`, locacaoSelecionado.locatario.idFilial),
                });
            }
        }
        return base;
    }, [locatariosRaw, filialNoForm, locacaoSelecionado?.idLocatario, locacaoSelecionado?.locatario]);

    // Espelha GetCicloPorRecorrencia do backend, só para o comparativo "antes → depois" na tela.
    const cicloAsaasDaPeriodicidade = useCallback((periodicidade?: TipoPeriodicidadePagamento) => {
        if (periodicidade === TipoPeriodicidadePagamento.Semanal) return 'WEEKLY';
        if (periodicidade === TipoPeriodicidadePagamento.Quinzenal) return 'BIWEEKLY';
        return 'MONTHLY';
    }, []);

    /**
     * Fluxo de CRIAÇÃO: confere se o locatário já tem assinatura ativa no Asaas antes de criar outra.
     * Não pré-seleciona nada aqui — na criação, escolher por conta própria reconfigurar uma assinatura
     * existente seria decidir no lugar do operador; a tela mostra as opções e ele decide.
     */
    const registrarCampoNovoLocatario = useCallback((campo: string, valor: any) => {
        camposNovoLocatarioRef.current = { ...camposNovoLocatarioRef.current, [campo]: valor };
    }, []);

    const preencherNovoLocatarioComClienteAsaas = useCallback((cliente: any) => {
        if (!cliente) return;

        const origem: Record<string, any> = {
            nome: cliente.nome,
            email: cliente.email,
            telefone: cliente.telefone,
            cep: cliente.cep,
            logradouro: cliente.logradouro,
            numero: cliente.numero,
            complemento: cliente.complemento,
            bairro: cliente.bairro,
            estado: cliente.estado,
            cidade: cliente.cidade,
        };

        const atualizacao: any = {};
        Object.entries(origem).forEach(([campo, valor]) => {
            const atual = camposNovoLocatarioRef.current[campo];
            const vazio = atual === undefined || atual === null || String(atual).trim() === '';
            if (vazio && valor !== undefined && valor !== null && String(valor).trim() !== '') {
                atualizacao[campo] = campo === 'nome' ? String(valor).toUpperCase() : valor;
            }
        });

        if (Object.keys(atualizacao).length === 0) return;

        camposNovoLocatarioRef.current = { ...camposNovoLocatarioRef.current, ...atualizacao };
        if (atualizacao.estado) {
            setEstado(atualizacao.estado);
            buscarCidades(atualizacao.estado);
        }
        setEntidadeParaAtualizarLocacao(atualizacao);
        setForcarAtualizacaoDeEntidadeLocacao(true);
        toast.info('Cliente encontrado no Asaas pelo documento. Os campos em branco foram preenchidos com o cadastro de lá.');
    }, []);

    /**
     * Zera a classificação das cobranças do Asaas. Precisa acontecer em TODO ponto que zera a escolha de
     * assinatura: a classificação governa o formulário (esconde o campo de caução e manda o valor e as
     * parcelas dela), e sobrevivendo a uma troca de contexto ela levaria a caução de um cliente para o
     * cadastro ou a edição de outro.
     */
    const limparCobrancasClassificadas = useCallback(() => {
        setCobrancasDisponiveisCriacao([]);
        setCategoriasCobrancasCriacao([]);
        setCobrancasIndisponiveisCriacao(false);
        setClassificacaoCobrancas({});
    }, []);

    const consultarAssinaturasDoLocatario = useCallback((alvo: any, reclassificacao = false) => {
        locatarioDaClassificacao.current = alvo ?? null;
        const documento = alvo && typeof alvo === 'object' ? alvo.documento : null;
        const idLocatario = alvo && typeof alvo !== 'object' ? String(alvo) : null;

        if (modo !== TipoFormulario.tpCadastro || !integradoAsaas || !enviarParaAsaas || (!idLocatario && !documento)) {
            requisicaoAssinaturasRef.current++;
            ultimoLocatarioConsultado.current = null;
            setClassificacaoAssinaturas(null);
            setAssinaturaEscolhida(null);
            limparCobrancasClassificadas();
            setCarregandoAssinaturasAsaas(false);
            return;
        }

        const quinzenalComDiasFixos = tipoPeriodicidadePagamento === TipoPeriodicidadePagamento.Quinzenal && desejoDefinirDias;

        // A chave inclui periodicidade e filial porque a classificação depende das duas: o locatário é
        // escolhido antes de a periodicidade ser definida, e uma troca depois mudava o veredito sem que
        // a consulta fosse repetida. Continua evitando a consulta dupla do onCampoDigitar (seleção e blur).
        const chave = `${idLocatario ? `L:${idLocatario}` : `D:${documento}`}|${tipoPeriodicidadePagamento ?? ''}|${quinzenalComDiasFixos}|${filialNoForm ?? ''}`;
        if (ultimoLocatarioConsultado.current === chave) return;
        ultimoLocatarioConsultado.current = chave;
        const requisicao = ++requisicaoAssinaturasRef.current;
        const ehAtual = () => requisicao === requisicaoAssinaturasRef.current;

        // Numa reclassificação a escolha é PRESERVADA enquanto a assinatura continuar reaproveitável:
        // trocar de mensal para semanal não muda o veredito, e zerar a decisão ali faria o operador
        // voltar a criar assinatura nova sem perceber. Quem derruba a escolha é a resposta, abaixo.
        const escolhaAnterior = reclassificacao ? escolhaAssinaturaRef.current : null;

        setCarregandoAssinaturasAsaas(true);
        if (!reclassificacao) {
            setAssinaturaEscolhida(null);
            escolhaAplicadaAoFormularioRef.current = null;
            setAtualizarFaturasEmAberto(false);
            setImportarPagasAnterioresAoInicio(false);
        }

        const params = new URLSearchParams();
        if (tipoPeriodicidadePagamento !== undefined && tipoPeriodicidadePagamento !== null) {
            params.append('periodicidade', String(tipoPeriodicidadePagamento));
        }
        params.append('quinzenalComDiasFixos', String(quinzenalComDiasFixos));
        if (filialNoForm) params.append('idFilial', String(filialNoForm));

        if (documento) params.append('documento', documento);
        const url = idLocatario
            ? `/Locacao/AssinaturasDoLocatarioNoAsaas/${idLocatario}?${params.toString()}`
            : `/Locacao/AssinaturasNoAsaasPorDocumento?${params.toString()}`;

        api.get(url)
            .then((res) => {
                if (!ehAtual()) return;
                setClassificacaoAssinaturas(res.data ?? null);

                // Cobranças livres do cliente: é o material da migração (caução paga no painel, multa,
                // acerto). Só semeia a sugestão quando não é reclassificação, para não apagar escolha
                // que o operador já fez ao trocar a periodicidade.
                const cobrancasLivres = res.data?.cobrancasDisponiveis ?? [];
                const categoriasDoCliente = res.data?.categorias ?? [];
                setCobrancasDisponiveisCriacao(cobrancasLivres);
                setCategoriasCobrancasCriacao(categoriasDoCliente);
                setCobrancasIndisponiveisCriacao(!!res.data?.cobrancasIndisponiveis);
                if (!reclassificacao) setClassificacaoCobrancas(sugerirClassificacao(cobrancasLivres, categoriasDoCliente));

                if (documento && !reclassificacao) preencherNovoLocatarioComClienteAsaas(res.data?.cliente);
                // origem 2 = Orfa: é a única que o componente renderiza. Sem este filtro, uma assinatura
                // classificada como "desta locação" era pré-selecionada e enviada sem aparecer na tela.
                const candidatas = (res.data?.assinaturas ?? []).filter((a: any) => a.podeReaproveitar && a.origem !== 1);
                const escolhaSegueValida = !!escolhaAnterior && candidatas.some((a: any) => a.assinatura?.id === escolhaAnterior);

                if (!escolhaSegueValida) {
                    // Primeira consulta deste locatário: a assinatura que inequivocamente cobra o aluguel
                    // já vem marcada. Com duas assinaturas (aluguel e manutenção, por exemplo), é o que
                    // impede o operador de reaproveitar a errada sem perceber. Na dúvida, nada é marcado.
                    setAssinaturaEscolhida(reclassificacao ? null : sugerirAssinaturaDoAluguel(candidatas, valorAluguelRef.current));
                    setAtualizarFaturasEmAberto(false);
                    setImportarPagasAnterioresAoInicio(false);
                }

                // Só interrompe o cadastro quando há de fato uma decisão a tomar. Assinatura de outra
                // locação (informativa) ou consulta indisponível não abrem modal: viram aviso na linha
                // de resumo, para não travar quem só quer cadastrar. Numa reclassificação, o modal só
                // volta se a mudança derrubou a escolha que o operador já tinha feito.
                // Cobrança livre também é decisão a tomar: é ela que, ignorada, vira boleto duplicado.
                const temCobrancaParaClassificar = cobrancasLivres.length > 0 && !reclassificacao;
                const precisaDecidir = (candidatas.length > 0
                    && (!reclassificacao || (!!escolhaAnterior && !escolhaSegueValida)))
                    || temCobrancaParaClassificar;
                if (precisaDecidir) {
                    setExibirModalEscolhaAssinatura(true);
                    return;
                }

                // A mudança tirou a assinatura escolhida de jogo e não há outra a oferecer (o caso
                // típico é a periodicidade passar a ser diária ou quinzenal com dias fixos, que não são
                // cobradas por assinatura). Avisar aqui é o que impede o operador de salvar achando que
                // ainda vai aproveitar a assinatura antiga, deixando ela cobrando junto da locação nova.
                if (escolhaAnterior && !escolhaSegueValida) {
                    toast.warning('A assinatura que você escolheu aproveitar não vale para esta configuração de cobrança. A locação vai criar uma assinatura nova no Asaas.');
                }
            })
            .catch(() => {
                if (!ehAtual()) return;
                setClassificacaoAssinaturas(null);
                setCobrancasDisponiveisCriacao([]);
                setClassificacaoCobrancas({});
                setCobrancasIndisponiveisCriacao(true);
            })
            .finally(() => {
                if (ehAtual()) setCarregandoAssinaturasAsaas(false);
            });
    }, [modo, integradoAsaas, enviarParaAsaas, tipoPeriodicidadePagamento, desejoDefinirDias, filialNoForm, token, preencherNovoLocatarioComClienteAsaas, limparCobrancasClassificadas]);

    // Mantém o espelho da escolha para a reclassificação poder compará-la sem virar dependência.
    useEffect(() => {
        escolhaAssinaturaRef.current = assinaturaEscolhida;
    }, [assinaturaEscolhida]);

    // A classificação depende de periodicidade, quinzena com dias fixos e filial, e o locatário é
    // escolhido ANTES de qualquer uma delas. Sem reconsultar quando mudam, o veredito exibido e a
    // escolha já feita ficavam obsoletos: trocar para diária depois de escolher aproveitar mandava ao
    // servidor um reaproveitamento que aquele fluxo não executa, e a assinatura antiga seguia cobrando
    // em paralelo com a locação nova. A guarda por chave impede consulta repetida.
    useEffect(() => {
        if (modo !== TipoFormulario.tpCadastro) return;
        if (!locatarioDaClassificacao.current) return;
        consultarAssinaturasDoLocatario(locatarioDaClassificacao.current, true);
    }, [modo, consultarAssinaturasDoLocatario]);

    // Cadastro do locatário pela CNH: a IA lê e o formulário é preenchido para conferência. Pelo ref,
    // o componente do campo é um só (não remonta a cada render e não perde o "Lendo a CNH...").
    const preencherLocatarioPelaCnhRef = useRef<(cnh: CnhLida, alterar: (campo: string, valor: any) => void) => void>(() => { });
    preencherLocatarioPelaCnhRef.current = (cnh, alterar) => {
        if (cnh.nome) {
            alterar('nome', cnh.nome);
            registrarCampoNovoLocatario('nome', cnh.nome);
        }
        if (cnh.cpf) {
            setMascaraDocumento('999.999.999-99');
            alterar('tipoDocumento', 1);
            alterar('documento', formatarCpf(cnh.cpf));
            if (cnh.cpf.length === 11) consultarAssinaturasDoLocatario({ documento: cnh.cpf });
        }
        if (cnh.rg) alterar('rg', cnh.rg);
        if (cnh.numeroRegistro) alterar('numeroRegistroCnh', cnh.numeroRegistro.slice(0, 11));
        const validade = validadeCnhParaIso(cnh.validade);
        if (validade) alterar('vencimentoHabilitacao', validade);
    };
    const CampoLerCnhLocatario = useMemo(() => ({ handleInputChange }: { handleInputChange?: (campo: string, valor: any) => void }) => (
        <BotaoLerCnh aoLer={cnh => preencherLocatarioPelaCnhRef.current(cnh, (campo, valor) => handleInputChange?.(campo, valor))} />
    ), []);

    /**
     * Ao aproveitar uma assinatura, o formulário nasce com os dados dela: valor, periodicidade e
     * vencimento. São SUGESTÕES: a locação continua sendo a fonte de verdade e o operador pode mudar
     * tudo antes de salvar. Sem isso ele teria que reescrever à mão o que já está no Asaas.
     */
    const aplicarDadosDaAssinaturaEscolhida = useCallback((idAssinatura: string | null) => {
        if (!idAssinatura) return;

        const item = (classificacaoAssinaturas?.assinaturas ?? []).find((a: any) => a.assinatura?.id === idAssinatura);
        const assinatura = item?.assinatura;
        if (!assinatura) return;

        const periodicidadePorCiclo: Record<string, TipoPeriodicidadePagamento> = {
            WEEKLY: TipoPeriodicidadePagamento.Semanal,
            BIWEEKLY: TipoPeriodicidadePagamento.Quinzenal,
            MONTHLY: TipoPeriodicidadePagamento.Mensal,
        };
        const periodicidade = assinatura.cycle ? periodicidadePorCiclo[assinatura.cycle] : undefined;

        const atualizacao: any = {};
        if (assinatura.value > 0) {
            atualizacao.valorAluguel = assinatura.value;
            setValorAluguel(Number(assinatura.value));
        }
        if (periodicidade) {
            atualizacao.periodicidadePagamento = periodicidade;
            setTipoPeriodicidadePagamento(periodicidade);
            setOpcoesPrazoMinimo(calcularOpcoesPrazoMinimo(periodicidade, null, null));
        }
        // A retirada é quando a cobrança deste cliente começou (a cobrança livre mais antiga), e o
        // primeiro pagamento segue o calendário atual da assinatura, recuado até lá: as parcelas do
        // contrato caem nos dias das cobranças já emitidas, que a importação casa uma a uma. Sem
        // histórico livre, vale o próximo vencimento. O encerramento é o fim da assinatura, se houver.
        const datas = datasSugeridasPelaAssinatura(item);
        if (datas.inicio) atualizacao.dataInicio = datas.inicio;
        if (datas.primeiroPagamento) atualizacao.dataPagamento = datas.primeiroPagamento;
        if (datas.termino) atualizacao.dataTermino = datas.termino;

        // Forma de pagamento da assinatura (boleto, pix, cartão) vira a forma de receber o aluguel.
        const formaPorBillingType: Record<string, BillingTypeAsaas> = {
            UNDEFINED: BillingTypeAsaas.UNDEFINED,
            BOLETO: BillingTypeAsaas.BOLETO,
            CREDIT_CARD: BillingTypeAsaas.CREDIT_CARD,
            PIX: BillingTypeAsaas.PIX,
        };
        if (assinatura.billingType && formaPorBillingType[assinatura.billingType] !== undefined) {
            atualizacao.asaasTipoDePagamento = formaPorBillingType[assinatura.billingType];
        }

        // Juros e multa que a assinatura já aplica: sem trazer, a locação nasceria sem encargo nenhum
        // e o próximo save empurraria isso para o Asaas, apagando o que estava configurado lá.
        if (assinatura.interestPercentage && assinatura.interestPercentage > 0) {
            atualizacao.jurosAoMes = assinatura.interestPercentage;
            atualizacao.jurosEscolha = 'jurosPorMes';
            setJurosPorDia(false);
        }
        if (assinatura.fineValue && assinatura.fineValue > 0) {
            if (String(assinatura.fineType).toUpperCase() === 'FIXED') {
                atualizacao.multaFixa = assinatura.fineValue;
                atualizacao.multaEscolha = 'multaFixa';
                setMultaPercentual(false);
            } else {
                atualizacao.multaPercentual = assinatura.fineValue;
                atualizacao.multaEscolha = 'multaPercentual';
                setMultaPercentual(true);
            }
        }

        if (Object.keys(atualizacao).length > 0) {
            setEntidadeParaAtualizarLocacao((prev: any) => ({ ...prev, ...atualizacao }));
            setForcarAtualizacaoDeEntidadeLocacao(true);
        }
    }, [classificacaoAssinaturas, calcularOpcoesPrazoMinimo]);

    /**
     * Fechar o modal sem confirmar volta à escolha que já estava aplicada ao formulário. A assinatura do
     * aluguel vem pré-selecionada, mas os dados dela só entram no cadastro ao confirmar: sem isto, quem
     * fechava o modal salvava reaproveitando a assinatura com as datas e o valor que estavam no formulário.
     */
    const descartarEscolhaDeAssinaturaNaoConfirmada = useCallback(() => {
        const aplicada = escolhaAplicadaAoFormularioRef.current;
        const aplicadaSegueValida = !!aplicada && (classificacaoAssinaturas?.assinaturas ?? [])
            .some((a: any) => a.podeReaproveitar && a.origem !== 1 && a.assinatura?.id === aplicada);
        setAssinaturaEscolhida(aplicadaSegueValida ? aplicada : null);
        setExibirModalEscolhaAssinatura(false);
    }, [classificacaoAssinaturas]);

    // Modal da escolha de assinatura na CRIAÇÃO: a decisão sai do meio do formulário, onde competia
    // com o cadastro, e vira uma pergunta objetiva no momento em que o locatário é escolhido.
    /**
     * O que a página "Cobranças" oferece. Esconde as da assinatura escolhida para reaproveitar: a
     * importação da assinatura já as traz como parcelas, e classificá-las de novo criaria um segundo
     * dono para a mesma cobrança (o servidor recusa, mas a tela nem deve oferecer). Trocar a escolha
     * devolve as cobranças à lista, com a classificação que já tinham.
     *
     * Avulsas primeiro; depois os vencimentos de cada assinatura juntos (encerradas antes das ativas),
     * para o operador classificar uma origem inteira de uma vez.
     */
    const cobrancasOferecidasCriacao = useMemo(() => {
        const ordemDaOrigem = (c: any) => (c.idAssinatura ? `1|${c.assinaturaAtiva ? 1 : 0}|${c.idAssinatura}` : '0');
        return (cobrancasDisponiveisCriacao || [])
            .filter((c: any) => !assinaturaEscolhida || c.idAssinatura !== assinaturaEscolhida)
            .map((c: any, indice: number) => ({ c, indice }))
            // Dentro de uma assinatura, do vencimento mais antigo para o mais novo, na ordem das parcelas.
            .sort((a: any, b: any) => ordemDaOrigem(a.c).localeCompare(ordemDaOrigem(b.c))
                || (a.c.idAssinatura ? String(a.c.vencimento).localeCompare(String(b.c.vencimento)) : 0)
                || a.indice - b.indice)
            .map((x: any) => x.c);
    }, [cobrancasDisponiveisCriacao, assinaturaEscolhida]);

    /** Quantas cobranças de cada assinatura o cliente tem para classificar (todas, inclusive as escondidas). */
    const cobrancasPorAssinaturaCriacao = useMemo(() => {
        const contagem: Record<string, number> = {};
        (cobrancasDisponiveisCriacao || []).forEach((c: any) => {
            if (c.idAssinatura) contagem[c.idAssinatura] = (contagem[c.idAssinatura] || 0) + 1;
        });
        return contagem;
    }, [cobrancasDisponiveisCriacao]);

    /**
     * O que a classificação das cobranças faz no cadastro. Caução classificada MANDA no campo de caução
     * (decisão do locador): o valor e as parcelas passam a vir das cobranças, e o campo sai da tela,
     * porque digitar um valor diferente do que o cliente já pagou é justamente o erro a evitar.
     */
    const cobrancasClassificadas = useMemo(() => {
        // A classificação só vale no contexto que a produziu: cadastro, conta integrada e locação indo
        // para o Asaas. Fora dele ela é resíduo de um formulário anterior, e aplicá-la esconderia o campo
        // de caução e mandaria a caução de outro cliente no payload (inclusive numa EDIÇÃO, onde o
        // servidor reescreve os lançamentos de caução com o valor recebido).
        const contextoValido = modo === TipoFormulario.tpCadastro && integradoAsaas && enviarParaAsaas;

        const escolhida = (destino: string) => (contextoValido ? (cobrancasOferecidasCriacao || []) : [])
            .filter((c: any) => classificacaoCobrancas[c.id]?.destino === destino);

        const caucoes = escolhida('caucao').slice().sort((a: any, b: any) => String(a.vencimento).localeCompare(String(b.vencimento)));
        const lancamentos = escolhida('lancamento');
        const alugueis = escolhida('aluguel');

        return {
            caucoes,
            lancamentos,
            idsDeAluguel: alugueis.map((c: any) => c.id),
            caucaoDefinidaPorCobrancas: caucoes.length > 0,
            valorCaucao: caucoes.reduce((soma: number, c: any) => soma + (Number(c.valor) || 0), 0),
            parcelasCaucao: caucoes.map((c: any) => ({
                data: String(c.vencimento).substring(0, 10),
                valor: Number(c.valor) || 0,
                pago: !!c.estaPaga,
                asaasPaymentId: c.id,
            })),
            linhasDeLancamento: lancamentos.map((c: any) => ({
                valor: Number(c.valor) || 0,
                descricao: c.descricao || 'LANÇAMENTO',
                vencimento: String(c.vencimento).substring(0, 10),
                idsCategorias: [classificacaoCobrancas[c.id]?.idCategoria].filter(Boolean),
                tipo: 1,
                pago: !!c.estaPaga,
                dataPagamento: c.estaPaga ? (c.dataPagamento ? String(c.dataPagamento).substring(0, 10) : null) : null,
                cobrarNoAsaas: false,
                asaasPaymentId: c.id,
            })),
        };
    }, [cobrancasOferecidasCriacao, classificacaoCobrancas, modo, integradoAsaas, enviarParaAsaas]);

    const alterarClassificacaoCobranca = useCallback((idCobranca: string, escolha: EscolhaCobranca | null) => {
        setClassificacaoCobrancas((anterior) => {
            const proximo = { ...anterior };
            if (!escolha) delete proximo[idCobranca];
            else proximo[idCobranca] = escolha;
            return proximo;
        });
    }, []);

    const classificarVariasCobrancas = useCallback((ids: string[], escolha: EscolhaCobranca | null) => {
        setClassificacaoCobrancas((anterior) => {
            const proximo = { ...anterior };
            ids.forEach((id) => {
                if (!escolha) delete proximo[id];
                else proximo[id] = escolha;
            });
            return proximo;
        });
    }, []);

    const limparClassificacaoDeCaucao = useCallback(() => {
        setClassificacaoCobrancas((anterior) => {
            const proximo: ClassificacaoCobrancas = {};
            Object.entries(anterior).forEach(([id, escolha]) => {
                if (escolha.destino !== 'caucao') proximo[id] = escolha;
            });
            return proximo;
        });
    }, []);

    const camposEscolhaAssinatura: Campo[] = useMemo(() => [
        {
            label: '', nome: '_escolhaAssinaturaModal', tipo: 'custom', required: false, largura: 12, coluna: 1, linha: 1, visible: true,
            component: () => (
                <EscolhaAssinaturaAsaas
                    classificacao={classificacaoAssinaturas}
                    carregando={carregandoAssinaturasAsaas}
                    valorAluguel={valorAluguel > 0 ? valorAluguel : undefined}
                    cicloAsaas={cicloAsaasDaPeriodicidade(tipoPeriodicidadePagamento)}
                    escolha={assinaturaEscolhida}
                    onEscolher={setAssinaturaEscolhida}
                    atualizarFaturas={atualizarFaturasEmAberto}
                    onAtualizarFaturas={setAtualizarFaturasEmAberto}
                    importarPagasAnteriores={importarPagasAnterioresAoInicio}
                    onImportarPagasAnteriores={setImportarPagasAnterioresAoInicio}
                    cobrancasPorAssinatura={cobrancasPorAssinaturaCriacao}
                />
            ),
        },
        {
            label: '', nome: '_cobrancasIndisponiveis', tipo: 'custom', required: false, largura: 12, coluna: 1, linha: 2,
            visible: () => cobrancasIndisponiveisCriacao,
            component: () => <AvisoCobrancasIndisponiveis />,
        },
        {
            label: '', nome: '_aberturaCobrancas', tipo: 'custom', required: false, largura: 12, coluna: 1, linha: 3,
            visible: () => cobrancasOferecidasCriacao.length > 0,
            component: () => <TextoDeAbertura quantidade={cobrancasOferecidasCriacao.length} />,
        },
        // Uma cobrança por campo: é o que permite o modal paginar a decisão em blocos curtos, em vez de
        // uma lista longa onde o operador confirma sem ter visto o fim.
        ...cobrancasOferecidasCriacao.map((cobranca: any, indice: number) => {
            // Primeira linha de cada assinatura de origem abre o grupo: diz de onde vieram aqueles
            // vencimentos e deixa classificar todos de uma vez (o caso típico é a manutenção mensal).
            const anterior = indice > 0 ? cobrancasOferecidasCriacao[indice - 1] : null;
            const abreGrupo = !!cobranca.idAssinatura && (!anterior || anterior.idAssinatura !== cobranca.idAssinatura);
            const doGrupo = abreGrupo
                ? cobrancasOferecidasCriacao.filter((c: any) => c.idAssinatura === cobranca.idAssinatura)
                : [];
            return {
                label: '', nome: `_cobranca_${cobranca.id}`, tipo: 'custom' as const, required: false,
                largura: 12, coluna: 1, linha: 10 + indice, visible: true,
                component: () => (
                    <LinhaCobranca
                        cobranca={cobranca}
                        categorias={categoriasCobrancasCriacao as any}
                        escolha={classificacaoCobrancas[cobranca.id]}
                        onClassificar={alterarClassificacaoCobranca}
                        posicao={indice + 1}
                        total={cobrancasOferecidasCriacao.length}
                        grupo={abreGrupo ? {
                            cobrancas: doGrupo,
                            classificacao: classificacaoCobrancas,
                            onClassificarTodas: (escolha: EscolhaCobranca | null) =>
                                classificarVariasCobrancas(doGrupo.map((c: any) => c.id), escolha),
                        } : undefined}
                    />
                ),
            };
        }),
        {
            label: '', nome: '_resumoClassificacao', tipo: 'custom', required: false, largura: 12, coluna: 1, linha: 900,
            visible: () => cobrancasOferecidasCriacao.length > 0,
            component: () => (
                <ResumoClassificacao
                    cobrancas={cobrancasOferecidasCriacao as any}
                    classificacao={classificacaoCobrancas}
                    categorias={categoriasCobrancasCriacao as any}
                />
            ),
        },
    ], [classificacaoAssinaturas, carregandoAssinaturasAsaas, assinaturaEscolhida, atualizarFaturasEmAberto, importarPagasAnterioresAoInicio, valorAluguel, tipoPeriodicidadePagamento, cicloAsaasDaPeriodicidade, cobrancasOferecidasCriacao, cobrancasPorAssinaturaCriacao, categoriasCobrancasCriacao, cobrancasIndisponiveisCriacao, classificacaoCobrancas, alterarClassificacaoCobranca, classificarVariasCobrancas]);

    /**
     * Duas páginas no modal de identificação no Asaas: Assinatura e Cobranças. A separação existe para a
     * decisão da assinatura não ficar acima de uma lista longa e passar batida; dentro de Cobranças ficam
     * TODAS elas, terminando no consolidado (que também nomeia as que ficaram sem destino).
     *
     * Sem assinatura a decidir, não pagina: uma página só com o nome "Cobranças" seria um passo inútil.
     */
    const paginasEscolhaAssinatura = useMemo(() => {
        if (!cobrancasOferecidasCriacao.length) return undefined;

        const temAssinaturaParaDecidir = (classificacaoAssinaturas?.assinaturas ?? [])
            .some((a: any) => a.podeReaproveitar && a.origem !== 1);
        if (!temAssinaturaParaDecidir) return undefined;

        return [
            { titulo: 'Assinatura', campos: ['_escolhaAssinaturaModal'] },
            {
                titulo: 'Cobranças',
                campos: [
                    '_cobrancasIndisponiveis',
                    '_aberturaCobrancas',
                    ...cobrancasOferecidasCriacao.map((c: any) => `_cobranca_${c.id}`),
                    '_resumoClassificacao',
                ],
            },
        ];
    }, [cobrancasOferecidasCriacao, classificacaoAssinaturas]);

    const campos: Campo[] = useMemo(() => [
        ...(campoFilial ? [campoFilial] : []),
        { label: 'Informações do Veículo', nome: '', required: true, tipo: 'label', largura: 12, coluna: 1, linha: 1, visible: true },
        {
            label: '', nome: 'veiculoEscolha', required: false, tipo: 'toggle', largura: 12, coluna: 1, linha: 1,
            // O toggle grava o próprio padrão ao aparecer: sem veículo livre no onboarding, já nasce em "Cadastrar Veículo".
            defaultValueToggle: onboarding.ativo && semVeiculoLivre ? "novoVeiculo" : "veiculoExistente",
            // No onboarding a frota acabou de ser cadastrada: só escolher o veículo. Sem veículo livre,
            // o toggle volta para a pessoa cadastrar o veículo aqui.
            visible: !editandoAsaas && modo == TipoFormulario.tpCadastro && (!onboarding.ativo || semVeiculoLivre), opcoes: [{ label: "Cadastrar Veículo", valor: "novoVeiculo" }, { label: "Veículo Existente", valor: "veiculoExistente" }],
            onCampoDigitar: (e: any) => {
                setNovoVeiculo(e == "novoVeiculo")
            }
        },
        {
            label: 'Placa', nome: 'placa', required: true, tipo: 'text', largura: 3, coluna: 1, linha: 1,
            visible: !editandoAsaas && novoVeiculo, mascara: '***-****', tudoMaiusculo: true, minimoCaracteres: 8,
            onCampoSair: (valor: any) => {
                if (modo !== TipoFormulario.tpVisualizacao && valor && valor.replace('-', '').trim().length >= 7) {
                    buscarDadosPorPlaca(valor);
                }
            }
        },
        {
            label: 'Tipo Veículo',
            nome: 'tipoVeiculo',
            required: true,
            tipo: 'select',
            selectBoxHint: 'Escolha',
            largura: 3,
            coluna: 2,
            linha: 1,
            visible: !editandoAsaas && novoVeiculo,
            opcoes: [
                { valor: TipoVeiculo.tpCarro, label: 'Carro' },
                { valor: TipoVeiculo.tpMoto, label: 'Moto' },
                { valor: TipoVeiculo.tpCaminhao, label: 'Caminhão' },
            ],
            carregando: consultandoPlaca,
            onCampoDigitar: debounce((t: any) => {
                setTipoVeiculo(t);
                setMarcas([]);
                setModelos([]);
                if ((modo === TipoFormulario.tpCadastro || modo === TipoFormulario.tpEdicao) && t) {
                    buscarMarcas(t);
                }
            }, 300),
        },
        { label: 'Renavam', nome: 'renavam', required: false, tipo: 'text', largura: 3, coluna: 3, linha: 1, visible: !editandoAsaas && novoVeiculo, tudoMaiusculo: true, minimoCaracteres: 11, },
        { label: 'Chassi', nome: 'chassi', required: false, tipo: 'text', largura: 3, coluna: 4, linha: 1, visible: !editandoAsaas && novoVeiculo, tudoMaiusculo: true, minimoCaracteres: 17, },
        {
            label: 'Marca',
            nome: 'marca',
            tipo: 'select',
            required: true,
            largura: 4,
            coluna: 2,
            linha: 2,
            visible: !editandoAsaas && novoVeiculo,
            opcoes: marcas.map(m => ({ valor: m.nome, label: m.nome, codigo: m.codigo })),
            carregando: carregandoSelect,
            onCampoDigitar: debounce((m: any) => {
                setModelos([]);
                if ((modo === TipoFormulario.tpCadastro || modo === TipoFormulario.tpEdicao) && m) {
                    buscarModelosPorMarca(m);
                }
            }, 300),
            allowNotFoundValues: true
        },
        {
            label: 'Modelo',
            nome: 'modelo',
            required: true,
            tipo: 'select',
            largura: 4,
            coluna: 2,
            linha: 2,
            visible: !editandoAsaas && novoVeiculo,
            opcoes: modelos.map(m => ({ valor: m.nome, label: m.nome, codigo: m.codigo })),
            carregando: carregandoSelect,
            allowNotFoundValues: true
        },
        { label: 'Ano', nome: 'ano', required: true, tipo: 'text', largura: 2, coluna: 3, linha: 2, visible: !editandoAsaas && novoVeiculo },
        { label: 'Cor', nome: 'cor', required: true, tipo: 'select', largura: 2, coluna: 4, linha: 2, visible: !editandoAsaas && novoVeiculo, opcoes: CoresVeiculo, selectBoxHint: 'Cor' },
        {
            label: '', nome: 'locatarioEscolha', required: false, tipo: 'toggle', largura: 12, coluna: 1, linha: 4,
            // No onboarding ainda não há cliente cadastrado: começa em "Cadastrar Locatário".
            defaultValueToggle: onboarding.ativo ? "novoLocatario" : "locatarioExistente",
            visible: !editandoAsaas && modo == TipoFormulario.tpCadastro, opcoes: [{ label: "Cadastrar Locatário", valor: "novoLocatario" }, { label: "Locatário Existente", valor: "locatarioExistente" }],
            onCampoDigitar: (e: any) => {
                const ehNovo = e == "novoLocatario";
                if (ehNovo !== novoLocatario) {
                    camposNovoLocatarioRef.current = {};
                    consultarAssinaturasDoLocatario(null);
                }
                setNovoLocatario(ehNovo)
            }
        },
        {
            label: '', nome: '_lerCnhLocatario', required: false, tipo: 'custom', largura: 12, coluna: 2, linha: 4,
            // Mesma linha do seletor Cadastrar/Existente: com as duas colunas cheias, cai logo abaixo dele.
            visible: !editandoAsaas && novoLocatario && modo === TipoFormulario.tpCadastro, component: CampoLerCnhLocatario,
        },
        {
            label: '', nome: '_maisDadosCliente', required: false, tipo: 'custom', largura: 12, coluna: 1, linha: 6,
            visible: !editandoAsaas && novoLocatario && onboarding.ativo,
            component: () => (
                <AvisoMaisDados>
                    <span>Tudo o que você preencher aqui vai sozinho para o contrato: documentos, contato e endereço do cliente.</span>
                </AvisoMaisDados>
            ),
        },
        { label: 'Nome', nome: 'nome', required: true, tipo: 'text', largura: 6, coluna: 1, linha: 5, visible: !editandoAsaas && novoLocatario, tudoMaiusculo: true, onCampoDigitar: (e: any) => registrarCampoNovoLocatario('nome', e) },
        { label: 'E-mail', nome: 'email', required: false, tipo: 'text', largura: 3, coluna: 2, linha: onboarding.ativo ? 8 : 5, visible: !editandoAsaas && novoLocatario, onCampoDigitar: (e: any) => registrarCampoNovoLocatario('email', e) },
        { label: 'Validade da CNH', nome: 'vencimentoHabilitacao', required: false, tipo: 'date', largura: 3, coluna: 3, linha: onboarding.ativo ? 8 : 5, visible: !editandoAsaas && novoLocatario },
        { label: 'RG', nome: 'rg', required: false, tipo: 'text', largura: 3, coluna: 1, linha: onboarding.ativo ? 8 : 6, visible: !editandoAsaas && novoLocatario },
        { label: 'CNH', nome: 'numeroRegistroCnh', required: false, tipo: 'text', largura: 3, coluna: 2, linha: onboarding.ativo ? 8 : 6, visible: !editandoAsaas && novoLocatario, maximoCaracteres: 11 },
        {
            label: 'Tipo Documento', nome: 'tipoDocumento', required: true, tipo: 'select', largura: 3, coluna: 3, linha: onboarding.ativo ? 9 : 6, visible: !editandoAsaas && novoLocatario && !onboarding.ativo, opcoes: [{ label: 'CPF', valor: 1 }, { label: 'CNPJ', valor: 2 }], onCampoDigitar(e) {
                if (e == 1) {
                    setMascaraDocumento('999.999.999-99');
                } else {
                    setMascaraDocumento('99.999.999/9999-99');
                }
            }, selectBoxHint: "CPF/CNPJ"
        },
        {
            label: onboarding.ativo ? 'CPF' : 'Documento', nome: 'documento', required: true, tipo: 'text', largura: 3, coluna: 4, linha: onboarding.ativo ? 5 : 6, visible: !editandoAsaas && novoLocatario, mascara: mascaraDocumento,
            onCampoDigitar: (e: any) => {
                const digitos = String(e ?? '').replace(/\D/g, '');
                if (digitos.length === 11 || digitos.length === 14)
                    consultarAssinaturasDoLocatario({ documento: digitos });
            }
        },
        { label: 'Telefone', nome: 'telefone', required: false, tipo: 'text', largura: 3, coluna: 1, linha: onboarding.ativo ? 5 : 7, visible: !editandoAsaas && novoLocatario, mascara: '(99) 99999-9999', onCampoDigitar: (e: any) => registrarCampoNovoLocatario('telefone', e) },
        {
            label: 'CEP', nome: 'cep', required: false, tipo: 'text', largura: 3, coluna: 2, linha: onboarding.ativo ? 10 : 7, visible: !editandoAsaas && novoLocatario, mascara: '99999-999', onCampoDigitar: (e: any) => registrarCampoNovoLocatario('cep', e), onCampoSair(e) {
                let cep = e.replace(/\D/g, '');
                if (cep.length == 8) {
                    buscarPorCep(e);
                }
            }, botaoExtra: { icone: FaSearchLocation, link: 'https://buscacepinter.correios.com.br/app/endereco/index.php', tooltip: 'Encontrar CEP' }
        },
        {
            label: 'Estado', nome: 'estado', required: false, tipo: 'select', largura: 3, coluna: 3, linha: onboarding.ativo ? 10 : 7, visible: !editandoAsaas && novoLocatario, opcoes: estados, onCampoDigitar: (e: any) => registrarCampoNovoLocatario('estado', e), onCampoSair(e) {
                if (e != estado) {
                    setEstado(e);
                }
            }, allowNotFoundValues: true, selectBoxHint: "Estado"
        },
        { label: 'Cidade', nome: 'cidade', required: false, tipo: 'select', largura: 3, coluna: 4, linha: onboarding.ativo ? 10 : 7, visible: !editandoAsaas && novoLocatario, opcoes: cidades, carregando: carregandoSelectCidades, allowNotFoundValues: true, selectBoxHint: "Cidade", onCampoDigitar: (e: any) => registrarCampoNovoLocatario('cidade', e) },
        { label: 'Bairro', nome: 'bairro', required: false, tipo: 'text', largura: 3, coluna: 1, linha: onboarding.ativo ? 11 : 8, visible: !editandoAsaas && novoLocatario, allowNotFoundValues: true, onCampoDigitar: (e: any) => registrarCampoNovoLocatario('bairro', e) },
        { label: 'Logradouro', nome: 'logradouro', required: false, tipo: 'text', largura: 3, coluna: 2, linha: onboarding.ativo ? 11 : 8, visible: !editandoAsaas && novoLocatario, onCampoDigitar: (e: any) => registrarCampoNovoLocatario('logradouro', e) },
        { label: 'Numero', nome: 'numero', required: false, tipo: 'text', largura: 3, coluna: 3, linha: onboarding.ativo ? 11 : 8, visible: !editandoAsaas && novoLocatario, onCampoDigitar: (e: any) => registrarCampoNovoLocatario('numero', e) },

        { label: 'Complemento', nome: 'complemento', required: false, tipo: 'text', largura: 3, coluna: 4, linha: onboarding.ativo ? 11 : 8, visible: !editandoAsaas && novoLocatario, onCampoDigitar: (e: any) => registrarCampoNovoLocatario('complemento', e) },

        {
            label: 'Locatário', nome: 'idLocatario', required: true, tipo: 'select', largura: 12, coluna: 1, linha: 5,
            visible: !novoLocatario, opcoes: locatariosOptionsFiltrados, apenasLeitura: modo === TipoFormulario.tpVisualizacao || editandoAsaas,
            // Na CRIAÇÃO, assim que o locatário é escolhido, conferimos se ele já tem assinatura ativa no
            // Asaas. Antes o sistema criava a segunda em silêncio — a origem mais comum de assinatura
            // órfã cobrando o cliente de um contrato que já acabou.
            // onCampoDigitar (e não onCampoSair): no select ele dispara na SELEÇÃO; o onCampoSair depende
            // de um blur que não acontece quando o operador escolhe o locatário e vai direto salvar.
            onCampoDigitar: (e: any) => consultarAssinaturasDoLocatario(e),
        },
        {
            label: '', nome: '_escolhaAssinaturaAsaasCriacao', tipo: 'custom', required: false, largura: 12, coluna: 1, linha: novoLocatario ? 9 : 6,
            visible: modo === TipoFormulario.tpCadastro && integradoAsaas && enviarParaAsaas
                && (carregandoAssinaturasAsaas || !!classificacaoAssinaturas?.assinaturas?.length || !!classificacaoAssinaturas?.consultaIndisponivel),
            component: () => (
                <ResumoEscolhaAssinatura
                    classificacao={classificacaoAssinaturas}
                    carregando={carregandoAssinaturasAsaas}
                    escolha={assinaturaEscolhida}
                    onAbrir={() => setExibirModalEscolhaAssinatura(true)}
                />
            ),
        },
        // O aviso de "não consegui listar as cobranças deste cliente" precisa viver AQUI, no formulário,
        // e não só dentro do modal de identificação: quando a listagem falha, a lista vem vazia e o modal
        // não tem motivo para abrir (nem quando o cliente não tem assinatura a decidir, que é o caso mais
        // comum na migração). Ficando só no modal, o operador cadastrava em silêncio e a caução já paga
        // era cobrada de novo, que é exatamente o que esta marca existe para evitar.
        {
            label: '', nome: '_cobrancasIndisponiveisCriacaoAviso', tipo: 'custom', required: false,
            largura: 12, coluna: 1, linha: novoLocatario ? 9 : 6,
            visible: modo === TipoFormulario.tpCadastro && integradoAsaas && enviarParaAsaas
                && cobrancasIndisponiveisCriacao,
            component: () => <AvisoCobrancasIndisponiveis />,
        },
        {
            label: 'Veículo', nome: 'idVeiculo', required: true, tipo: 'select', largura: 12, coluna: 1, linha: 1,
            visible: !novoVeiculo, opcoes: veiculosOptionsFiltrados, apenasLeitura: modo === TipoFormulario.tpVisualizacao || editandoAsaas,
            onCampoSair: (e: any) => {
                if (e) {
                    const label = veiculosOptions.find(v => v.valor === e)?.label || '';
                    const placa = (label.includes(':') ? label.split(':')[0] : label.split(' - ')[0]).trim();
                    if (placa) {
                        api.get(`/AzulMonitor/Odometro/${obterIdTenent(token)}/${placa.replace('-', '').toUpperCase()}`)
                            .then(res => {
                                if (res.data?.encontrado) {
                                    setEntidadeParaAtualizarLocacao({ kmInicial: res.data.odometroKm });
                                    setForcarAtualizacaoDeEntidadeLocacao(true);
                                }
                            })
                            .catch(() => {});
                    }
                }
            },
        },
        {
            // linha 100 e não 96: o ModalForm agrupa campos pela `linha`, e a 96 é do editor de
            // parcelas da caução. Compartilhando a linha, a Observação (declarada antes no array)
            // renderizava primeiro e o editor aparecia depois dela — ao marcar "caução negociada"
            // o operador via o campo de observação no lugar da configuração do parcelamento.
            label: 'Observação', nome: 'observacao', required: false, tipo: 'memo', largura: 12, coluna: 1, linha: 100,
            visible: () => mostrarAvancadoLocacao,
            ajudinha: {
                texto: 'Use este campo para registrar detalhes adicionais da locação (acordos verbais, condições especiais, etc.). Fica visível também na edição e visualização.',
            },
        },
        {
            label: '', alertMessage: 'O campo "Prazo mínimo da locação" será usado para gerar a previsão de pagamentos (aluguéis) a partir de hoje, mas também serão criados pagamentos desde o início da locação.', nome: 'alertaSobrePrazoMinimo', required: false, tipo: 'aviso', largura: 12, coluna: 1, linha: 1, visible: (values) => {
                return (
                    !editandoAsaas &&
                    modo === TipoFormulario.tpCadastro &&
                    Boolean(values.locacaoEmAndamento)
                );
            }, alertType: 'info', alertIcon: FaInfo, alertDismissible: true, alertTitle: "Sobre locações em Andamento:"
        },
        {
            label: 'Quilometragem Inicial', nome: 'kmInicial', required: false, tipo: 'number', largura: 6, coluna: 1, linha: 2,
            visible: true, ajudinha: {
                texto: "Este campo corresponde a quilometragem inicial do veículo no momento em que a locação se iniciou.",
                autoCloseTime: 3
            }
        },
        {
            label: 'Você receberá por', nome: 'periodicidadePagamento', required: true, tipo: 'select', largura: 6, coluna: 2, linha: 2,
            visible: true, apenasLeitura: modo === TipoFormulario.tpVisualizacao || editandoAsaas, opcoes: OpcoesPeriodicidadePagamento,
            onCampoDigitar: (e) => {
                const recorrencia = e as TipoPeriodicidadePagamento;
                setTipoPeriodicidadePagamento(recorrencia);
                const persistido = locacaoSelecionadoRef.current;
                const manterGarantia = Number(persistido?.periodicidadePagamento) === Number(recorrencia);
                const tempoContrato = persistido?.tempoContratoEmMeses;
                const valorPrazoPersistido = typeof tempoContrato === 'object' ? tempoContrato?.value : tempoContrato;
                setOpcoesPrazoMinimo(calcularOpcoesPrazoMinimo(recorrencia, manterGarantia ? persistido?.tipoPeriodicidadeTempoContrato : null, manterGarantia ? valorPrazoPersistido : null));
            }, selectBoxIsCleareable: false
        },
        {
            label: 'Quilometragem Final', nome: 'kmFinal', required: false, tipo: 'number', largura: 6, coluna: 2, linha: 9,
            visible: modo != TipoFormulario.tpCadastro, ajudinha: {
                texto: "Este campo corresponde a quilometragem final do veículo no momento em que a locação foi encerrada.",
                autoCloseTime: 3
            },
            apenasLeitura: modo === TipoFormulario.tpCadastro
        },
        { label: 'Informações do Locatário e Contrato', nome: '', required: true, tipo: 'label', largura: 6, coluna: 1, linha: 4, visible: true },
        {
            label: "Marque se a locação está em andamento", coluna: 1, largura: 12, linha: 3,
            visible: !editandoAsaas && modo === TipoFormulario.tpCadastro,
            nome: 'locacaoEmAndamento', tipo: 'checkbox', required: false
        },
        {
            label: 'Qual o prazo mínimo da locação?', nome: 'tempoContratoEmMeses', required: true, tipo: 'selectwithnumber', largura: 6, coluna: 1, linha: 4,
            visible: true, apenasLeitura: editandoAsaas, ajudinha: {
                texto: "Este campo representa a duração do contrato, que pode ser expressa em dias, semanas, quinzenas ou meses.",
                autoCloseTime: 3
            }, opcoes: opcoesPrazoMinimo
        },
        {
            label: 'Fiador', nome: 'fiador', required: false, tipo: 'text', largura: 6, coluna: 2, linha: 4, visible: true,
        },
        {
            label: "Marque se é uma locação com opção de compra", coluna: 1, largura: 12, linha: 5,
            visible: true,
            nome: 'opcaoDeCompra', tipo: 'checkbox', required: false,
            ajudinha: {
                texto: "Essa opção é bastante comum em planos com promessa de compra, nos quais, ao final do contrato, o veículo passa a ser do locatário"
            },
        },
        { label: 'Informações da Locação', nome: '', required: true, tipo: 'label', largura: 12, coluna: 1, linha: 6, visible: true },
        {
            label: 'Valor do Aluguel', nome: 'valorAluguel', required: true, tipo: 'money', largura: 6, coluna: 1, linha: 7, visible: true, apenasLeitura: editandoAsaas,
            onCampoDigitar: (e) => {
                setValorAluguel(Number(e));
            }
        },
        {
            label: `Valor da ${nomeCaucao.titulo}`, nome: 'valorCaucao', required: false, tipo: 'money', largura: 6, coluna: 2, linha: 7,
            visible: !cobrancasClassificadas.caucaoDefinidaPorCobrancas, apenasLeitura: editandoAsaas,
            onCampoDigitar: (e) => {
                setValorCaucaoState(Number(e) || 0);
            }
        },
        {
            label: "Desejo definir os dias do 1º e 2º pagamento de cada quinzena", coluna: 1, largura: 12, linha: 8,
            visible: tipoPeriodicidadePagamento === TipoPeriodicidadePagamento.Quinzenal,
            apenasLeitura: editandoAsaas,
            nome: 'desejoDefinirPrimeiroSegundoDia', tipo: 'checkbox', required: false,
            onCampoDigitar: setDesejoDefinirDias,
        },
        {
            label: 'Data e hora de retirada do veículo', nome: 'dataInicio', required: true, tipo: 'datetime-local', largura: 6, coluna: 1, linha: 9,
            visible: true, apenasLeitura: editandoAsaas, ajudinha: {
                texto: "Dia e hora em que o locatário saiu com o veículo. A hora define de quem é uma multa ou uma ocorrência quando o mesmo veículo é devolvido e alugado de novo no mesmo dia. As cobranças continuam por dia.",
                autoCloseTime: 3
            },
        },
        {
            label: (desejoDefinirDias && tipoPeriodicidadePagamento === TipoPeriodicidadePagamento.Quinzenal) ? 'Data 1º Pagmt' : 'Data primeiro pagamento',
            nome: 'dataPagamento', required: true, tipo: 'date', largura: 6, coluna: 2, linha: 9,
            visible: true, apenasLeitura: editandoAsaas, ajudinha: {
                texto: (desejoDefinirDias && tipoPeriodicidadePagamento === TipoPeriodicidadePagamento.Quinzenal) ?
                    'Este campo refere-se ao dia do mês que será cobrado o primeiro pagamento, se quinzena' :
                    "Este campo indica a data de início do(s) pagamento(s).",
                autoCloseTime: 3
            },
            onCampoSair: (value) => {
                const data = parseDateFromString(value);
                setDiaPrimeiroPagamento(data)
            },
        },
        {
            label: 'Data 2º Pagmt', nome: 'dataSegundoPagamentoQuinzena', required: false, tipo: 'date',
            largura: 4, coluna: 2, linha: 9, visible: (desejoDefinirDias && tipoPeriodicidadePagamento === TipoPeriodicidadePagamento.Quinzenal),
            apenasLeitura: editandoAsaas,
            ajudinha: {
                texto: 'Este campo refere-se ao dia do mês que será cobrado o segundo pagamento, se quinzena',
                autoCloseTime: 3
            },
            onCampoSair: (e) => setDiaSegundoPagamento(new Date(e)),
        },
        {
            label: 'Quando o mês não tiver o dia escolhido',
            nome: 'ajusteDiaInexistente', tipo: 'select', largura: 6, coluna: 1, linha: 10,
            required: false, apenasLeitura: editandoAsaas,
            visible: desejoDefinirDias
                && tipoPeriodicidadePagamento === TipoPeriodicidadePagamento.Quinzenal
                && (((diaPrimeiroPagamento?.getDate() ?? 0) > 28) || ((diaSegundoPagamento?.getDate() ?? 0) > 28)),
            opcoes: [
                { label: 'Ir para o primeiro dia do mês seguinte', valor: 0 },
                { label: 'Usar o último dia do mês', valor: 1 },
            ],
            ajudinha: {
                texto: 'Alguns meses não têm o dia escolhido (ex.: dia 30 em fevereiro). Escolha para onde a cobrança vai nesses meses. Padrão: primeiro dia do mês seguinte.',
                autoCloseTime: 4
            },
        },
        {
            label: 'Data e hora de encerramento', nome: 'dataTermino', required: false, tipo: 'datetime-local', largura: 6, coluna: 1, linha: 9,
            visible: ((modo === TipoFormulario.tpVisualizacao || modo === TipoFormulario.tpEdicao) || asaasNestaLocacao),
            ajudinha: {
                texto: "Dia e hora em que a locação finalizou ou irá finalizar (devolução do veículo).",
                autoCloseTime: 3
            },
            apenasLeitura: (modo === TipoFormulario.tpCadastro) && !asaasNestaLocacao
        },
        {
            label: 'Como você receberá o aluguel?', nome: 'asaasTipoDePagamento',
            required: asaasNestaLocacao && !editandoAsaas, tipo: 'select', largura: 6, coluna: 1, linha: 10,
            // Visível com a CONTA integrada, mesmo que o aluguel não vá para o Asaas: esta escolha é
            // também o padrão herdado pela caução e pelos lançamentos que forem cobrados por lá.
            visible: integradoAsaas, apenasLeitura: editandoAsaas, opcoes: BillingTypeOptions,
            ajudinha: editandoAsaas
                ? { texto: "Este campo não pode ser editado pois está vinculado a uma assinatura no Asaas.", autoCloseTime: 4 }
                : { texto: "Vale para as cobranças do aluguel. A caução e cada lançamento podem usar outra forma; sem escolha própria, eles seguem esta.", autoCloseTime: 6 },
        },
        {
            label: '', nome: 'jurosEscolha', required: false, tipo: 'toggle', largura: 12, coluna: 1, linha: 1, defaultValueToggle: "jurosPorDia",
            visible: (modo == TipoFormulario.tpCadastro || modo == TipoFormulario.tpEdicao), opcoes: [{ label: "Juros por dia", valor: "jurosPorDia" }, { label: "Juros ao mês", valor: "jurosPorMes" }],
            onCampoDigitar: (e: any) => {
                setJurosPorDia(e == "jurosPorDia")
            }
        },
        { coluna: 2, label: 'Valor de juros ao dia', largura: 4, nome: 'valorJurosAoDia', tipo: 'money', linha: 2, required: false, visible: jurosPorDia, apenasLeitura: false },
        { coluna: 2, label: 'Juros', largura: 12, nome: 'juros', tipo: 'label', linha: 1, required: false, visible: true, apenasLeitura: true, subLabel: "Aplique juros quando o pagamento atrasar. O valor da parcela aumentará diariamente até ser quitado." },
        {
            coluna: 1, label: 'Juros ao mês', largura: 4, nome: 'jurosAoMes', tipo: 'percentual', linha: 2, required: false, visible: !jurosPorDia, ajudinha:
                { texto: "Esse valor representa o percentual de juros aplicado quando houver atraso no pagamento. Esse percentual é aplicado diariamente e considera-se um mês de 30 dias!" },
            onCampoDigitar(e) {
                const valorDescontoEmPorcetagem = e / 100;
                const percentualFinal = valorDescontoEmPorcetagem

                const valorFinal = percentualFinal > 0
                    ? valorAluguel * percentualFinal
                    : 0;

                setEntidadeParaAtualizarLocacao({ valorJurosAoMes: valorFinal });
                setForcarAtualizacaoDeEntidadeLocacao(true);
            },
        },
        { coluna: 2, label: 'Valor de juros ao mês', largura: 4, nome: 'valorJurosAoMes', tipo: 'money', linha: 2, required: false, visible: !jurosPorDia, apenasLeitura: true },
        { coluna: 2, label: 'Multa', largura: 12, nome: 'multa', tipo: 'label', linha: 3, required: false, visible: true, apenasLeitura: true, subLabel: "A multa será somada ao valor da parcela caso o pagamento seja feito após a data do vencimento." },
        {
            label: '', nome: 'multaEscolha', required: false, tipo: 'toggle', largura: 12, coluna: 1, linha: 4, defaultValueToggle: "multaPercentual",
            visible: (modo == TipoFormulario.tpCadastro || modo == TipoFormulario.tpEdicao), opcoes: [{ label: "Percentual", valor: "multaPercentual" }, { label: "Valor Fixo", valor: "multaFixo" }],
            onCampoDigitar: (e: any) => {
                setMultaPercentual(e == "multaPercentual")
            }
        },
        {
            coluna: 1, label: 'Valor percentual da multa', largura: 4, nome: 'multaPercentual', tipo: 'percentual', linha: 5, required: false, visible: multaPercentual, ajudinha:
                { texto: "Esse valor representa o percentual de multa aplicado quando houver atraso no pagamento." },
            onCampoDigitar(e) {
                const valorDescontoEmPorcetagem = e / 100;
                const percentualFinal = valorDescontoEmPorcetagem

                const valorFinal = percentualFinal > 0
                    ? valorAluguel * percentualFinal
                    : 0;

                setEntidadeParaAtualizarLocacao({ valorMulta: valorFinal });
                setForcarAtualizacaoDeEntidadeLocacao(true);
            },
        },
        { coluna: 2, label: 'Valor da multa', largura: 4, nome: 'valorMulta', tipo: 'money', linha: 5, required: false, visible: multaPercentual, apenasLeitura: true },
        { coluna: 1, label: 'Valor da multa', largura: 4, nome: 'multaFixa', tipo: 'money', linha: 5, required: false, visible: !multaPercentual, apenasLeitura: false },
        {
            label: 'Informações de Lançamentos', nome: '', required: true, tipo: 'label', largura: 12, coluna: 1, linha: 10,
            visible: !editandoAsaas && modo === TipoFormulario.tpCadastro
        },
        {
            label: "Marque se já recebeu o primeiro pagamento do aluguel", coluna: 1, largura: 12, linha: 10,
            visible: !editandoAsaas && modo === TipoFormulario.tpCadastro,
            nome: 'gerarPagamentoInicialComoPago', tipo: 'checkbox', required: false,
        },
        {
            label: `Marque se já recebeu o valor da ${nomeCaucao.minusculo}`, coluna: 1, largura: 12, linha: 12,
            visible: !editandoAsaas && modo === TipoFormulario.tpCadastro && !caucaoParcelada,
            nome: 'gerarLancamentoCaucaoComoPago', tipo: 'checkbox', required: false,
        },
        {
            label: "Definir todos os pagamentos desde o início da locação até hoje como recebido",
            coluna: 1,
            largura: 12,
            linha: 13,
            visible: (values) => {
                const dataPagamento = values.dataPagamento || values.dataInicio;
                if (!dataPagamento) return false;

                const dataLimpa = limparHorario(parseDateFromString(dataPagamento));
                const hojeLimpo = limparHorario(new Date());

                return (
                    modo === TipoFormulario.tpCadastro &&
                    dataLimpa < hojeLimpo
                );
            },
            nome: 'definirPagamentosAnteriorAHojeComoPago',
            tipo: 'checkbox',
            required: false,
            ajudinha: {
                texto: "Essa opção é ideal para cadastrar uma locação que já está em andamento..."
            }
        },
        {
            label: "Desejo gerar Pagamento único referente a todos os dias locados", coluna: 1, largura: 12, linha: 14, visible: (!editandoAsaas && (modo === TipoFormulario.tpCadastro) && tipoPeriodicidadePagamento == TipoPeriodicidadePagamento.Diario),
            nome: 'desejoGerarPagamentoUnico', tipo: 'checkbox', required: false,
            ajudinha: {
                texto: "Utilize esta opção para gerar um único pagamento referente à locação. Ou seja, caso a locação tenha X dias, o sistema multiplicará a quantidade de dias pelo valor da diária e criará um pagamento único para o dia de vencimento informado."
            },
        },
        {
            label: '', nome: 'contratoEscolha', required: false, tipo: 'toggle', largura: 12, coluna: 1, linha: 14, defaultValueToggle: "gerarContrato",
            // No onboarding com o contrato do locador já virado modelo, anexar faria perder o contrato
            // preenchido automaticamente (o ponto da etapa). Aí só gera.
            visible: !editandoAsaas && modo == TipoFormulario.tpCadastro && !(onboarding.ativo && onboarding.idModeloContrato), opcoes: [{ label: "Anexar Contrato", valor: "anexarContrato" }, { label: ehPlanoGratuito(token) ? "Gerar Contrato (Apenas Premium)" : "Gerar Contrato", valor: "gerarContrato" }],
            onCampoDigitar: (e: any) => {
                setGeraContrato(e == "gerarContrato");
            }
        },
        {
            label: 'Contrato', nome: 'documentoContrato', required: false, tipo: 'file', largura: 12, coluna: 1, linha: 15, visible: !geraContrato,
        },
        {
            label: onboarding.ativo && onboarding.idModeloContrato ? 'Seu contrato' : 'Modelo de Contrato', nome: 'modeloContrato', required: false, tipo: 'select', largura: 12, coluna: 1, linha: 16,
            novo: !onboarding.ativo, tutorialLink: onboarding.ativo ? undefined : "https://youtu.be/K--okUsfQxI",
            apenasLeitura: !!(onboarding.ativo && onboarding.idModeloContrato),
            visible: geraContrato && (!ehPlanoGratuito(token)), ajudinha: {
                texto: "Este campo define o modelo utilizado para a geração do contrato no sistema. Ao selecioná-lo, o contrato será criado automaticamente com base nas informações da locação",
                autoCloseTime: 3
            }, opcoes: modelosContratoOptions

        },
        { label: 'Id', nome: 'id', required: false, tipo: 'text', largura: 8, coluna: 1, linha: 16, visible: false, tudoMaiusculo: true },
        {
            linha: 17, coluna: 1, largura: 6,
            nome: 'idUsuario', label: 'Vendedor responsável',
            tipo: 'select' as const, required: false, visible: true,
            apenasLeitura: !isAdmin,
            opcoes: usuariosEmpresa.map(u => ({ label: u.nome, valor: u.id }))
        },
        {
            label: '', nome: '_toggleAvancadoLocacao', tipo: 'custom', required: false,
            largura: 12, coluna: 1, linha: 90,
            component: () => (
                <button
                    type="button"
                    tabIndex={onboarding.ativo ? -1 : undefined}
                    onClick={() => setMostrarAvancadoLocacao(!mostrarAvancadoLocacao)}
                    style={{ background: 'none', border: 'none', color: '#1F467E', cursor: 'pointer', fontSize: '1rem', padding: 0, textDecoration: 'underline' }}
                >
                    {mostrarAvancadoLocacao ? 'Ocultar opções avançadas' : 'Mostrar opções avançadas (Parcelamentos, Banco, etc...)'}
                </button>
            ),
        },
        {
            label: 'Atenção', nome: '_labelBancoInfo', tipo: 'label', required: false,
            largura: 12, coluna: 1, linha: 91, visible: () => mostrarAvancadoLocacao,
            subLabel: 'Esta seleção NÃO irá transferir valores de forma automática para a conta. Será apenas para facilitar a conciliação financeira.',
        },
        {
            label: 'Banco para Recebimento', nome: 'idBanco', tipo: 'select', required: false,
            largura: 12, coluna: 1, linha: 92, visible: () => mostrarAvancadoLocacao,
            selectBoxIsCleareable: true,
            opcoes: bancosOpcoes,
        },
        {
            label: 'Descrição customizada do aluguel (Asaas)', nome: 'descricaoCustomAluguel', tipo: 'text', required: false,
            largura: 12, coluna: 1, linha: 93,
            visible: () => mostrarAvancadoLocacao && asaasNestaLocacao,
            ajudinha: {
                texto: 'Opcional. Substitui o texto padrão "ALUGUEL - <PLACA>" usado nas cobranças de aluguel enviadas pelo Asaas. Não afeta a descrição da caução. Deixe em branco para usar o padrão.',
                autoCloseTime: 4
            }
        },
        {
            label: '', nome: '_toggleAvancadoContrato', tipo: 'custom', required: false,
            largura: 12, coluna: 1, linha: 50,
            component: () => (
                <button
                    type="button"
                    tabIndex={onboarding.ativo ? -1 : undefined}
                    onClick={() => setMostrarAvancadoContrato(!mostrarAvancadoContrato)}
                    style={{ background: 'none', border: 'none', color: '#1F467E', cursor: 'pointer', fontSize: '1rem', padding: 0, textDecoration: 'underline' }}
                >
                    {mostrarAvancadoContrato ? 'Ocultar opções avançadas' : 'Opções avançadas'}
                </button>
            ),
        },
        {
            label: 'Limite de Quilometragem', nome: 'limiteQuilometragem', tipo: 'number', required: false,
            largura: 6, coluna: 1, linha: 51,
            visible: () => mostrarAvancadoContrato,
            ajudinha: {
                texto: 'Km máximo permitido durante a locação. No encerramento, será verificado automaticamente se o locatário excedeu este limite.',
                autoCloseTime: 4
            }
        },
        {
            // Chave da caução: vale mesmo quando a locação inteira está marcada para não ir ao Asaas.
            label: `Cobrar a ${nomeCaucao.minusculo} no Asaas`, nome: '_cobrarCaucaoNoAsaasCheck', tipo: 'checkbox', required: false,
            largura: 12, coluna: 1, linha: 94,
            visible: () => mostrarAvancadoLocacao && integradoAsaas && valorCaucaoState > 0,
            // Só a criação gera a caução; depois o servidor preserva o que foi gravado.
            apenasLeitura: modo !== TipoFormulario.tpCadastro,
            onCampoDigitar: (v: boolean) => setCobrarCaucaoNoAsaas(v),
            ajudinha: {
                texto: `Independe da chave do rodapé, que vale para o aluguel. Serve para cobrar a ${nomeCaucao.minusculo} pelo Asaas numa locação acertada por fora, ou o contrário.`,
                autoCloseTime: 6
            }
        },
        {
            label: `Como você receberá a ${nomeCaucao.minusculo}?`, nome: 'caucaoTipoDePagamento', tipo: 'select', required: false,
            largura: 6, coluna: 1, linha: 94, opcoes: BillingTypeOptionsComHeranca,
            // Visível (e não escondido) mesmo com a chave desmarcada: escondê-lo fazia parecer que a
            // opção de escolher a forma de pagamento da caução não existia.
            visible: () => mostrarAvancadoLocacao && integradoAsaas && valorCaucaoState > 0,
            apenasLeitura: !cobrarCaucaoNoAsaas || modo !== TipoFormulario.tpCadastro,
            onCampoDigitar: (v: any) => setCaucaoTipoNoForm(v === null || v === undefined ? '' : String(v)),
            ajudinha: {
                texto: `Deixe em "Mesma do aluguel" para seguir a escolha feita acima. Cartão de Crédito com ${nomeCaucao.minusculo} parcelada gera um parcelamento de verdade no Asaas, em que o locatário passa o cartão uma vez só.`,
                autoCloseTime: 8
            }
        },
        {
            label: '', nome: '_caucaoDefinidaPorCobrancas', tipo: 'custom', required: false, largura: 12, coluna: 1, linha: 7,
            visible: () => cobrancasClassificadas.caucaoDefinidaPorCobrancas,
            component: () => (
                <div style={{
                    padding: '0.6rem 0.8rem', borderRadius: '6px', background: '#e9f5ff',
                    border: '1px solid #1F467E', fontSize: '0.85rem', color: '#495057',
                }}>
                    <strong style={{ color: '#212529' }}>
                        Caução de {cobrancasClassificadas.valorCaucao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                        {cobrancasClassificadas.caucoes.length > 1 ? ` em ${cobrancasClassificadas.caucoes.length} parcelas` : ''}
                    </strong>
                    <div style={{ marginTop: '2px' }}>
                        Definida pelas cobranças que você apontou no Asaas, com as datas e o pago de cada uma.
                        Nenhuma cobrança nova será emitida para ela.
                    </div>
                    <button
                        type="button"
                        className="btn btn-link"
                        style={{ padding: 0, fontSize: '0.8rem' }}
                        onClick={limparClassificacaoDeCaucao}
                    >
                        Informar a caução manualmente
                    </button>
                </div>
            ),
        },
        {
            label: `Marque caso a ${nomeCaucao.minusculo} tenha sido negociada (ex.: parcelamento)`, nome: '_caucaoParceladaCheck', tipo: 'checkbox', required: false,
            largura: 12, coluna: 1, linha: 95,
            // Negociação só vale na criação, quando os lançamentos da caução nascem; na edição ela já está
            // nos lançamentos da locação e mudar aqui não teria efeito.
            visible: () => mostrarAvancadoLocacao && valorCaucaoState > 0 && modo === TipoFormulario.tpCadastro,
            onCampoDigitar: (v: boolean) => setCaucaoParcelada(v),
            ajudinha: {
                texto: `Marque se a ${nomeCaucao.minusculo} foi negociada em parcelas. Você poderá configurar quantidade, datas e valores de cada parcela abaixo. Cada parcela vira um lançamento na categoria ${nomeCaucao.titulo}, e uma cobrança individual no Asaas quando a conta está integrada.`,
                autoCloseTime: 5
            }
        },
        {
            label: '', nome: '_caucaoParceladaEditor', tipo: 'custom', required: false,
            largura: 12, coluna: 1, linha: 96,
            visible: () => mostrarAvancadoLocacao && caucaoParcelada && valorCaucaoState > 0 && !cobrancasClassificadas.caucaoDefinidaPorCobrancas,
            // Componente importado (referência estável) — evita remount/perda de foco no input.
            // Metadados extras (integradoAsaas, callback) ficam em campo.extraProps.
            component: ParcelasCaucaoEditor,
            extraProps: {
                // A caução tem chave própria: o que importa aqui é a conta estar integrada e o
                // operador ter marcado "Cobrar a caução no Asaas", não a decisão do aluguel.
                integradoAsaas: integradoAsaas && cobrarCaucaoNoAsaas,
                tipoDePagamentoCaucao: caucaoTipoNoForm,
                onParcelasChange: handleParcelasCaucaoChange,
                parcelasCaucaoRef,
            },
        },
        {
            label: 'Lançamentos', nome: '_lancamentosLocacaoEditor', tipo: 'custom', required: false,
            largura: 12, coluna: 1, linha: 97,
            visible: () => mostrarAvancadoLocacao,
            subLabel: 'Adicione até 5 lançamentos (receitas ou despesas) vinculados a esta locação.',
            component: LancamentosLocacaoEditor,
            extraProps: {
                idEmpresa: obterIdTenent(token),
                idLocacao: modo === TipoFormulario.tpEdicao ? (locacaoSelecionado?.id) : undefined,
                // Idem para os lançamentos: cada um decide por si se vai ao Asaas.
                integradoAsaas,
                onChange: handleLancamentosLocacaoChange,
                lancamentosRef: lancamentosLocacaoRef,
            },
        },
        {
            label: `Definir comissão para esta unidade${filiaisComissao.find((x: any) => x.id === filialNoForm)?.nome ? ` (${filiaisComissao.find((x: any) => x.id === filialNoForm)?.nome})` : ''}`, nome: '_definirComissaoFilial', tipo: 'checkbox', required: false,
            largura: 12, coluna: 1, linha: 98,
            visible: () => mostrarAvancadoLocacao && !!filialNoForm,
            onCampoDigitar: (v: boolean) => {
                setDefinirComissaoFilial(v);
                if (v) {
                    const filial = filiaisComissao.find((x: any) => x.id === filialNoForm);
                    const tipoSugerido = Number(filial?.comissaoTipoCalculo) || 1;
                    setComissaoFilialTipo(tipoSugerido);
                    setEntidadeParaAtualizarLocacao((prev: any) => ({
                        ...prev,
                        comissaoFilialTipoCalculo: tipoSugerido,
                        comissaoFilialValor: filial?.comissaoValor ?? 0,
                    }));
                    setForcarAtualizacaoDeEntidadeLocacao(true);
                }
            },
            ajudinha: {
                texto: 'Comissão que esta unidade recebe nesta locação. Sugerida a partir da configuração da unidade. Você pode ajustar. Percentual incide sobre cada parcela; fixo é um valor por parcela.',
                autoCloseTime: 6
            }
        },
        {
            label: 'Tipo de comissão', nome: 'comissaoFilialTipoCalculo', tipo: 'select', required: false,
            largura: 6, coluna: 1, linha: 99,
            visible: () => mostrarAvancadoLocacao && !!filialNoForm && definirComissaoFilial,
            onCampoDigitar: (v: any) => setComissaoFilialTipo(Number(v) || 0),
            opcoes: [
                { label: 'Percentual (%)', valor: 1 },
                { label: 'Fixo (R$)', valor: 2 },
            ],
        },
        {
            label: 'Valor da comissão', nome: 'comissaoFilialValor', tipo: comissaoFilialTipo === 2 ? 'money' : 'percentual', required: false,
            largura: 6, coluna: 2, linha: 99,
            visible: () => mostrarAvancadoLocacao && !!filialNoForm && definirComissaoFilial && comissaoFilialTipo !== 0,
        },
    ], [
        veiculosOptions,
        veiculosOptionsFiltrados,
        locatariosOptions,
        locatariosOptionsFiltrados,
        modo,
        tipoPeriodicidadePagamento,
        desejoDefinirDias,
        novoVeiculo,
        marcas,
        modelos,
        tipoVeiculo,
        carregandoSelect,
        consultandoPlaca,
        novoLocatario,
        mascaraDocumento,
        estados,
        estado,
        cidades,
        geraContrato,
        valorAluguel,
        multaPercentual,
        entidadeParaAtualizarLocacao,
        forcarAtualizacaoDeEntidadeLocacao,
        jurosPorDia,
        integradoAutentique,
        editandoAsaas,
        mostrarAvancadoLocacao,
        mostrarAvancadoContrato,
        bancosOpcoes,
        asaasNestaLocacao,
        cobrarCaucaoNoAsaas,
        caucaoTipoNoForm,
        caucaoParcelada,
        valorCaucaoState,
        cobrancasClassificadas,
        limparClassificacaoDeCaucao,
        handleParcelasCaucaoChange,
        handleLancamentosLocacaoChange,
        locacaoSelecionado,
        token,
        usuariosEmpresa,
        isAdmin,
        filialNoForm,
        definirComissaoFilial,
        comissaoFilialTipo,
        filiaisComissao,
        empresaTemFiliais,
        filiaisOptions,
        filialSelecionada,
        calcularOpcoesPrazoMinimo,
        // Sem estas, o bloco de escolha de assinatura não reagiria à resposta do Asaas.
        classificacaoAssinaturas,
        cobrancasIndisponiveisCriacao,
        carregandoAssinaturasAsaas,
        assinaturaEscolhida,
        atualizarFaturasEmAberto,
        importarPagasAnterioresAoInicio,
        valorAluguel,
        integradoAsaas,
        enviarParaAsaas,
        consultarAssinaturasDoLocatario,
        registrarCampoNovoLocatario,
        cicloAsaasDaPeriodicidade,
        semVeiculoLivre,
    ]);

    useEffect(() => {
        if (forcarAtualizacaoDeEntidadeNoModalGerarContrato) {
            setForcarAtualizacaoDeEntidadeNoModalGerarContrato(false);
        }
    }, [forcarAtualizacaoDeEntidadeNoModalGerarContrato]);

    useEffect(() => {
        if (forcarAtualizacaoDeEntidadeNoModal) {
            setForcarAtualizacaoDeEntidadeNoModal(false);
        }
    }, [forcarAtualizacaoDeEntidadeNoModal]);

    useEffect(() => {
        if (forcarAtualizacaoDeEntidadeLocacao) {
            setForcarAtualizacaoDeEntidadeLocacao(false);
        }
    }, [forcarAtualizacaoDeEntidadeLocacao]);

    useEffect(() => {
        if (forcarAtualizacaoDeEntidadeAlterarData) {
            setForcarAtualizacaoDeEntidadeAlterarData(false);
        }
    }, [forcarAtualizacaoDeEntidadeAlterarData]);

    useEffect(() => {
        if (forcarAtualizacaoDeEntidadeVincularAsaas) {
            setForcarAtualizacaoDeEntidadeVincularAsaas(false);
        }
    }, [forcarAtualizacaoDeEntidadeVincularAsaas]);

    useEffect(() => {
        if (forcarAtualizacaoDeEntidadeNoModalPagamentos) {
            setForcarAtualizacaoDeEntidadeNoModalPagamentos(false);
        }
    }, [forcarAtualizacaoDeEntidadeNoModalPagamentos]);

    useEffect(() => {
        if (forcarAtualizacaoDeEntidadeNoModalEncerramento) {
            setForcarAtualizacaoDeEntidadeNoModalEncerramento(false);
        }
    }, [forcarAtualizacaoDeEntidadeNoModalEncerramento]);

    const onSaveAlterarData = useCallback(async (entidade: any) => {
        try {
            setCarregandoAlterarDataPagamento(true);
            setIsSaving(true);

            const periodicidade = locacaoSelecionado.periodicidadePagamento;
            const gerarDiferenca = geraPagamentoDiferencaDias && Number(entidade.valorPagamentoDiferenca) > 0;

            const payload: any = {
                idLocacao: entidade.id,
                dataAPartir: entidade.dataPagamento,
                periodicidade,
                gerarDiferenca,
                dataPagamentoDiferenca: entidade.dataPagamentoDiferenca || formatDateToISOWithZeroTime(new Date()),
                valorDiferenca: Number(entidade.valorPagamentoDiferenca) || 0,
            };

            if (periodicidade === TipoPeriodicidadePagamento.Semanal) {
                payload.novoDiaSemana = entidade.diaSemana;
            } else if (periodicidade === TipoPeriodicidadePagamento.Mensal) {
                payload.novoDiaMes = Number(entidade.diaMes);
            } else if (periodicidade === TipoPeriodicidadePagamento.Quinzenal) {
                payload.novoDiaMes = Number(entidade.diaMes);
                if (locacaoSelecionado.dataSegundoPagamentoQuinzena != null) {
                    payload.novoDiaMes2 = Number(entidade.diaMes2);
                }
            }

            await api.put('/AtualizarDiaPagamento', payload, {
                headers: { 'Content-Type': 'application/json' },
            });

            toast.success("O Dia do Pagamento atualizado com sucesso!");
            setExibirFormModalAlterarDataPagamento(false);
            setCarregando(false);
            setIsSaving(false);
            setCarregandoAlterarDataPagamento(false);
            setRealizarConsulta(true);
        } catch (error: any) {
            tratarErro(error);
        } finally {
            setIsSaving(false);
        }
    }, [locacaoSelecionado, geraPagamentoDiferencaDias]);

    const onSaveAlterarValorPagamento = useCallback(async (entidade: any) => {
        try {
            setCarregandoAlterarValorPagamento(true);
            setIsSaving(true);
            const valorPagamento = entidade.valorAluguelNovo || 0;

            await api.put(`/AtualizarValorPagamento/${entidade.id}/${entidade.dataPagamento}/${valorPagamento}`, null, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            toast.success("O valor do aluguel atualizado com sucesso!");
            setExibirFormModalAlterarValorPagamento(false);
            setCarregando(false);
            setIsSaving(false);
            setCarregandoAlterarValorPagamento(false);
            setRealizarConsulta(true);
        } catch (error: any) {
            tratarErro(error);
        } finally {
            setIsSaving(false);
        }
    }, []);

    // Sugere a data de encerramento a partir do início da locação + prazo, respeitando a
    // periodicidade do prazo. Retorna '' quando não há prazo válido (deixa a decisão de
    // marcar/desmarcar o encerramento para o chamador — nunca sugere a própria data de início).
    const calcularDataEncerramentoSugerida = useCallback((loc: any): string => {
        const iso = loc?.dataInicio ? String(loc.dataInicio) : '';
        const datePart = iso.length >= 10 ? iso.substring(0, 10) : '';
        if (!datePart) return '';
        const [y, m, d] = datePart.split('-').map(Number);

        // tempoContratoEmMeses pode chegar como objeto { value, unit } ou como string JSON.
        let prazo: any = loc?.tempoContratoEmMeses;
        if (typeof prazo === 'string') {
            try { prazo = JSON.parse(prazo); } catch { prazo = null; }
        }
        const qtd = Number(prazo?.value ?? prazo) || 0;
        if (qtd <= 0) return '';
        const unidade = loc?.tipoPeriodicidadeTempoContrato ?? prazo?.unit;

        const fim = new Date(y, (m - 1), d);
        switch (unidade) {
            case TipoPeriodicidadePagamento.Semanal: fim.setDate(fim.getDate() + qtd * 7); break;
            case TipoPeriodicidadePagamento.Quinzenal: fim.setDate(fim.getDate() + qtd * 15); break;
            case TipoPeriodicidadePagamento.Diario: fim.setDate(fim.getDate() + qtd); break;
            case TipoPeriodicidadePagamento.Mensal:
            default: {
                // Somar meses com clamp de fim de mês, igual ao AddMonths do backend
                // (31/jan + 1 mês = 28/fev, não 03/mar como faria Date.setMonth cru).
                const alvo = new Date(y, (m - 1) + qtd, 1);
                const ultimoDia = new Date(alvo.getFullYear(), alvo.getMonth() + 1, 0).getDate();
                fim.setFullYear(alvo.getFullYear(), alvo.getMonth(), Math.min(d, ultimoDia));
                break;
            }
        }
        return `${fim.getFullYear()}-${String(fim.getMonth() + 1).padStart(2, '0')}-${String(fim.getDate()).padStart(2, '0')}`;
    }, []);

    const atualizarCamposVincularAsaas = useCallback(() => {
        // A decisão sobre assinatura existente acontece AQUI, antes de qualquer escrita: o preview
        // (endpoint que já existia e a tela não usava) traz as assinaturas do cliente classificadas.
        setClassificacaoAssinaturas(null);
        setAssinaturaEscolhida(null);
        setAtualizarFaturasEmAberto(false);
        setImportarPagasAnterioresAoInicio(false);
        setPreviewVinculacao(null);
        setCarregandoAssinaturasAsaas(true);
        api.get(`/Locacao/PreviewVinculacaoAsaas/${locacaoSelecionado.id}`)
            .then((res) => {
                setPreviewVinculacao(res.data);
                setClassificacaoAssinaturas(res.data?.assinaturasDoCliente ?? null);
                // Reaproveitar é o padrão quando há exatamente uma candidata: é o que evita a duplicata
                // e preserva os boletos já entregues. Com mais de uma, o operador escolhe.
                const candidatas = (res.data?.assinaturasDoCliente?.assinaturas ?? []).filter((a: any) => a.podeReaproveitar && a.origem !== 1);
                setAssinaturaEscolhida(candidatas.length === 1 ? candidatas[0].assinatura.id : null);
            })
            .catch(() => setClassificacaoAssinaturas({ assinaturas: [], consultaIndisponivel: true }))
            .finally(() => setCarregandoAssinaturasAsaas(false));

        const temTermino = !!locacaoSelecionado.dataTermino;
        // Se já há término, pré-marca com essa data; senão, tenta a data calculada pelo prazo.
        // Sem término e sem prazo válido → deixa DESMARCADO (contrato indeterminado), nunca
        // sugere a própria data de início (que faria o backend não criar assinatura futura).
        const dataSugerida = temTermino
            ? String(locacaoSelecionado.dataTermino).substring(0, 10)
            : calcularDataEncerramentoSugerida(locacaoSelecionado);
        const definir = temTermino || !!dataSugerida;
        setDefinirEncerramentoAsaas(definir);
        setEntidadeParaAtualizarVincularAsaas({
            desejoDefinirEncerramentoAsaas: definir,
            dataEncerramentoAsaas: dataSugerida,
        });
        setForcarAtualizacaoDeEntidadeVincularAsaas(true);
    }, [locacaoSelecionado, calcularDataEncerramentoSugerida]);

    const onSaveVincularAsaas = useCallback(async (entidade: any) => {
        const locacao = locacaoSelecionado;
        try {
            setCarregandoVincularAsaas(true);
            setIsSaving(true);

            const definir = !!entidade.desejoDefinirEncerramentoAsaas;
            const params = new URLSearchParams();
            params.append('definirEncerramento', String(definir));
            if (definir && entidade.dataEncerramentoAsaas) {
                params.append('dataEncerramento', String(entidade.dataEncerramentoAsaas).substring(0, 10));
            }

            if (assinaturaEscolhida) {
                params.append('reaproveitarSubscriptionId', assinaturaEscolhida);
                params.append('atualizarFaturasEmAberto', String(atualizarFaturasEmAberto));
                params.append('importarPagasAnterioresAoInicio', String(importarPagasAnterioresAoInicio));
            }

            const res = await api.post(`/Locacao/CriarAsssinaturaNoAsaas/${locacao.id}?${params.toString()}`);
            if (!res.data) {
                setExibirModalVincularAsaas(false);
                toast.error('Não foi possível vincular ao Asaas. Verifique se a conta Asaas está configurada corretamente para esta locação.');
                return;
            }
            setExibirModalVincularAsaas(false);

            // "Não foi possível verificar" é diferente de "não existe": antes, uma falha na consulta ao
            // Asaas fazia a tela seguir calada e uma assinatura duplicada passava despercebida.
            if (res.data?.consultaDeAssinaturasIndisponivel) {
                toast.warning('Não foi possível verificar se este cliente já possui outra assinatura ativa no Asaas. Confira no painel do Asaas para evitar cobrança duplicada.');
            }

            // A pergunta sobre assinatura antiga não acontece mais AQUI: ela é feita no modal, antes de
            // qualquer escrita (EscolhaAssinaturaAsaas). Perguntar depois significava já ter criado a
            // segunda assinatura — e a única saída oferecida era apagar a antiga com as cobranças dela.

            // Contrato já encerrado em relação à próxima data do ciclo: o backend gera apenas os
            // pagamentos retroativos em atraso e NÃO cria assinatura futura no Asaas (DTO vem sem
            // asaasSubscriptionId). Não anunciar "vinculada ao Asaas" nesse caso.
            if (!res.data?.asaasSubscriptionId) {
                toast.info('Pagamentos em atraso registrados. Nenhuma assinatura futura foi criada no Asaas (o contrato já se encerrou).');
                setRealizarConsulta(true);
                return;
            }
            toast.success(assinaturaEscolhida
                ? 'Locação vinculada à assinatura que já existia no Asaas'
                : 'Locação vinculada ao Asaas com sucesso');
            setRealizarConsulta(true);

            // Cobrança avulsa que o cliente já tinha (caução paga no painel, acerto por fora) não entra
            // pela assinatura: se sobrou alguma sem dono, pergunta agora, antes de o operador sair da tela.
            abrirConciliacaoCobrancas(locacao, true);
        } catch (err: any) {
            tratarErro(err);
        } finally {
            setIsSaving(false);
            setCarregandoVincularAsaas(false);
        }
    }, [locacaoSelecionado, assinaturaEscolhida, atualizarFaturasEmAberto, importarPagasAnterioresAoInicio]);

    /**
     * Conciliação manual: traz as cobranças do cliente no Asaas e deixa o operador dizer o que cada uma
     * é nesta locação. Chamada pelo menu da locação e oferecida logo depois de criar ou vincular, porque
     * é nesse instante que a cobrança avulsa já existente (caução paga no painel, acerto por fora) vira
     * cobrança duplicada sem ninguém perceber.
     *
     * Com somenteSeTiverDisponivel, só abre se houver cobrança sem dono: modal vazio ensina a fechar sem ler.
     */
    const abrirConciliacaoCobrancas = useCallback(async (locacao: Locacao, somenteSeTiverDisponivel = false) => {
        if (!locacao?.id) return;

        setLocacaoConciliacaoAsaas(locacao);
        setVinculosConciliacao({});
        setDadosConciliacao(null);
        setCarregandoConciliacao(true);
        if (!somenteSeTiverDisponivel) setExibirModalConciliacao(true);

        try {
            const res = await api.get(`/Locacao/ConciliacaoCobrancasAsaas/${locacao.id}`);
            const dados: ConciliacaoCobrancas = res.data;
            const temDisponivel = (dados?.cobrancas || []).some((c) => c.disponivel);

            if (somenteSeTiverDisponivel && !temDisponivel) return;

            // Sugestão de categoria já marcada: a cobrança cuja descrição CONTÉM o nome da categoria
            // ("CAUCAO PARCELA 2 DE 3" → CAUÇÃO) vem pré-escolhida para poupar cliques numa migração com
            // dezenas de cobranças. O card mostra exatamente o que será criado e a opção "Não trazer"
            // desfaz: a decisão continua do operador, só não começa em branco quando o nome bate.
            const sugestoes: Record<string, ChaveItem> = {};
            (dados?.cobrancas || []).forEach((c) => {
                if (c.disponivel && c.idCategoriaSugerida) sugestoes[c.id] = chaveDaCategoria(c.idCategoriaSugerida);
            });
            setVinculosConciliacao(sugestoes);

            setDadosConciliacao(dados);
            setExibirModalConciliacao(true);
        } catch (err: any) {
            // Falha de consulta precisa APARECER: concluir "não há nada a conciliar" é o erro que leva
            // à cobrança em dobro. No oferecimento automático não interrompe o fluxo, só avisa.
            if (somenteSeTiverDisponivel) {
                toast.warning('Não foi possível conferir as cobranças deste cliente no Asaas. Use "Conciliar cobranças do Asaas" no menu da locação antes de cobrar.');
            } else {
                setDadosConciliacao({ cobrancas: [], itens: [], consultaIndisponivel: true });
            }
        } finally {
            setCarregandoConciliacao(false);
        }
    }, []);

    const onSaveConciliacao = useCallback(async () => {
        const locacao = locacaoConciliacaoAsaas;
        if (!locacao?.id) return;

        const vinculos = Object.entries(vinculosConciliacao).map(([asaasPaymentId, chave]) => {
            if (ehChaveDeCategoria(chave)) {
                const [, idCategoria] = String(chave).split(':');
                return { asaasPaymentId, acao: AcaoConciliacao.CriarLancamento, idCategoria };
            }
            const [, tipo, idItem] = String(chave).split(':');
            return {
                asaasPaymentId,
                acao: AcaoConciliacao.VincularItemExistente,
                tipoItem: Number(tipo) as TipoItemConciliacao,
                idItem,
            };
        });

        if (!vinculos.length) {
            setExibirModalConciliacao(false);
            return;
        }

        try {
            setSalvandoConciliacao(true);
            const res = await api.post(`/Locacao/ConciliacaoCobrancasAsaas/${locacao.id}`, vinculos);
            const resultado = res.data || {};
            setExibirModalConciliacao(false);

            const partes: string[] = [];
            if (resultado.vinculados) partes.push(`${resultado.vinculados} cobrança(s) vinculada(s)`);
            if (resultado.lancamentosCriados) partes.push(`${resultado.lancamentosCriados} lançamento(s) criado(s)`);
            if (resultado.baixasAplicadas) partes.push(`${resultado.baixasAplicadas} baixa(s) aplicada(s)`);
            if (resultado.cobrancasRemovidas) partes.push(`${resultado.cobrancasRemovidas} cobrança(s) duplicada(s) removida(s)`);
            toast.success(partes.length ? partes.join(', ') : 'Nada foi alterado.');

            // Avisos ficam mais tempo na tela: são o que explica conciliação parcial e divergência de valor.
            (resultado.avisos || []).forEach((avisoTexto: string) => toast.warning(avisoTexto, { autoClose: 12000 }));

            setRealizarConsulta(true);
        } catch (err: any) {
            tratarErro(err);
        } finally {
            setSalvandoConciliacao(false);
        }
    }, [locacaoConciliacaoAsaas, vinculosConciliacao]);

    const camposConciliacao: Campo[] = useMemo(() => [
        {
            label: '', nome: '_conciliacaoCobrancas', tipo: 'custom', required: false, largura: 12, coluna: 1, linha: 1, visible: true,
            component: () => (
                <ConciliacaoCobrancasAsaasView
                    dados={dadosConciliacao}
                    carregando={carregandoConciliacao}
                    vinculos={vinculosConciliacao}
                    onAlterarVinculo={(idCobranca, chave) => setVinculosConciliacao((anterior) => {
                        const proximo = { ...anterior };
                        if (!chave) delete proximo[idCobranca];
                        else proximo[idCobranca] = chave;
                        return proximo;
                    })}
                />
            ),
        },
    ], [dadosConciliacao, carregandoConciliacao, vinculosConciliacao]);

    const carregarHistoricoSubstituicao = useCallback(async (idLocacao: string) => {
        try {
            const response = await api.get(`/Locacao/HistoricoSubstituicaoVeiculo/${idLocacao}`);
            setHistoricoSubstituicao(response.data || []);
        } catch {
            setHistoricoSubstituicao([]);
        }
    }, []);

    const abrirModalSubstituirVeiculo = useCallback(() => {
        setNovoVeiculoSelecionado('');
        // Agora em hora LOCAL (toISOString usa UTC e, depois das 21h no Brasil, sugeria o dia seguinte).
        // A troca tem hora: é ela que diz qual veículo estava com o locatário no instante de uma multa.
        const agora = new Date();
        agora.setMinutes(agora.getMinutes() - agora.getTimezoneOffset());
        setDataSubstituicao(agora.toISOString().substring(0, 16));
        setKmFinalVeiculoAtual('');
        setKmInicialNovoVeiculo('');
        carregarHistoricoSubstituicao(locacaoSelecionado.id);
    }, [locacaoSelecionado, carregarHistoricoSubstituicao]);

    const onSaveSubstituirVeiculo = useCallback(async () => {
        try {
            if (!novoVeiculoSelecionado) {
                toast.error('Selecione o novo veículo.');
                return;
            }
            if (!dataSubstituicao) {
                toast.error('Informe a data da substituição.');
                return;
            }
            setCarregandoSubstituirVeiculo(true);

            let urlSubstituir = `/Locacao/SubstituirVeiculo/${locacaoSelecionado.id}/${novoVeiculoSelecionado}?dataSubstituicao=${dataSubstituicao}`;
            if (kmFinalVeiculoAtual) urlSubstituir += `&kmFinalVeiculoAnterior=${parseInt(kmFinalVeiculoAtual, 10)}`;
            if (kmInicialNovoVeiculo) urlSubstituir += `&kmInicialVeiculoNovo=${parseInt(kmInicialNovoVeiculo, 10)}`;
            await api.put(urlSubstituir);

            toast.success("Veículo substituído com sucesso!");
            await carregarHistoricoSubstituicao(locacaoSelecionado.id);
            setNovoVeiculoSelecionado('');
            setKmFinalVeiculoAtual('');
            setKmInicialNovoVeiculo('');
            setCarregandoSubstituirVeiculo(false);
            setRealizarConsulta(true);
        } catch (error: any) {
            tratarErro(error);
            setCarregandoSubstituirVeiculo(false);
        }
    }, [locacaoSelecionado, novoVeiculoSelecionado, dataSubstituicao, kmFinalVeiculoAtual, kmInicialNovoVeiculo, carregarHistoricoSubstituicao]);

    const handleVisualizarPagamentos = (idLocacao: string) => {
        const urlMontada = `/pagamento?locacao=${idLocacao}`;
        window.open(urlMontada, '_blank', 'noopener,noreferrer');
    };

    const gerarContrato = async (entidade: any) => {
        try {
            setCarregandoGerarContrato(true);

            // Se já existe um contrato vinculado, perguntar se substitui ou adiciona como novo
            const jaTemContrato = !!locacaoSelecionado?.documentoContrato || !!locacaoSelecionado?.autentiqueDocumentId;
            if (jaTemContrato) {
                setEscolhaContratoModeloId(entidade.modeloContrato);
                escolhaGerarContratoRef.current = { adicionarComoNovo: false, nome: '', descricao: '', naoEnviarAssinatura: false };
                setExibirGerarContrato(false);
                setCarregandoGerarContrato(false);
                setExibirEscolhaContrato(true);
                return;
            }

            // Caminho normal: verificar variáveis e gerar
            await prosseguirGerarContrato(entidade.modeloContrato, false, '', '');
        } catch (error: any) {
            tratarErro(error);
        } finally {
            setCarregandoGerarContrato(false);
        }
    };

    /**
     * Continua o fluxo de gerar contrato após o usuário escolher entre substituir o existente
     * ou adicionar como novo documento. Verifica variáveis pendentes e dispara a geração.
     *
     * Importante: esta função NÃO captura exceções — quem a chama (tipicamente o componente
     * ModalEscolhaGerarContrato) precisa que a Promise rejeite para liberar o spinner.
     * Erros ainda assim chegam ao toast porque finalizarGeracaoContrato/api propagam.
     */
    const prosseguirGerarContrato = async (
        idModeloContrato: string,
        adicionarComoNovoDocumento: boolean,
        nomeNovoDocumento: string,
        descricaoNovoDocumento: string,
        naoEnviarAssinatura: boolean = false,
    ) => {
        // Garante que o modal de variáveis manuais será tratado como "gerar contrato" (não "salvar locação")
        cenarioVariaveisManuaisRef.current = 'gerar-contrato';
        // Persiste a escolha na ref — usada pelo onSave do modal de variáveis manuais
        escolhaGerarContratoRef.current = {
            adicionarComoNovo: adicionarComoNovoDocumento,
            nome: nomeNovoDocumento,
            descricao: descricaoNovoDocumento,
            naoEnviarAssinatura,
        };

        setCarregandoGerarContrato(true);
        try {
            const verificacao = await api.post(`/Locacao/VerificarVariaveisContrato/${locacaoSelecionado.id}/${idModeloContrato}`);
            const variaveis: { chave: string; descricao: string; isCustomizada?: boolean; isRequired?: boolean }[] = verificacao.data || [];

            if (variaveis.length > 0) {
                setModeloContratoSelecionadoId(idModeloContrato);
                setVariaveisPendentes(variaveis);
                setEscolhaContratoModeloId(idModeloContrato);
                setExibirGerarContrato(false);
                setExibirEscolhaContrato(false);
                setExibirModalVariaveisManuais(true);
                return;
            }

            await finalizarGeracaoContrato(idModeloContrato, {}, adicionarComoNovoDocumento, nomeNovoDocumento, descricaoNovoDocumento, naoEnviarAssinatura);
            setExibirEscolhaContrato(false);
        } catch (error: any) {
            tratarErro(error);
            throw error; // re-throw para o componente filho liberar o spinner
        } finally {
            setCarregandoGerarContrato(false);
        }
    };

    const finalizarGeracaoContrato = async (
        idModeloContrato: string,
        manuais: Record<string, string>,
        adicionarComoNovoDocumento: boolean = false,
        nomeNovoDocumento: string = '',
        descricaoNovoDocumento: string = '',
        naoEnviarParaAssinatura: boolean = false,
    ) => {
        try {
            setCarregandoGerarContrato(true);

            const body = {
                valoresManuais: manuais,
                adicionarComoNovoDocumento,
                nomeNovoDocumento: adicionarComoNovoDocumento ? nomeNovoDocumento : null,
                descricaoNovoDocumento: adicionarComoNovoDocumento ? (descricaoNovoDocumento || null) : null,
                naoEnviarParaAssinatura,
            };

            const response = await api.post(
                `/Locacao/GerarContratoComOpcoes/${locacaoSelecionado.id}/${idModeloContrato}`,
                body
            );

            const urlContrato = response.data.link;
            setExibirModalVariaveisManuais(false);

            if (response.data.enviadoParaAssinatura) {
                const responseLink = adicionarComoNovoDocumento
                    ? await api.post(`/locacao/${locacaoSelecionado.id}/documentos/${response.data.idDocumento}/assinatura/link`)
                    : await api.post(`/Locacao/AssinarContratoGerarLink/${locacaoSelecionado.id}`);
                setLinkAssinatura(responseLink.data.link);
                setExibirLinkAssinaturaModal(true);
                setRealizarConsulta(true);
            } else {
                const desejaVisualizarContrato = await confirm("Contrato gerado com sucesso! Deseja visualizá-lo agora?");

                if (desejaVisualizarContrato) {
                    setTituloContratoVisualizador(`Contrato de ${locacaoSelecionado.locatario.nome}: ${locacaoSelecionado.veiculo.placa} - ${locacaoSelecionado.veiculo.marca} - ${locacaoSelecionado.veiculo.modelo} - ${locacaoSelecionado.veiculo.ano}`);
                    setLinkContratoPreview(urlContrato);
                    setRealizarConsulta(true);
                } else {
                    toast.success("Contrato gerado com sucesso!")
                    setRealizarConsulta(true);
                }
            }
        } catch (error: any) {
            tratarErro(error);
        } finally {
            setCarregandoGerarContrato(false);
        }
    };

    const exibirOpcoesAposCriarLocacao = async (
        verPagamentos: () => void,
        verContrato: () => void,
        verVistoria: () => void,
        criarLoginLocatario: () => void,
        assinarEGerarLink: () => void,
    ) => {
        await showButtonList({
            title: "Locação criada com sucesso!",
            message: "O que deseja fazer agora?",
            closeOnClick: false,
            buttons: [
                {
                    icon: <FaFileContract />,
                    title: "Ver Contrato",
                    onClick: verContrato,
                },
                {
                    icon: <FaMoneyBill />,
                    title: "Ver Pagamentos",
                    onClick: verPagamentos,
                },
                {
                    icon: <FaCheckCircle />,
                    title: "Realizar Vistoria",
                    onClick: verVistoria,
                },
                ...(usuarioTemPermissao(token, 'locatario_novo') || usuarioTemPermissao(token, 'locatario_editar') ? [{
                    icon: <FaMobileAlt />,
                    title: "Login no App",
                    onClick: criarLoginLocatario,
                }] : []),
                {
                    icon: <FaSignature />,
                    title: "Assinar Contrato",
                    onClick: assinarEGerarLink,
                },
            ],
        });
    };

    // Primeira locação do onboarding: nada de mensagem técnica, e uma saída quando o contrato falha.
    const onSaveRef = useRef<(entidade: any, deveInformarOId?: boolean, naoDeveValidarAlteracoesDePagamento?: boolean) => Promise<void>>();
    const tratarErroOnboarding = (error: any, entidade: any, enviouLocacao: boolean, deveInformarOId?: boolean, naoDeveValidarAlteracoesDePagamento?: boolean) => {
        const status = error?.response?.status;
        const bruta = error?.response ? extrairMensagemErroApi(error) : '';
        const tecnica = !error?.response || status >= 500 || pareceMensagemTecnica(bruta);
        const mensagem = tecnica
            ? 'Não conseguimos criar a locação agora. Confira a sua internet e tente de novo em instantes.'
            : bruta;

        // O contrato é gerado no envio da locação: com um modelo escolhido, qualquer falha ali pode ser
        // dele (modelo não encontrado, Word que não abre, falha ao baixar o modelo). A saída é criar a
        // locação sem o contrato; ele pode ser gerado depois pela tela de Locação.
        const falhaDoContrato = modo == TipoFormulario.tpCadastro && enviouLocacao && Boolean(entidade?.modeloContrato);
        rastrearTeste('onboarding_locacao_erro', { motivo: falhaDoContrato && onboarding.aoFalharContrato ? 'contrato' : tecnica ? 'servidor' : 'validacao' });
        if (falhaDoContrato && onboarding.aoFalharContrato) {
            const pareceDoContrato = error?.name == 'TemplateError' || /contrato|modelo|documento|word|docx|template/i.test(bruta);
            onboarding.aoFalharContrato({
                motivo: !tecnica && !pareceDoContrato ? mensagem : undefined,
                criarSemContrato: () => {
                    const { modeloContrato, ...semModelo } = entidade;
                    return onSaveRef.current?.({ ...semModelo, contratoEscolha: 'anexarContrato' }, deveInformarOId, naoDeveValidarAlteracoesDePagamento) ?? Promise.resolve();
                },
            });
            return;
        }
        toast.error(mensagem, { autoClose: 8000 });
    };

    const onSave = useCallback(async (entidade: any, deveInformarOId?: boolean, naoDeveValidarAlteracoesDePagamento?: boolean) => {
        if (isSaving) return;

        const cadastrandoLocatario = modo === TipoFormulario.tpCadastro && novoLocatario;
        const cadastrandoVeiculo = modo === TipoFormulario.tpCadastro && novoVeiculo;

        // ────────────────────────────────────────────────────────────────────────
        // Variáveis manuais do contrato (observacao/negociacao):
        // se o usuário escolheu um modelo e essa é a PRIMEIRA passada (ref vazia),
        // verifica se o template tem variáveis manuais. Se tiver, abre o modal de
        // preenchimento e PARA o submit. O modal salva os valores na ref e re-chama
        // este onSave — na segunda passada a ref está populada e o fluxo segue normal.
        // IMPORTANTE: setIsSaving(true) ANTES do await para travar o botão durante
        // a chamada de rede. Se for abrir o modal, libera o isSaving para que o
        // re-call do onSave (vindo do modal) não seja bloqueado pelo guard.
        // ────────────────────────────────────────────────────────────────────────
        if (entidade.modeloContrato && valoresManuaisContratoRef.current === null) {
            setIsSaving(true);
            try {
                const respVars = await api.get<{ chave: string; descricao: string; isCustomizada?: boolean; isRequired?: boolean }[]>(
                    `/Locacao/VariaveisManuaisDoModelo/${entidade.modeloContrato}`
                );
                const vars = respVars.data || [];
                if (vars.length > 0) {
                    cenarioVariaveisManuaisRef.current = 'salvar-locacao';
                    entidadeLocacaoPendenteRef.current = entidade;
                    setVariaveisPendentes(vars);
                    setExibirModalVariaveisManuais(true);
                    setIsSaving(false); // libera para o re-call vindo do modal
                    return;
                }
                // Sem vars manuais — marca como "já checado" para não re-verificar
                valoresManuaisContratoRef.current = {};
            } catch (e) {
                // Falha de verificação não bloqueia o salvar; segue sem manuais
                valoresManuaisContratoRef.current = {};
            }
        }

        // O cliente novo é cadastrado junto com a locação: sem nome ou CPF o servidor recusa com uma
        // mensagem técnica ("Campo 'Nome' obrigatório."). Aqui a pessoa recebe o que fazer.
        if (cadastrandoLocatario
            && (!String(entidade.nome ?? '').trim() || !String(entidade.documento ?? '').replace(/\D/g, ''))) {
            if (onboarding.ativo) rastrearTeste('onboarding_locacao_erro', { motivo: 'validacao' });
            toast.error('Faltam o nome e o CPF do cliente. Volte para a primeira parte (Dados) e preencha, ou use "Preencher pela CNH".', { autoClose: 8000 });
            return;
        }

        setIsSaving(true);

        let idNovoLocatario: number | null = null;
        let idNovoVeiculo: number | null = null;
        let locatarioCriado = false;
        let veiculoCriado = false;
        // Onboarding: a falha aconteceu já no envio da locação (é aí que o contrato é gerado).
        let enviouLocacao = false;

        try {
            if (!usuarioTemPermissao(token, 'locacao_novo') && !usuarioTemPermissao(token, 'locacao_editar')) {
                toast.error('Sem permissão para esta ação');
                return;
            }

            let locatario;
            if (cadastrandoLocatario) {
                locatario = await handleCriarLocatario(entidade);
                idNovoLocatario = locatario.id;
                locatarioCriado = true;
            }
            let veiculo;
            if (cadastrandoVeiculo) {
                veiculo = await handleCriarVeiculo(entidade);
                idNovoVeiculo = veiculo.id;
                veiculoCriado = true;
            }

            const locacaoASalvar: any = {
                idLocatario: cadastrandoLocatario ? idNovoLocatario : entidade['idLocatario'] || 0,
                idVeiculo: cadastrandoVeiculo ? idNovoVeiculo : entidade['idVeiculo'],
                valorAluguel: entidade['valorAluguel'] || 0,
                valorCaucao: entidade['valorCaucao'] || 0,
                diaPagamento: obterNumeroDoDia(new Date(entidade['dataPagamento'])) || obterNumeroDoDia(new Date(entidade['dataInicio'])),
                idEmpresa: obterIdTenent(token),
                dataInicio: entidade['dataInicio'],
                status: entidade['status'],
                kmInicial: entidade['kmInicial'] || 0,
                periodicidadePagamento: entidade['periodicidadePagamento'],
                tempoContratoEmMeses: deveInformarOId ? entidade['tempoContratoEmMeses'] : Number(entidade['tempoContratoEmMeses'].value),
                gerarLancamentoCaucaoComoPago: entidade['gerarLancamentoCaucaoComoPago'] || false,
                gerarPagamentoInicialComoPago: entidade['gerarPagamentoInicialComoPago'] || false,
                definirPagamentosAnteriorAHojeComoPago: entidade['definirPagamentosAnteriorAHojeComoPago'] || false,
                tipoPeriodicidadeTempoContrato: deveInformarOId ? entidade['tipoPeriodicidadeTempoContrato'] : Number(entidade['tempoContratoEmMeses'].unit),
                desejoGerarPagamentoUnico: entidade['desejoGerarPagamentoUnico'] || false,
                // O vencimento é por dia: sem data de pagamento informada, herda só o DIA da retirada, nunca a hora.
                dataPagamento: entidade['dataPagamento'] || (entidade['dataInicio'] ? String(entidade['dataInicio']).substring(0, 10) : null),
                dataSegundoPagamentoQuinzena: entidade['dataSegundoPagamentoQuinzena'] || null,
                ajusteDiaInexistente: Number(entidade['ajusteDiaInexistente']?.valor ?? entidade['ajusteDiaInexistente'] ?? 0),
                locacaoEmAndamento: entidade['locacaoEmAndamento'] || false,
                observacao: entidade['observacao'] || "",
                fiador: entidade['fiador'] || "",
                asaasTipoDePagamento: entidade['asaasTipoDePagamento'],
                // Vem do switch no rodapé, não de `campos`, então entra no payload à mão. Só faz
                // diferença na criação: no PUT o servidor descarta e mantém o valor persistido.
                integrarAoAsaas: enviarParaAsaas,
                // Escolha feita no formulário: usar uma assinatura que o locatário já tem no Asaas em vez
                // de criar outra. Só faz sentido na criação (no PUT o servidor ignora).
                reaproveitarAssinaturaAsaasId: enviarParaAsaas ? assinaturaEscolhida : null,
                atualizarFaturasEmAbertoDaAssinatura: atualizarFaturasEmAberto,
                importarPagasAnterioresAoInicio: importarPagasAnterioresAoInicio,
                // Chave e forma da caução: vêm do form, mas só fazem sentido com a conta integrada.
                // String vazia no select significa "herda do aluguel" e precisa virar null, senão o
                // backend gravaria 0 (= o locatário escolhe) e a herança sumiria.
                cobrarCaucaoNoAsaas: integradoAsaas ? cobrarCaucaoNoAsaas : null,
                caucaoTipoDePagamento: (integradoAsaas && cobrarCaucaoNoAsaas && entidade['caucaoTipoDePagamento'] !== '' && entidade['caucaoTipoDePagamento'] !== null && entidade['caucaoTipoDePagamento'] !== undefined)
                    ? Number(entidade['caucaoTipoDePagamento'])
                    : null,
                opcaoDeCompra: entidade['opcaoDeCompra'] || false,
                idBanco: entidade['idBanco'] || null,
                descricaoCustomAluguel: entidade['descricaoCustomAluguel']?.trim() || null,
                limiteQuilometragem: entidade['limiteQuilometragem'] ? Number(entidade['limiteQuilometragem']) : null,
                idFilial: entidade['idFilial'] || null,
                comissaoFilialTipoCalculo: (entidade['idFilial'] && definirComissaoFilial) ? (Number(entidade['comissaoFilialTipoCalculo']) || 0) : 0,
                comissaoFilialValor: (entidade['idFilial'] && definirComissaoFilial && (Number(entidade['comissaoFilialTipoCalculo']) || 0) > 0) ? (Number(entidade['comissaoFilialValor']) || 0) : null,
                // Caução definida por cobrança vai SEMPRE como parcelada, mesmo sendo uma só: o servidor
                // só lê ParcelasCaucao (e portanto o vínculo com o pay_) quando CaucaoParcelada é true.
                // Com false, ele montava a parcela sintética sem cobrança e emitia um boleto novo da
                // caução que o cliente já tinha pago — exatamente o que esta feature existe para evitar.
                caucaoParcelada: cobrancasClassificadas.caucaoDefinidaPorCobrancas
                    ? true
                    : caucaoParcelada,
                // ATENÇÃO: este endpoint usa multipart/form-data. ASP.NET [FromForm] não
                // deserializa string JSON em List<T>. Por isso enviamos as parcelas como
                // string em um campo separado parcelasCaucaoJson — o controller faz
                // o parse manualmente e popula locacao.ParcelasCaucao antes do service.
                // Caução vinda das cobranças do Asaas: cada parcela leva o pay_ que já existe, e o
                // servidor amarra em vez de emitir. Uma parcela só também vai como parcelamento de 1,
                // porque é o formato que carrega o vínculo.
                parcelasCaucaoJson: cobrancasClassificadas.caucaoDefinidaPorCobrancas
                    ? JSON.stringify(cobrancasClassificadas.parcelasCaucao)
                    : (caucaoParcelada
                        ? JSON.stringify(parcelasCaucaoRef.current.map(p => ({ data: p.data, valor: p.valor, pago: p.pago })))
                        : null),
                // Cobranças que o operador classificou como aluguel: o servidor casa cada uma com a
                // parcela do mesmo ciclo depois de gerar o cronograma.
                cobrancasDeAluguelJson: cobrancasClassificadas.idsDeAluguel.length > 0
                    ? JSON.stringify(cobrancasClassificadas.idsDeAluguel)
                    : null,
                // null quando a seção nunca foi aberta (ref intacto) → backend não mexe nos avulsos.
                // Lista (mesmo vazia) → backend reconcilia para exatamente este conjunto.
                lancamentosJson: (lancamentosLocacaoRef.current === null && cobrancasClassificadas.linhasDeLancamento.length === 0)
                    ? null
                    : JSON.stringify([...cobrancasClassificadas.linhasDeLancamento, ...(lancamentosLocacaoRef.current ?? []).map(l => ({
                        id: l.id,
                        valor: l.valor,
                        descricao: l.descricao,
                        vencimento: l.vencimento,
                        idsCategorias: l.idsCategorias,
                        tipo: l.tipo,
                        pago: l.pago,
                        dataPagamento: l.pago ? (l.dataPagamento ?? null) : null,
                        cobrarNoAsaas: l.cobrarNoAsaas,
                        tipoDePagamento: l.tipoDePagamento ?? null,
                    }))]),
            };

            // Caução definida pelas cobranças: o campo nem aparece na tela, então o valor vem da soma.
            if (cobrancasClassificadas.caucaoDefinidaPorCobrancas) {
                locacaoASalvar.valorCaucao = cobrancasClassificadas.valorCaucao;
            }

            // Validação local das parcelas da caução antes de enviar ao backend
            if (caucaoParcelada && !cobrancasClassificadas.caucaoDefinidaPorCobrancas) {
                const valorCaucaoTotal = Number(entidade['valorCaucao']) || 0;
                const parcelas = parcelasCaucaoRef.current;
                if (valorCaucaoTotal <= 0) {
                    toast.warning('Informe o valor da caução antes de parcelar.');
                    setIsSaving(false);
                    return;
                }
                if (!parcelas.length || parcelas.some(p => p.valor <= 0)) {
                    toast.warning('Todas as parcelas da caução devem ter valor maior que zero.');
                    setIsSaving(false);
                    return;
                }
                const soma = parcelas.reduce((acc, p) => acc + p.valor, 0);
                if (Math.abs(soma - valorCaucaoTotal) > 0.01) {
                    toast.warning(`A soma das parcelas (${soma.toFixed(2)}) não bate com o valor da caução (${valorCaucaoTotal.toFixed(2)}).`);
                    setIsSaving(false);
                    return;
                }
            }

            locacaoASalvar.valorJurosAoDia = Number(entidade['valorJurosAoDia']) || 0;
            locacaoASalvar.jurosAoMes = Number(entidade['jurosAoMes']) || 0;
            locacaoASalvar.multaFixa = Number(entidade['multaFixa']) || 0;
            locacaoASalvar.multaPercentual = Number(entidade['multaPercentual']) || 0;

            if (entidade.asaasSubscriptionId) {
                locacaoASalvar.asaasSubscriptionId = entidade.asaasSubscriptionId;
            }

            const alteracoesQueVaoAfetarPagamentos: AlteracaoPagamento[] = [];
            let vaiRegerarPagamentos = false;

            if (!naoDeveValidarAlteracoesDePagamento && (entidade.status == StatusLocacao.Ativa && (modo === TipoFormulario.tpEdicao || deveInformarOId))) {
                const apenasTempoAlterado =
                    locacaoSelecionado.tempoContratoEmMeses != locacaoASalvar.tempoContratoEmMeses &&
                    locacaoSelecionado.tipoPeriodicidadeTempoContrato === locacaoASalvar.tipoPeriodicidadeTempoContrato &&
                    locacaoSelecionado.periodicidadePagamento === locacaoASalvar.periodicidadePagamento &&
                    locacaoSelecionado.valorAluguel === locacaoASalvar.valorAluguel;

                if (apenasTempoAlterado && locacaoASalvar.tempoContratoEmMeses > locacaoSelecionado.tempoContratoEmMeses) {
                    const tentandoProlongar = await confirm("Você está tentando prologar a locação?");
                    if (tentandoProlongar) {
                        setLocacaoSelecionado(entidade);
                        setExibirFormModalPagamentos(true);
                        toast.info("Utilize essa tela para prolongar a locação. Acessível através dos 3 pontinhos ao lado das opções de visualização, edição e exclusão.")
                        setExibirFormModal(false);
                        return;
                    }
                }

                const obj = typeof locacaoSelecionado.tempoContratoEmMeses === 'string'
                    ? JSON.parse(locacaoSelecionado.tempoContratoEmMeses)
                    : locacaoSelecionado.tempoContratoEmMeses;

                if (locacaoSelecionado.periodicidadePagamento != locacaoASalvar.periodicidadePagamento) {
                    alteracoesQueVaoAfetarPagamentos.push({
                        titulo: "Recorrência de Recebimentos",
                        de: converterPeriodicidadePagamentoParaTexto(locacaoSelecionado.periodicidadePagamento) ?? "",
                        para: converterPeriodicidadePagamentoParaTexto(locacaoASalvar.periodicidadePagamento) ?? "",
                    });
                    vaiRegerarPagamentos = true;

                }

                if (locacaoSelecionado.tempoContratoEmMeses.value != locacaoASalvar.tempoContratoEmMeses || locacaoSelecionado.tempoContratoEmMeses.unit != locacaoASalvar.tipoPeriodicidadeTempoContrato) {
                    alteracoesQueVaoAfetarPagamentos.push({
                        titulo: "Duração do Contrato",
                        de: `${obj.value} ${converterPeriodicidadeTempoParaTexto(obj.unit)}`,
                        para: `${locacaoASalvar.tempoContratoEmMeses} ${converterPeriodicidadeTempoParaTexto(locacaoASalvar.tipoPeriodicidadeTempoContrato)}`,
                    });
                    vaiRegerarPagamentos = true;
                }

                if (locacaoSelecionado.valorAluguel != locacaoASalvar.valorAluguel) {
                    alteracoesQueVaoAfetarPagamentos.push({
                        titulo: "Valor do Aluguel",
                        de: formatarParaReais(locacaoSelecionado.valorAluguel),
                        para: formatarParaReais(locacaoASalvar.valorAluguel),
                    });
                }

                // O backend também regenera os pagamentos quando a data do primeiro pagamento muda.
                const parseDia = (valor: any) => valor ? parseDateFromString(String(valor).substring(0, 10)) : null;
                const dataPagamentoOriginal = parseDia(locacaoSelecionado.dataPagamento || locacaoSelecionado.dataInicio);
                const dataPagamentoNova = parseDia(entidade['dataPagamento'] || entidade['dataInicio']);
                if (dataPagamentoOriginal && dataPagamentoNova && dataPagamentoOriginal.getTime() !== dataPagamentoNova.getTime()) {
                    alteracoesQueVaoAfetarPagamentos.push({
                        titulo: "Data do Primeiro Pagamento",
                        de: formatarData(dataPagamentoOriginal),
                        para: formatarData(dataPagamentoNova),
                    });
                    vaiRegerarPagamentos = true;
                }

            }

            if (entidade.dataTermino) {
                if (new Date(entidade.dataTermino) < new Date(entidade.dataInicio)) {
                    toast.info('A data de término da locação deve ser posterior a data de início.');
                    return;
                }

                // Locação com assinatura: a data de encerramento é o término da assinatura no Asaas. A
                // edição comum não sincroniza esse campo (o backend recusa), então uma data nova vai
                // para "Nova Previsão de Encerramento", que atualiza o Asaas antes de gravar. Data no
                // passado segue o caminho normal: é encerramento, e esse a edição trata. O "Encerrar
                // Locação" também passa por aqui (status Encerrada) e nunca deve ser desviado.
                const terminoNovo = String(entidade.dataTermino).substring(0, 10);
                const terminoAtual = locacaoSelecionado.dataTermino ? String(locacaoSelecionado.dataTermino).substring(0, 10) : '';
                const agora = new Date();
                const hojeIso = new Date(agora.getTime() - agora.getTimezoneOffset() * 60000).toISOString().substring(0, 10);
                if (modo === TipoFormulario.tpEdicao && locacaoSelecionado.asaasSubscriptionId
                    && entidade.status != StatusLocacao.Encerrada
                    && terminoNovo !== terminoAtual && terminoNovo >= hojeIso) {
                    const abrir = await confirm('Esta locação tem assinatura no Asaas, e a data de encerramento é o término da assinatura. A alteração é feita em "Nova Previsão de Encerramento", que atualiza o Asaas junto. Abrir agora com a data informada?');
                    if (abrir) {
                        dataSugeridaNovaPrevisao.current = terminoNovo;
                        setExibirFormModal(false);
                        setExibirModalNovaPrevisaoEncerramento(true);
                    }
                    return;
                }

                const dataTermino = new Date(entidade.dataTermino);
                const hoje = new Date();

                hoje.setHours(0, 0, 0, 0);
                const dataTerminoSemHoras = new Date(dataTermino);
                dataTerminoSemHoras.setHours(0, 0, 0, 0);


                if (asaasNestaLocacao && dataTerminoSemHoras >= hoje) {
                    locacaoASalvar.dataTermino = entidade.dataTermino;
                    if (entidade.kmFinal) {
                        locacaoASalvar.kmFinal = entidade.kmFinal;
                    }
                } else {
                    const kmFinal = entidade.kmFinal || 0;
                    if (kmFinal < entidade.kmInicial) {
                        toast.info('O Quilometragem final deve ser maior que o Quilometragem inicial da locação');
                        return;
                    }

                    locacaoASalvar.dataTermino = entidade.dataTermino;
                    locacaoASalvar.kmFinal = kmFinal;
                }
            }

            let continua = true;

            if (alteracoesQueVaoAfetarPagamentos.length > 0) {
                const dataBaseStr = entidade['dataPagamento'] || entidade['dataInicio'];
                const dataBase = dataBaseStr ? limparHorario(parseDateFromString(String(dataBaseStr).substring(0, 10))) : null;
                const locacaoComecouNoPassado = !!dataBase && dataBase < limparHorario(new Date());

                const opcoes = await confirmarEdicaoComRegeracaoDePagamentos({
                    alteracoes: alteracoesQueVaoAfetarPagamentos,
                    exibirOpcoesEmAndamento: vaiRegerarPagamentos && locacaoComecouNoPassado,
                });

                if (opcoes) {
                    locacaoASalvar.locacaoEmAndamento = opcoes.locacaoEmAndamento;
                    locacaoASalvar.definirPagamentosAnteriorAHojeComoPago = opcoes.definirPagamentosAnteriorAHojeComoPago;
                } else {
                    continua = false;
                }
            }

            if (continua) {
                const dadosASalvar = new FormData();

                Object.entries(locacaoASalvar).forEach(([key, value]) => {
                    if (value !== null && value !== undefined) {
                        if (value instanceof Date) {
                            dadosASalvar.append(key, value.toISOString());
                        } else {
                            dadosASalvar.append(key, typeof value === 'object' ? JSON.stringify(value) : String(value));
                        }
                    }
                });

                if (entidade.documentoContrato) {
                    dadosASalvar.append('documentoContrato', entidade.documentoContrato);
                }

                if (entidade.modeloContrato) {
                    dadosASalvar.append('modeloContrato', entidade.modeloContrato);
                }

                // Valores manuais do contrato (observacao/negociacao) coletados antes do submit
                if (valoresManuaisContratoRef.current && Object.keys(valoresManuaisContratoRef.current).length > 0) {
                    dadosASalvar.append('valoresManuaisJson', JSON.stringify(valoresManuaisContratoRef.current));
                }

                const documentoContratoRemoved = arquivoRemovido && !entidade.documentoContrato;
                dadosASalvar.append('removerDocumentoContrato', String(documentoContratoRemoved));

                if (deveInformarOId || modo == TipoFormulario.tpEdicao) {
                    dadosASalvar.append('id', entidade.id);
                }

                const apiAcao = modo === TipoFormulario.tpCadastro ? api.post : api.put;
                enviouLocacao = true;
                const response = await apiAcao('/locacao/ComDocumentoContrato', dadosASalvar, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });

                setExibirFormModal(false);
                setNovoLocatario(false);
                setNovoVeiculo(false);
                ultimoSalvamentoOkRef.current = true;
                toast.success('Locação salva com sucesso');

                // Fail-open + aviso: a locação foi salva localmente, mas a assinatura no Asaas pode não
                // ter sido atualizada (404 = vive em outra conta/filial; erro transitório do Asaas). Este
                // é o caminho REAL de save (onSave custom); o ModalForm não chama requisicaoBemSucedida
                // aqui, então o aviso PRECISA ser tratado neste ponto — senão o operador veria só o
                // toast de sucesso e não saberia que o valor/juros/multa divergem da cobrança no Asaas.
                const avisoAsaas = response?.data?.avisoAsaas ?? response?.data?.AvisoAsaas;
                if (avisoAsaas) {
                    toast.warning(avisoAsaas, { autoClose: false });
                }

                if (asaasNestaLocacao) {
                    toast.info('Atenção: O Asaas permite a geração de até 5 pagamentos por mês. Mas fique tranquilo: os demais pagamentos serão criados automaticamente à medida que forem sendo recebidos.', { autoClose: 15000 })
                }

                setRealizarConsulta(false);
                setRealizarConsulta(true);

                const idLocacao = response.data.id;

                // Grava o progresso do onboarding já agora: se a pessoa recarregar nos próximos
                // instantes, não volta para criar a mesma locação de novo.
                if (onboarding.ativo && modo == TipoFormulario.tpCadastro) onboarding.registrarLocacaoCriada?.(idLocacao);

                if (Boolean(entidade['vendeuVeiculo'])) {
                    venderVeiculo(locacaoASalvar.idVeiculo, idLocacao)
                } else {
                    setTimeout(async () => {
                        if (modo == TipoFormulario.tpCadastro) {
                            if (onboarding.ativo && onboarding.aoCriarLocacao) {
                                rastrearTeste('onboarding_locacao_criada', { comContrato: Boolean(entidade?.modeloContrato), veiculoNovo: cadastrandoVeiculo });
                                onboarding.aoCriarLocacao(idLocacao);
                                return;
                            }

                            const linkContrato = await obterDocumentoContrato(response.data);
                            exibirOpcoesAposCriarLocacao(
                                () => handleVisualizarPagamentos(idLocacao),
                                () => {
                                    if (linkContrato) {
                                        setTituloContratoVisualizador(`Contrato`);
                                        setLinkContratoPreview(linkContrato);
                                    } else {
                                        toast.info('Nenhum contrato foi gerado. Verifique se um modelo foi selecionado.');
                                    }
                                },
                                () => {
                                    const vistoria = `/vistoria?idLocacao=${idLocacao}&km=${locacaoASalvar.kmInicial}`;
                                    window.open(vistoria, '_blank');
                                },
                                () => {
                                    setLoginAppLocatarioId(String(locacaoASalvar.idLocatario));
                                    setExibirModalLoginApp(true);
                                },
                                async () => {
                                    try {
                                        const config = await api.get('ConfiguracaoFilial/ResolvidaAtual');
                                        const autentiqueApiKey = config.data.autentiqueConfigurado;

                                        if (autentiqueApiKey) {
                                            const responseLink = await api.post(`/Locacao/AssinarContratoGerarLink/${idLocacao}`);
                                            setLinkAssinatura(responseLink.data.link);
                                            setExibirLinkAssinaturaModal(true);
                                        } else {
                                            toast.info('Para realizar este procedimento, sua conta precisa estar integrada ao Autentique. Acesse Perfil > Integração para concluir a configuração');
                                        }
                                    } catch (error: any) {
                                        tratarErro(error);
                                    }
                                }
                            );
                        } else {
                            const confirmed = await confirm('Deseja visualizar os pagamentos?');
                            if (confirmed) {
                                handleVisualizarPagamentos(idLocacao);
                            }
                        }

                    }, 250);
                }
            } else {
                setIsSaving(false);
            }
        } catch (error: any) {
            if (onboarding.ativo) setCarregando(false);
            else tratarErro(error);
            try {
                if (locatarioCriado && idNovoLocatario) {
                    await api.delete(`/locatario/${idNovoLocatario}`);
                }
                if (veiculoCriado && idNovoVeiculo) {
                    await api.delete(`/veiculo/${idNovoVeiculo}`);
                }
            } catch (rollbackError) {
                console.error('Erro durante o rollback:', rollbackError);
                if (!onboarding.ativo) toast.error('Ocorreu um erro ao desfazer as alterações. Verifique os registros criados.');
            }
            // No onboarding o aviso vem depois do rollback: o cliente (e o veículo) criados nesta
            // tentativa já foram desfeitos, então tentar de novo não duplica o cadastro.
            if (onboarding.ativo) tratarErroOnboarding(error, entidade, enviouLocacao, deveInformarOId, naoDeveValidarAlteracoesDePagamento);
        } finally {
            setIsSaving(false);
            setArquivoRemovido(false);
            // Limpa as refs de variáveis manuais do contrato — próximo salvar começa do zero
            valoresManuaisContratoRef.current = null;
            entidadeLocacaoPendenteRef.current = null;
        }
    }, [
        isSaving,
        diaPrimeiroPagamento,
        diaSegundoPagamento,
        desejoDefinirDias,
        token,
        modo,
        arquivoRemovido,
        handleVisualizarPagamentos,
        novoLocatario,
        novoVeiculo,
    ]);
    onSaveRef.current = onSave;

    const handleCriarLocatario = async (entidade: any) => {
        if (novoLocatario) {
            const response = await api.post('/locatario', {
                idEmpresa: obterIdTenent(token),
                dataCadastro: new Date(),
                documento: entidade.documento,
                nome: entidade.nome,
                email: entidade.email,
                telefone: entidade.telefone,
                tipoDocumento: entidade.tipoDocumento,
                cep: entidade.cep,
                logradouro: entidade.logradouro,
                numero: entidade.numero,
                complemento: entidade.complemento,
                bairro: entidade.bairro,
                cidade: entidade.cidade,
                estado: entidade.estado,
                rg: entidade.rg,
                numeroRegistroCnh: entidade.numeroRegistroCnh,
                vencimentoHabilitacao: entidade.vencimentoHabilitacao || null,
                ...(entidade.idFilial ? { idFilial: entidade.idFilial } : {}),
            });
            return response.data;
        }
        return null;
    }

    const handleCriarVeiculo = async (entidade: any) => {
        if (novoVeiculo) {
            const formData = new FormData();
            formData.append("idEmpresa", obterIdTenent(token));
            formData.append("dataCadastro", new Date().toISOString());
            formData.append("placa", entidade.placa);
            formData.append("tipoVeiculo", entidade.tipoVeiculo);
            formData.append("marca", entidade.marca);
            formData.append("modelo", entidade.modelo);
            formData.append("ano", entidade.ano.toString());
            formData.append("renavam", entidade.renavam);
            formData.append("cor", entidade.cor);
            formData.append("chassi", entidade.chassi);
            if (entidade.idFilial) formData.append("idFilial", entidade.idFilial);

            const response = await api.post('/veiculo', formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            });

            return response.data;
        }
        return null;
    };

    const onSavePagamentos = useCallback(async (entidade: any, deveValidarId?: Boolean) => {
        if (isSavingPagamentos) return;

        setIsSavingPagamentos(true);

        try {
            const pagamentoUnico = entidade.desejoGerarPagamentoUnico;
            const dataPagamento = entidade.dataPagamento;
            let tipoPeriodicidade = entidade.tempoContratoEmMeses.unit;

            if (!tipoPeriodicidade) {
                tipoPeriodicidade = TipoPeriodicidadePagamento.Diario;
            }

            let quantidade = entidade.tempoContratoEmMeses.value;
            if (!quantidade) {
                quantidade = 1;
            }

            const queryParams = new URLSearchParams();

            if (pagamentoUnico !== undefined) {
                queryParams.append("pagamentoUnico", pagamentoUnico.toString());
            }

            if (dataPagamento) {
                // Só o dia, como string: new Date("YYYY-MM-DD") é meia-noite UTC e, serializado com "Z",
                // a API o lê como 21:00 do dia anterior.
                queryParams.append("dataPagamento", String(dataPagamento).substring(0, 10));
            }

            if (tipoPeriodicidade !== undefined) {
                queryParams.append("tipoPeriodicidade", tipoPeriodicidade.toString());
            }

            const response = await api.post(`/CriarPagamentosPrevistosPorTempo/${locacaoSelecionado.id}/${quantidade}?${queryParams.toString()}`);

            setRealizarConsulta(true);
            const estavaEncerrada = locacaoSelecionado.status === StatusLocacao.Encerrada;
            const avisoAsaas = response?.data?.avisoAsaas ?? response?.data?.AvisoAsaas;
            if (avisoAsaas) {
                toast.warning(avisoAsaas, { autoClose: false });
            } else {
                toast.success(estavaEncerrada ? 'Locação renovada e reativada com sucesso!' : 'Locação prolongada com sucesso!');
            }
            setExibirFormModalPagamentos(false);
        } catch (error: any) {
            tratarErro(error);
        } finally {
            setIsSavingPagamentos(false);
        }
    }, [isSavingPagamentos, locacaoSelecionado.id, locacaoSelecionado.status]);

    const onSaveNovaPrevisaoEncerramento = useCallback(async (entidade: any) => {
        if (salvandoNovaPrevisao) return;
        setSalvandoNovaPrevisao(true);
        try {
            // Só o dia, como string: new Date("YYYY-MM-DD") é meia-noite UTC e, serializado com "Z",
            // a API o lê como 21:00 do dia anterior (o endDate iria um dia antes para o Asaas).
            const novaData = String(entidade.novaDataEncerramento).substring(0, 10);
            await api.put(`/Locacao/AtualizarEndDateAssinatura/${locacaoSelecionado.id}`, { novaDataEncerramento: novaData });
            setRealizarConsulta(true);
            toast.success('Previsão de encerramento atualizada com sucesso! Os próximos pagamentos serão gerados automaticamente pelo Asaas conforme o ciclo da assinatura.', { autoClose: 10000 });
            setExibirModalNovaPrevisaoEncerramento(false);
        } catch (error: any) {
            tratarErro(error);
        } finally {
            setSalvandoNovaPrevisao(false);
        }
    }, [salvandoNovaPrevisao, locacaoSelecionado.id]);

    const tratarErro = useCallback((error: AxiosError<ApiError>) => {
        setCarregando(false);
        setIsSaving(false);
        setIsSavingPagamentos(false);
        setCarregandoAlterarDataPagamento(false);
        setCarregandoAlterarValorPagamento(false);

        if (error.name == 'TemplateError') {
            toast.error(`O seu modelo de contrato contém um erro. Verifique, no cadastro do modelo, se alguma variável está em um formato incorreto. O padrão esperado é: {nome_variavel}.`, { autoClose: 8000 });
            return;
        }

        const data = error.response?.data;

        if (data?.errors && typeof data.errors === 'object' && !Array.isArray(data.errors)) {
            const erros = data.errors as Record<string, string[]>;
            Object.keys(erros).forEach(campo => {
                erros[campo].forEach((msg: string) => toast.error(msg));
            });
            return;
        }

        const errorMessage = extrairMensagemErroApi(error);

        if (errorMessage.includes("Modelo de contrato sem documento anexado")) {
            setExibirFormModal(false);
            setRealizarConsulta(true);
            toast.success("A locação foi criada, configure o seu Modelo e acesso os 3 pontos > Gerar Contrato");
        }
        toast.error(`Não foi possível continuar a operação Locação: ${errorMessage}`);
    }, []);

    const handleFecharModal = useCallback(() => {
        setExibirFormModal(false);
        setNovoLocatario(false);
        setNovoVeiculo(false);
        setTipoPeriodicidadePagamento(TipoPeriodicidadePagamento.Nenhum);
        if (modo === TipoFormulario.tpEdicao || modo === TipoFormulario.tpCadastro) {
            setRealizarConsulta(true);
        }
    }, [modo]);

    const handleFecharModalPagamentos = useCallback(() => {
        setExibirFormModalPagamentos(false);
    }, []);

    const handleCadastrar = useCallback(() => {
        if (!usuarioTemPermissao(token, 'locacao_novo')) {
            toast.error('Você não tem permissão para cadastrar um nova locação');
            return;
        }

        setTipoPeriodicidadePagamento(TipoPeriodicidadePagamento.Nenhum);
        setOpcoesPrazoMinimo(OPCOES_PRAZO_TODAS);
        setFilialNoForm(filialSelecionada || null);

        setModo(TipoFormulario.tpCadastro);
        // Zera a escolha de assinatura do Asaas: sem isto, a decisão do cadastro anterior continuava no
        // estado e a guarda por locatário impedia nova consulta, então o POST seguinte enviava uma
        // assinatura que já tinha dono e o servidor abortava a criação inteira.
        setClassificacaoAssinaturas(null);
        setAssinaturaEscolhida(null);
        setAtualizarFaturasEmAberto(false);
        setImportarPagasAnterioresAoInicio(false);
        setCarregandoAssinaturasAsaas(false);
        // Pelo mesmo motivo: a classificação das cobranças do cadastro anterior esconde o campo de caução
        // e manda o valor e as parcelas dela, então sobreviver a um novo cadastro levaria a caução de um
        // cliente para o contrato de outro.
        limparCobrancasClassificadas();
        ultimoLocatarioConsultado.current = null;
        locatarioDaClassificacao.current = null;
        camposNovoLocatarioRef.current = {};
        requisicaoAssinaturasRef.current++;
        escolhaAssinaturaRef.current = null;
        escolhaAplicadaAoFormularioRef.current = null;
        // Locação nova começa enviando ao Asaas; o locador desmarca no rodapé quando esta for exceção.
        setEnviarParaAsaas(true);
        setCobrarCaucaoNoAsaas(true);
        setCaucaoTipoNoForm('');
        setLocacaoSelecionado({ idUsuario: obterIdUsuario(token) } as any);
        setEntidadeParaAtualizarLocacao({ tempoContratoEmMeses: { value: 1, unit: TipoPeriodicidadePagamento.Mensal } })
        setForcarAtualizacaoDeEntidadeLocacao(true);
        setExibirFormModal(true);
    }, [token, filialSelecionada, limparCobrancasClassificadas]);

    // Onboarding: a primeira locação é criada nesta mesma tela, já aberta em "Criar Locação" e guiada.
    // Começa pelo cadastro do cliente (quem está chegando ainda não tem nenhum), fica fora do Asaas
    // enquanto ele experimenta e usa o contrato que ele mandou no passo anterior.
    const abrirLocacaoDoOnboarding = useCallback(() => {
        handleCadastrar();
        const temModelo = Boolean(onboarding.idModeloContrato);
        setGeraContrato(temModelo);
        setEnviarParaAsaas(false);
        setNovoLocatario(true);
        setEntidadeParaAtualizarLocacao({
            // No onboarding o tipo de documento fica oculto: o cliente da primeira locação é pessoa física.
            tipoDocumento: 1,
            tempoContratoEmMeses: { value: 1, unit: TipoPeriodicidadePagamento.Mensal },
            contratoEscolha: temModelo ? 'gerarContrato' : 'anexarContrato',
            ...(temModelo ? { modeloContrato: onboarding.idModeloContrato } : {}),
        });
        setForcarAtualizacaoDeEntidadeLocacao(true);
    }, [handleCadastrar, onboarding.idModeloContrato]);

    useEffect(() => {
        if (onboarding.ativo) abrirLocacaoDoOnboarding();
    }, [onboarding.ativo]);

    const handleEditar = useCallback((locacao: any) => {
        if (!usuarioTemPermissao(token, 'locacao_editar')) {
            toast.error('Você não tem permissão para editar uma locação');
            return;
        }

        /*
        if (locacao.asaasSubscriptionId) {
            toast.info("Essa Locação não pode ser editada por aqui. Como está vinculado ao Asaas, apenas o valor e o dia de pagamento podem ser alterados pelo menu disponível ao clicar nos três pontinhos.", { autoClose: 8000 });
            return;
        }
        */

        if (locacao.status == StatusLocacao.Encerrada) {
            toast.error('Você não pode editar uma locação Encerrada.');
            return;
        }

        // Cópia: o formulário não pode alterar a linha da grid (DL-164).
        locacao = prepararLocacaoParaFormulario(locacao);

        setTipoPeriodicidadePagamento(locacao.periodicidadePagamento as TipoPeriodicidadePagamento);
        setOpcoesPrazoMinimo(calcularOpcoesPrazoMinimo(locacao.periodicidadePagamento, locacao.tipoPeriodicidadeTempoContrato, locacao.tempoContratoEmMeses?.value, integradoAsaas && locacao.integrarAoAsaas !== false));

        if (Number(locacao.jurosAoMes) > 0) {
            locacao.jurosEscolha = 'jurosPorMes';
            setJurosPorDia(false);
        } else {
            locacao.jurosEscolha = 'jurosPorDia';
            setJurosPorDia(true);
        }

        if (Number(locacao.multaPercentual) > 0) {
            locacao.multaEscolha = 'multaPercentual';
            setMultaPercentual(true);
        } else {
            locacao.multaEscolha = 'multaFixo';
            setMultaPercentual(false);
        }

        // Injetar veículo e locatário nos arrays raw ANTES de abrir o modal
        if (locacao.veiculo?.placa && locacao.idVeiculo) {
            setVeiculosRaw((prev: any[]) => {
                if (prev.some((v: any) => v.id === locacao.idVeiculo)) return prev;
                return [...prev, locacao.veiculo];
            });
        }
        if (locacao.locatario?.documento && locacao.idLocatario) {
            setLocatariosRaw((prev: any[]) => {
                if (prev.some((l: any) => l.id === locacao.idLocatario)) return prev;
                return [...prev, locacao.locatario];
            });
        }

        setModo(TipoFormulario.tpEdicao);
        setNovoLocatario(false);
        setNovoVeiculo(false);
        // A classificação de cobranças é exclusiva do cadastro: se sobrar de um cadastro aberto antes,
        // esconde o campo de caução desta edição e faz o PUT levar a caução do outro cliente.
        limparCobrancasClassificadas();
        setFilialNoForm(locacao.idFilial || null);
        // null/undefined = locação criada antes do opt-out existir, que sempre integrou.
        setEnviarParaAsaas(locacao.integrarAoAsaas !== false);
        // Sem escolha própria (null), a caução seguia a decisão da locação — mesma regra do servidor.
        setCobrarCaucaoNoAsaas(locacao.cobrarCaucaoNoAsaas ?? (locacao.integrarAoAsaas !== false));
        setCaucaoTipoNoForm(locacao.caucaoTipoDePagamento === null || locacao.caucaoTipoDePagamento === undefined ? '' : String(locacao.caucaoTipoDePagamento));
        setLocacaoSelecionado(locacao);
        // Caução também abre as opções avançadas: é lá que ficam a cobrança no Asaas e a forma de pagamento dela.
        if (locacao.idBanco || locacao.observacao || Number(locacao.valorCaucao) > 0) {
            setMostrarAvancadoLocacao(true);
        }
        setExibirFormModal(true);
    }, [token, calcularOpcoesPrazoMinimo, limparCobrancasClassificadas]);

    const handleExclusao = useCallback((locacao: Locacao) => {
        if (!usuarioTemPermissao(token, 'locacao_excluir')) {
            toast.error('Sem permissão para excluir');
            return;
        }

        const fetchLocacoes = async () => {
            setCarregando(true);
            try {
                await api.delete(`/locacao/${locacao.id}`);
                toast.success('Locação foi excluída com sucesso');
                setRealizarConsulta(true);
                toast.info('Atenção a exclusão da locação apagou todos os vínculos com essa locação: Manutenções, Pagamentos, Lançamentos, etc...')
            } catch (error: any) {
                tratarErro(error);
            } finally {
                setCarregando(false);
            }
        }

        fetchLocacoes();
    }, [token, tratarErro]);

    const handleAtualizarContratoAssinado = async (idLocacao: string) => {
        try {
            setCarregandoAtualizarContrato(true);
            const response = await api.put(`/Locacao/AtualizarContratoAssinado/${idLocacao}`);
            toast.success("Contrato atualizado com sucesso!");
        } catch (error: any) {
            tratarErro(error);
        } finally {
            setRealizarConsulta(true);
            setCarregandoAtualizarContrato(false);
        }
    };


    const handleRegerarPagamentosPrevistos = useCallback(async () => {
        setShowAlertaConfirmarRegeracao(false);
        setCarregando(true);

        try {
            if (locacaoSelecionado && usuarioTemPermissao(token, 'pagamento_novo')) {
                // Só o dia vai na rota: a hora da retirada não é vencimento.
                let dataInicio = String(locacaoSelecionado.dataPagamento ? locacaoSelecionado.dataPagamento : locacaoSelecionado.dataInicio).substring(0, 10);
                await api.post(`/CriarPagamentosPrevistos/${locacaoSelecionado.id}/${dataInicio}`);
                toast.success('Pagamentos gerados com sucesso! Todos os Pagamentos excluídos desde a data de início da locação foram regerados!');
            }
        } catch (error: any) {
            tratarErro(error);
        } finally {
            setCarregando(false);
        }
    }, [locacaoSelecionado, token, tratarErro]);

    const handleVisualizacao = useCallback((locacao: any) => {
        if (!usuarioTemPermissao(token, 'locacao_visualizar')) {
            toast.error('Sem permissão para visualizar');
            return;
        }

        // Cópia: o formulário não pode alterar a linha da grid (DL-164).
        locacao = prepararLocacaoParaFormulario(locacao);

        setTipoPeriodicidadePagamento(locacao.periodicidadePagamento as TipoPeriodicidadePagamento);
        setOpcoesPrazoMinimo(calcularOpcoesPrazoMinimo(locacao.periodicidadePagamento, locacao.tipoPeriodicidadeTempoContrato, locacao.tempoContratoEmMeses?.value, integradoAsaas && locacao.integrarAoAsaas !== false));

        if (Number(locacao.jurosAoMes) > 0) {
            locacao.jurosEscolha = 'jurosPorMes';
            setJurosPorDia(false);
        } else {
            locacao.jurosEscolha = 'jurosPorDia';
            setJurosPorDia(true);
        }

        if (Number(locacao.multaPercentual) > 0) {
            locacao.multaEscolha = 'multaPercentual';
            setMultaPercentual(true);
        } else {
            locacao.multaEscolha = 'multaFixo';
            setMultaPercentual(false);
        }

        // Injetar veículo e locatário nos arrays raw ANTES de abrir o modal
        // (veiculosOptionsFiltrados e locatariosOptionsFiltrados derivam de veiculosRaw/locatariosRaw)
        if (locacao.veiculo?.placa && locacao.idVeiculo) {
            setVeiculosRaw((prev: any[]) => {
                if (prev.some((v: any) => v.id === locacao.idVeiculo)) return prev;
                return [...prev, locacao.veiculo];
            });
        }
        if (locacao.locatario?.documento && locacao.idLocatario) {
            setLocatariosRaw((prev: any[]) => {
                if (prev.some((l: any) => l.id === locacao.idLocatario)) return prev;
                return [...prev, locacao.locatario];
            });
        }

        setEnviarParaAsaas(locacao.integrarAoAsaas !== false);
        setCobrarCaucaoNoAsaas(locacao.cobrarCaucaoNoAsaas ?? (locacao.integrarAoAsaas !== false));
        setCaucaoTipoNoForm(locacao.caucaoTipoDePagamento === null || locacao.caucaoTipoDePagamento === undefined ? '' : String(locacao.caucaoTipoDePagamento));
        setLocacaoSelecionado(locacao);
        setModo(TipoFormulario.tpVisualizacao);
        setNovoLocatario(false);
        setNovoVeiculo(false);
        // Caução também abre as opções avançadas: é lá que ficam a cobrança no Asaas e a forma de pagamento dela.
        if (locacao.idBanco || locacao.observacao || Number(locacao.valorCaucao) > 0) {
            setMostrarAvancadoLocacao(true);
        }
        setExibirFormModal(true);
    }, [token, calcularOpcoesPrazoMinimo]);

    const requisicaoBemSucedida = useCallback((response: any) => {
        setRealizarConsulta(true);
        setExibirFormModal(false);
        toast.success('Locação salva com sucesso');

        // Fail-open + aviso: a locação foi salva localmente, mas a assinatura no Asaas não pôde ser
        // atualizada (404/config). O backend devolve AvisoAsaas para o operador não pensar que a
        // cobrança foi sincronizada. Checa os dois casings por segurança.
        const avisoAsaas = response?.data?.avisoAsaas ?? response?.data?.AvisoAsaas;
        if (avisoAsaas) {
            toast.warning(avisoAsaas, { autoClose: false });
        }

        // Locação NOVA numa conta integrada: cobrança avulsa que o cliente já tinha no Asaas (caução paga
        // no painel, acerto por fora) não é achada por nenhuma regra automática, e a locação acabou de
        // criar a dela. Só abre se de fato sobrou cobrança sem dono.
        const idCriado = response?.data?.id ?? response?.data?.Id;
        if (modo === TipoFormulario.tpCadastro && idCriado && integradoAsaas) {
            abrirConciliacaoCobrancas({ id: idCriado } as Locacao, true);
        }
    }, [modo, integradoAsaas, abrirConciliacaoCobrancas]);


    useEffect(() => {
        if (!temPermissao || !realizarConsulta) return;

        const fetchVeiculos = async () => {
            setCarregando(true);
            try {
                const response = await api.get(`/VeiculoPorEmpresaESemLocacao/${obterIdTenent(token)}`);
                setVeiculosRaw((prev: any[]) => {
                    // Preservar veículos injetados de locações existentes (já em locação)
                    const idsNovos = new Set(response.data.map((v: any) => v.id));
                    const preservar = prev.filter((v: any) => !idsNovos.has(v.id));
                    return [...response.data, ...preservar];
                });
                const novasOpcoes = response.data.map((veiculo: any) => ({
                    valor: veiculo.id,
                    label: `${veiculo.placa}:  ${veiculo.marca} ${veiculo.modelo} ${veiculo.ano}`,
                }));
                setVeiculosOptions(novasOpcoes);
                if (onboarding.ativo) setSemVeiculoLivre(novasOpcoes.length === 0);
            } catch (error: any) {
                // No onboarding, sem a lista a pessoa ainda pode cadastrar o veículo na própria locação.
                if (onboarding.ativo) setSemVeiculoLivre(true);
                else tratarErro(error);
            } finally {
                setCarregando(false);
            }
        }

        fetchVeiculos();
    }, [temPermissao, realizarConsulta, token, tratarErro]);


    useEffect(() => {
        if (!temPermissao || !realizarConsulta) return;

        const fetchLocatarios = async () => {
            try {
                const response = await api.get(`/LocatarioPorEmpresaESemLocacao/${obterIdTenent(token)}`);
                setLocatariosRaw((prev: any[]) => {
                    // Preservar locatários injetados de locações existentes (já em locação)
                    const idsNovos = new Set(response.data.map((l: any) => l.id));
                    const preservar = prev.filter((l: any) => !idsNovos.has(l.id));
                    return [...response.data, ...preservar];
                });
                const novasOpcoes = response.data.map((locatario: any) => ({
                    valor: locatario.id,
                    label: `${locatario.documento} - ${locatario.nome}`,
                }));
                setLocatariosOptions(novasOpcoes);
            } catch (error: any) {
                tratarErro(error);
            }
        }

        fetchLocatarios();
    }, [temPermissao, realizarConsulta, token, tratarErro]);

    useEffect(() => {
        if (!temPermissao || !realizarConsulta) return;

        const fetchModelosContrato = async () => {
            try {
                const response = await api.get(`/ModeloContrato/PorEmpresaAtivos/${obterIdTenent(token)}`);
                const novasOpcoes = response.data.map((modeloContrato: any) => ({
                    valor: modeloContrato.id,
                    label: `${modeloContrato.titulo} - ${modeloContrato.descricao}`,
                }));
                setModelosContratoOptions(novasOpcoes);
            } catch (error: any) {
                tratarErro(error);
            }
        }

        fetchModelosContrato();
    }, [temPermissao, realizarConsulta, token, tratarErro]);

    const handleOnSim = useCallback(async () => {
        const entidade: any = montarPayloadMudancaStatus(entidadeDoSimNao, StatusLocacao.Ativa);

        await onSave(entidade, true, true);
        setShowAlertaSimNao(false);
    }, [entidadeDoSimNao, onSave]);

    const venderVeiculo = async (id: string, idLocacao: string) => {
        if (await confirm("Esta ação é irreversível! O veículo sai da frota e deixa de contar no plano.\nDeseja realmente marcar o veículo como vendido?", { alert: true, waitSeconds: 5, sound: true })) {
            setCarregando(true);
            try {
                await api.put(`/Veiculo/MarcarComoVendido/${id}`);
                setTimeout(() => {
                    toast.success(`Veículo vendido com sucesso`);
                    setRealizarConsulta(true);
                    setCarregando(false);
                }, 250);
            } catch (error) {
                tratarErro(error as AxiosError<ApiError>);
            }
        }

        setTimeout(async () => {
            const confirmed = await confirm('Deseja visualizar os pagamentos?');
            if (confirmed) {
                handleVisualizarPagamentos(idLocacao);
            }
        }, 250);
    }

    // Após encerrar a locação, busca os lançamentos PENDENTES atrelados a ela e abre o modal
    // para o usuário escolher quais remover (agrupados por categoria). Status Pendente = 2.
    // Quando asaasControlaJurosEMulta === false && asaasSubscriptionId existe, também busca
    // pagamentos não pagos para exibição e remoção manual no modal.
    const carregarLancamentosPendentesEAbrirModal = async (locacao: Locacao) => {
        const idLocacao = locacao.id as string;
        const fmtData = (iso: string) => {
            const p = (iso || '').slice(0, 10).split('-');
            return p.length === 3 ? `${p[2]}/${p[1]}/${p[0]}` : '';
        };
        try {
            const usaExclusaoManualPagamentos =
                locacao.asaasControlaJurosEMulta === false && !!locacao.asaasSubscriptionId;

            // Dispara as chamadas em paralelo para reduzir o tempo de espera
            const [resp, respPag] = await Promise.all([
                api.get(`/Lancamento/PorEstoque/${idLocacao}`),
                usaExclusaoManualPagamentos
                    ? api.get(`/Pagamento/NaoPagosPorLocacao/${idLocacao}`)
                    : Promise.resolve({ data: [] }),
            ]);

            const pendentes: LancamentoPendente[] = (resp.data || [])
                .filter((l: any) => l.status === 2)
                .map((l: any) => ({
                    id: l.id,
                    descricao: l.descricao || '',
                    valor: Number(l.valor) || 0,
                    dataRealizado: fmtData(l.dataRealizado),
                    categoriaNome: l.lancamentoCategorias?.[0]?.categoria?.nome || 'Sem categoria',
                }));

            let pagamentos: PagamentoPendente[] = [];
            if (usaExclusaoManualPagamentos) {
                const hoje = new Date(); hoje.setHours(0, 0, 0, 0);
                pagamentos = (respPag.data || []).map((p: any) => {
                    const dt = new Date((p.dataPrevista || '').slice(0, 10) + 'T00:00:00');
                    return {
                        id: p.id,
                        descricao: p.descricao || '',
                        valor: Number(p.valor) || 0,
                        dataPrevista: p.dataPrevista,
                        dataPrevistaLabel: fmtData(p.dataPrevista),
                        emAtraso: dt < hoje,
                    } as PagamentoPendente;
                });
            }

            if (pendentes.length > 0 || pagamentos.length > 0) {
                setLancamentosPendentes(pendentes);
                setPagamentosPendentes(pagamentos);
                setLocacaoEncerradaId(idLocacao);
                setExibirModalPendentes(true);
            }
        } catch (error) {
            tratarErro(error as AxiosError<ApiError>);
        }
    };

    const removerSelecionadosDoEncerramento = async (idsLancamentos: string[], idsPagamentos: string[]) => {
        const total = idsLancamentos.length + idsPagamentos.length;
        if (total === 0) return;
        const ok = await confirm(`Remover ${total} item(ns) selecionado(s)? Esta ação não pode ser desfeita.`, { alert: true });
        if (!ok) return;
        setCarregandoRemocaoPendentes(true);
        try {
            if (idsLancamentos.length > 0) {
                await api.delete(`/Lancamento/ExcluirPorIds/${obterIdTenent(token)}`, { data: idsLancamentos });
            }
            if (idsPagamentos.length > 0) {
                await api.delete(`/Pagamento/ExcluirPorIds/${obterIdTenent(token)}`, { data: idsPagamentos });
            }
            toast.success('Itens removidos com sucesso');
            setExibirModalPendentes(false);
            setLancamentosPendentes([]);
            setPagamentosPendentes([]);
            setLocacaoEncerradaId(null);
            setRealizarConsulta(true);
        } catch (error) {
            tratarErro(error as AxiosError<ApiError>);
        } finally {
            setCarregandoRemocaoPendentes(false);
        }
    };

    // dataEncerramento chega como "YYYY-MM-DDTHH:mm" (texto sem fuso, como a retirada e a substituição): um Date
    // seria serializado com toISOString() e a API converteria o instante para Brasília, deslocando a hora digitada
    // em navegadores fora de UTC-3 (Manaus, Cuiabá, Rio Branco) e, perto da meia-noite, o próprio dia.
    const mudarStatusDaLocacao = useCallback(async (status: StatusLocacao, locacao: Locacao, dataEncerramento?: Date | string, hodometroFinal?: number, observacao?: string, vendeuVeiculo?: boolean) => {
        if (locacao.status === StatusLocacao.Encerrada) {
            setMensagem(['Essa locação está encerrada. Deseja reativá-la?']);
            setEntidadeDoSimNao(locacao);
            setShowAlertaSimNao(true);
            return;
        }

        setCarregando(true);
        try {
            // A venda do veículo ao locatário só existe no encerramento e só vale o que o modal mandou;
            // a reativação (handleOnSim) nunca carrega essa marca (DL-181).
            const entidade: any = montarPayloadMudancaStatus(locacao, status, { observacao, vendeuVeiculo: status == StatusLocacao.Encerrada && !!vendeuVeiculo });

            if (status == StatusLocacao.Encerrada) {
                entidade.dataTermino = dataEncerramento || new Date();
                const kmFinal = hodometroFinal || 0;
                entidade.kmFinal = kmFinal;

                if (kmFinal < Number(entidade.kmInicial)) {
                    toast.info('O Quilometragem final deve ser maior que o Quilometragem inicial da locação');
                    return;
                }

                // Verificar limite de quilometragem
                if (locacao.limiteQuilometragem && locacao.limiteQuilometragem > 0) {
                    const kmRodados = kmFinal - Number(entidade.kmInicial);
                    if (kmRodados > locacao.limiteQuilometragem) {
                        const excedente = kmRodados - locacao.limiteQuilometragem;
                        toast.warn(
                            `Limite de quilometragem excedido! Rodados: ${kmRodados.toLocaleString('pt-BR')} km | Limite: ${locacao.limiteQuilometragem.toLocaleString('pt-BR')} km | Excedente: ${excedente.toLocaleString('pt-BR')} km`,
                            { autoClose: false }
                        );
                    }
                }

                if (entidade.dataTermino && new Date(entidade.dataTermino) < new Date(entidade.dataInicio)) {
                    toast.info('A data de término da locação deve ser posterior a data de início.')
                    return;
                }

                setCarregandoEncerramento(true);
            }

            ultimoSalvamentoOkRef.current = false;
            await onSave(entidade, true, true);
            setRealizarConsulta(true);
            // Só abre o modal de pendentes se a locação foi de fato encerrada; com o PUT falhando, o
            // operador via o erro e o modal juntos e achava que os pendentes travavam o encerramento.
            if (status == StatusLocacao.Encerrada && locacao.id && ultimoSalvamentoOkRef.current) {
                await carregarLancamentosPendentesEAbrirModal(locacao);
            }
        } finally {
            setCarregando(false);

            if (status == StatusLocacao.Encerrada) {
                setCarregandoEncerramento(false);
                setExibirFormModalEncerramento(false);
            }
        }
    }, [entidadeDoSimNao, onSave]);

    const onSaveEncerramento = (entidade: any) => {
        mudarStatusDaLocacao(StatusLocacao.Encerrada, locacaoSelecionado, entidade.dataEncerramento, entidade.kmFinal, entidade.observacao, Boolean(entidade.vendeuVeiculo));
    }

    const handleAbrirConfirmacaoEncerramento = async (locacao: Locacao) => {
        if (locacao.status == StatusLocacao.Encerrada) {
            setMensagem(['Essa já locação está Encerrada. Você deseja reativá-la?']);
            setEntidadeDoSimNao(locacao);
            setShowAlertaSimNao(true);
            return;
        }

        // Busca dados completos da locação para ter o limiteQuilometragem
        try {
            const resp = await api.get(`/Locacao/${locacao.id}`);
            const limiteKm = resp.data?.limiteQuilometragem || 0;
            setLimiteKmEncerramento(limiteKm);
        } catch {
            setLimiteKmEncerramento(0);
        }

        setModo(TipoFormulario.tpEdicao);
        setNovoLocatario(false);
        setNovoVeiculo(false);
        atualizarCamposPagamentos();
        setLocacaoSelecionado(locacao);
        setExibirFormModalEncerramento(true);
    }

    const contratoNaoInformada = () => {
        toast.info('Esse locação não possui um contrato anexado no sistema.');
    }

    const naoFoiPossivelBaixarContrato = () => {
        toast.error('Não foi possível baixar o contrato dessa locação.');
    }

    const contratoBaixadoComSucesso = () => {
        toast.success('Contrato baixado com sucesso');
    }

    const baixarContrato = async (entidade: any) => {
        handleDownloadFile(entidade.documentoContrato, `${entidade.locatario.nome}-CONTRATO`, () => contratoNaoInformada(), () => contratoBaixadoComSucesso(), () => naoFoiPossivelBaixarContrato());
    }

    const chamaTelaGerarContrato = (locacao: Locacao) => {
        setLocacaoSelecionado(locacao);
        setExibirGerarContrato(true);
    }

    async function obterDocumentoContrato(locacao: Locacao) {
        try {
            const response = await api.get(`/Locacao/ComDocumentoContrato/${locacao.id}`);
            setCarregando(false);
            return response.data.documentoContrato;
        } catch (error: any) {
            tratarErro(error);
            setCarregando(false);
            return "";
        }
    }

    const visualizarDocumentoDeContrato = async (locacao: Locacao) => {
        setCarregando(true);
        const documento = await obterDocumentoContrato(locacao);
        if (documento) {
            setTituloContratoVisualizador(`Contrato`);
            setLinkContratoPreview(documento);
        } else {
            toast.info('Essa locação não possui um contrato anexado no sistema.');
            return;
        }
    }

    // Ações que a API restringe (ver LocacaoController/PagamentoController): o que não pode, não aparece.
    const acoesDaLocacaoPermitidas: Record<string, boolean> = {
        'Encerrar Locação': usuarioTemPermissao(token, 'locacao_editar'),
        'Ativar/Inativar Locação': usuarioTemPermissao(token, 'locacao_editar'),
        'Substituir Veículo': usuarioTemPermissao(token, 'locacao_editar'),
        'Gerar Contrato': usuarioTemPermissao(token, 'locacao_novo'),
        'Assinar e copiar Link para o Locatário': usuarioTemPermissao(token, 'locacao_novo'),
        'Atualizar Contrato Assinado': usuarioTemPermissao(token, 'locacao_editar'),
        'Prolongar locação': usuarioTemPermissao(token, 'pagamento_novo'),
        'Regerar Pagamentos Previstos': usuarioTemPermissao(token, 'pagamento_novo'),
        'Alterar dia de Pagamento': usuarioTemPermissao(token, 'locacao_editar'),
        'Consultar Pagamentos': usuarioTemPermissao(token, 'pagamento_visualizar'),
        'Atualizar Valor do Aluguel': usuarioTemPermissao(token, 'locacao_editar'),
        'Vincular Locação existente ao Asaas': usuarioTemPermissao(token, 'locacao_novo'),
        'Conciliar cobranças do Asaas': usuarioTemPermissao(token, 'locacao_editar'),
        'Conciliar banco': usuarioTemPermissao(token, 'locacao_editar'),
    };

    const acoesExtras = useMemo(() => ocultarAcoes([
        {
            Icone: FaFilePdf,
            OnClick: (locacao: Locacao) => {
                setLocacaoSelecionadaParaRelatorio(locacao);
                setShowRelatorioLocacao(true);
            },
            Texto: 'Relatório Completo',
            Cor: '#1E3A5F',
        },
        {
            Icone: FaTimes,
            OnClick: (locacao: Locacao) => handleAbrirConfirmacaoEncerramento(locacao),
            Texto: 'Encerrar Locação'
        },
        {
            Icone: FaExchangeAlt,
            OnClick: (locacao: Locacao) => {
                if (locacao.status === StatusLocacao.Ativa) {
                    mudarStatusDaLocacao(StatusLocacao.Inativa, locacao);
                } else if (locacao.status === StatusLocacao.Inativa) {
                    mudarStatusDaLocacao(StatusLocacao.Ativa, locacao);
                } else {
                    setMensagem(['Essa locação está Encerrada. Você deseja reativá-la?']);
                    setEntidadeDoSimNao(locacao);
                    setShowAlertaSimNao(true);
                }
            },
            Texto: 'Ativar/Inativar Locação'
        },
        {
            Icone: FaCarSide,
            OnClick: async (locacao: Locacao) => {
                if (!usuarioTemPermissao(token, 'locacao_editar')) {
                    toast.error('Usuário logado não tem permissão para realizar essa ação.');
                    return;
                }
                if (locacao.status !== StatusLocacao.Ativa) {
                    toast.error('Apenas locações ativas podem ter o veículo substituído.');
                    return;
                }
                setLocacaoSelecionado(locacao);
                try {
                    const response = await api.get(`/VeiculoPorEmpresaESemLocacao/${obterIdTenent(token)}`);
                    const opcoesVeiculos = response.data
                        .map((veiculo: any) => ({
                            valor: veiculo.id,
                            label: labelComFilial(`${veiculo.placa}:  ${veiculo.marca} ${veiculo.modelo} ${veiculo.ano}`, veiculo.idFilial),
                        }));
                    setVeiculosParaSubstituicao(opcoesVeiculos);
                } catch (error: any) {
                    tratarErro(error);
                    return;
                }

                setExibirFormModalSubstituirVeiculo(true);
            },
            Texto: 'Substituir Veículo'
        },
        {
            Icone: FaTimeline,
            OnClick: (locacao: Locacao) => {
                setIdLocacaoResumo(locacao.id ?? null);
                setExibirResumoLocacao(true);
            },
            Texto: 'Linha do Tempo'
        },
        {
            Texto: 'Documentos',
            OnClick: (locacao: Locacao) => {
                setLocacaoDocumentos(locacao);
                setExibirModalDocumentos(true);
            },
            Icone: FaFileAlt,
        },
        {
            Icone: FaFileContract,
            Texto: 'Contrato',
            SubMenu: [
                {
                    Icone: FaFileSignature,
                    Texto: 'Gerar Contrato',
                    OnClick: (locacao: Locacao) => {
                        setLocacaoSelecionado(locacao);
                        setExibirGerarContrato(true);
                    },
                },
                {
                    Icone: FaEye,
                    OnClick: (locacao: Locacao) => {
                        visualizarDocumentoDeContrato(locacao);
                    },
                    Texto: 'Ver Contrato',
                    Condicao: (locacao: Locacao) => !!locacao.documentoContrato,
                    TooltipDisabled: "Essa locação não tem um documento de contrato vinculado. Clique em 'Gerar Contrato' para gerar um"
                },
                {
                    Icone: FaFileDownload,
                    OnClick: (locacao: Locacao) => {
                        baixarContrato(locacao);
                    },
                    Texto: 'Baixar Contrato',
                    Condicao: (locacao: Locacao) => !!locacao.documentoContrato,
                    TooltipDisabled: "Essa locação não tem um documento de contrato vinculado. Clique em 'Gerar Contrato' para gerar um"
                },
                {
                    Icone: FaSignature,
                    OnClick: async (locacao: Locacao) => {
                        try {
                            setCarregando(true);
                            const response = await api.get(`/Locacao/GetStatusAssinatura/${locacao.id}`);

                            const todosAssinaram = response.data.data.document.signatures.every((s: any) => s.signed != null);

                            if (todosAssinaram) {
                                toast.info("Este contrato já foi assinado por todas as partes.");
                            } else {
                                const responseLink = await api.post(`/Locacao/AssinarContratoGerarLink/${locacao.id}`);
                                setLinkAssinatura(responseLink.data.link);
                                setExibirLinkAssinaturaModal(true);
                            }
                        } catch (error) {
                            tratarErro(error as AxiosError<ApiError>);
                        } finally {
                            setCarregando(false);
                        }
                    },
                    Texto: 'Assinar e copiar Link para o Locatário',
                    Condicao: (locacao: Locacao) => !!locacao.autentiqueDocumentId,
                    TooltipDisabled: "Esse contrato não existe na integração com o Assinador Digital"
                },
                {
                    Texto: 'Atualizar Contrato Assinado',
                    OnClick: (locacao: Locacao) => {
                        if (locacao.id) {
                            handleAtualizarContratoAssinado(locacao.id)
                        }
                    },
                    Icone: FaSyncAlt,
                    Condicao: (locacao: Locacao) => !!locacao.autentiqueDocumentId,
                    TooltipDisabled: "Esse contrato não existe na integração com o Assinador Digital"
                },
            ]
        },
        {
            Icone: FaDollarSign,
            Texto: 'Financeiro',
            SubMenu: [
                {
                    Icone: FaHandshake,
                    OnClick: (locacao: Locacao) => {
                        if (!usuarioTemPermissao(token, 'pagamento_novo')) {
                            toast.error('Usuário logado não tem permissão para realizar essa ação.');
                            return;
                        }
                        setLocacaoSelecionado(locacao);
                        if (locacao.asaasSubscriptionId) {
                            setExibirModalNovaPrevisaoEncerramento(true);
                        } else {
                            if (locacao.status === StatusLocacao.Encerrada) {
                                toast.info('Essa locação está encerrada. Ao prolongar, ela será reativada automaticamente.', { autoClose: 5000 });
                            }
                            setExibirFormModalPagamentos(true);
                        }
                    },
                    Texto: 'Prolongar locação'
                },
                {
                    Icone: FaMoneyBillTransfer,
                    OnClick: (locacao: Locacao) => {
                        if (locacao.asaasSubscriptionId) {
                            toast.error('Essa locação é gerenciada pelo Asaas. Dessa forma, não poode ter seus pagamentos regerados por aqui')
                            return;
                        }
                        if (!usuarioTemPermissao(token, 'pagamento_novo')) {
                            toast.error('Usuário logado não tem permissão para realizar essa ação.');
                            return;
                        }
                        setLocacaoSelecionado(locacao);
                        setMessagemConfirmarRegeracao([
                            'Deseja realmente regerar todos os Pagamentos desde o início da locação?',
                            `Data de início da locação: ${formatarData(locacao.dataInicio)}`,
                            'Obs: Os pagamentos já existentes não serão duplicados!'
                        ]);
                        setShowAlertaConfirmarRegeracao(true);
                    },
                    Texto: 'Regerar Pagamentos Previstos'
                },
                {
                    Icone: FaCalendar,
                    OnClick: (locacao: Locacao) => {
                        if (locacao.periodicidadePagamento === TipoPeriodicidadePagamento.Diario) {
                            toast.error('Contratos diários não possuem um dia fixo de pagamento — não é possível alterar.');
                            return;
                        }
                        if (!usuarioTemPermissao(token, 'pagamento_novo')) {
                            toast.error('Usuário logado não tem permissão para realizar essa ação.');
                            return;
                        }
                        setLocacaoSelecionado(locacao);
                        setExibirFormModalAlterarDataPagamento(true);
                    },
                    Texto: 'Alterar dia de Pagamento'
                },
                {
                    Icone: FaMoneyBill1Wave,
                    OnClick: (locacao: Locacao) => {
                        if (locacao.id) {
                            handleVisualizarPagamentos(locacao.id);
                        } else {
                            toast.error('Não foi possível consultar os pagamentos dessa locação, pois ela não possui um ID válido.');
                        }
                    },
                    Texto: 'Consultar Pagamentos'
                },
                {
                    Icone: FaMoneyBillTransfer,
                    OnClick: (locacao: Locacao) => {
                        setLocacaoSelecionado(locacao);
                        setExibirFormModalAlterarValorPagamento(true);
                    },
                    Texto: 'Atualizar Valor do Aluguel'
                },
                {
                    Imagem: asaasLogo,
                    OnClick: (locacao: Locacao) => {
                        if (locacao.status != StatusLocacao.Ativa) {
                            toast.error('Só é possível gerar no Asaas uma locação ativa.')
                            return;
                        }

                        if (locacao.asaasSubscriptionId) {
                            toast.info('Essa locação já consta no asaas!')
                            return;
                        }

                        if (!integradoAsaas) {
                            toast.error('A sua conta não está integrada ao Asaas.');
                            return;
                        }

                        // Bloquear pela PERIODICIDADE DE PAGAMENTO (não pela unidade de duração do
                        // contrato): o backend ramifica por PeriodicidadePagamento (GerarAssinaturaNoAsaas)
                        // e o ramo diário retorna null após criar as cobranças. Se a guarda usasse
                        // tipoPeriodicidadeTempoContrato, uma locação com prazo em meses mas pagamento
                        // diário passaria, cairia no ramo diário e o front exibiria um falso erro de
                        // "não foi possível vincular" — arriscando cobranças duplicadas num retry.
                        if (locacao.periodicidadePagamento == TipoPeriodicidadePagamento.Diario) {
                            toast.error('Não é possível realizar essa ação com locações diárias. Encerre o contrato atual e gere um novo para prosseguir com o Asaas.')
                            return;
                        }

                        setLocacaoSelecionado(locacao);
                        setExibirModalVincularAsaas(true);
                    },
                    Texto: 'Vincular Locação existente ao Asaas',
                    Condicao: (locacao: Locacao) => !!integradoAsaas,
                    TooltipDisabled: "Vincule a sua conta ao Asaas para utilizar essa funcionalidade"
                },
                {
                    Icone: FaUniversity,
                    OnClick: (locacao: Locacao) => {
                        if (!integradoAsaas) {
                            toast.error('A sua conta não está integrada ao Asaas.');
                            return;
                        }
                        abrirConciliacaoCobrancas(locacao);
                    },
                    Texto: 'Conciliar cobranças do Asaas',
                    Condicao: (locacao: Locacao) => !!integradoAsaas,
                    TooltipDisabled: "Vincule a sua conta ao Asaas para utilizar essa funcionalidade"
                },
                {
                    Icone: FaUniversity,
                    OnClick: (locacao: Locacao) => {
                        setLocacaoConciliacao(locacao);
                        setExibirModalConciliar(true);
                    },
                    Texto: 'Conciliar banco',
                }
            ]
        }
    ] as any[], acoesDaLocacaoPermitidas), [mudarStatusDaLocacao, token]);

    const pages = [
        {
            titulo: "Dados",
            campos: ["idFilial", "idVeiculo", "veiculoEscolha", "renavam", "tipoVeiculo", "marca", "placa", "modelo", "ano", "cor", "locatarioEscolha", "idLocatario", "_escolhaAssinaturaAsaasCriacao", "_cobrancasIndisponiveisCriacaoAviso", "_lerCnhLocatario", "_maisDadosCliente", "tipoDocumento", "documento", "rg", "nome", "email", "vencimentoHabilitacao", "numeroRegistroCnh", "chassi", "telefone", "cep", "cidade", "estado", "numero", "complemento", "bairro", "logradouro"]
        },
        {
            titulo: "Contrato",
            campos: ["kmInicial", "periodicidadePagamento", "alertaSobrePrazoMinimo", "locacaoEmAndamento", "tempoContratoEmMeses", "tipoPeriodicidadeTempoContrato", "fiador", "opcaoDeCompra", "_toggleAvancadoContrato", "limiteQuilometragem"],
        },
        {
            titulo: "Valores",
            campos: ["valorAluguel", "valorCaucao", "desejoDefinirPrimeiroSegundoDia",
                "dataInicio",
                "dataPagamento",
                "dataSegundoPagamentoQuinzena",
                "dataTermino", "kmFinal", "asaasTipoDePagamento",
                "_toggleAvancadoLocacao", "_labelBancoInfo", "idBanco", "descricaoCustomAluguel",
                "_cobrarCaucaoNoAsaasCheck", "caucaoTipoDePagamento",
                // Substitui "valorCaucao" quando a caução vem das cobranças classificadas: sem ele na
                // página, o campo de caução desaparecia e NADA ficava no lugar (o valor não aparecia e o
                // link de volta ao preenchimento manual era inalcançável).
                "_caucaoDefinidaPorCobrancas",
                "_caucaoParceladaCheck", "_caucaoParceladaEditor", "_lancamentosLocacaoEditor",
                "_definirComissaoFilial", "comissaoFilialTipoCalculo", "comissaoFilialValor", "observacao"]
        },
        {
            titulo: "Juros e Multa",
            campos: ["jurosEscolha", "valorJurosAoDia", "juros", "jurosAoMes", "valorJurosAoMes", "multa", "multaEscolha", "multaPercentual", "valorMulta", "multaFixa"]
        },
        {
            titulo: "Arquivo",
            campos: ["documentoContrato", "contratoEscolha", "modeloContrato"]
        },
    ]

    if (modo == TipoFormulario.tpCadastro && !asaasNestaLocacao) {
        // Inserir antes de "Arquivo" para manter a ordem correta do tour
        const indexArquivo = pages.findIndex(p => p.titulo === "Arquivo");
        pages.splice(indexArquivo, 0, {
            titulo: "Lançamentos Iniciais",
            campos: [
                "gerarPagamentoInicialComoPago",
                "gerarLancamentoCaucaoComoPago",
                "definirPagamentosAnteriorAHojeComoPago",
                "desejoGerarPagamentoUnico",
            ]
        })
    }

    if (asaasNestaLocacao && modo == TipoFormulario.tpCadastro) {
        const indexArquivo = pages.findIndex(p => p.titulo === "Arquivo");
        pages.splice(indexArquivo, 0, {
            titulo: "Lançamentos Iniciais",
            campos: [
                "definirPagamentosAnteriorAHojeComoPago",
                "desejoGerarPagamentoUnico",
            ]
        })
    }


    useEffect(() => {
        const fetchBuscarCidades = async (estado: any) => {

            if (estado) {
                if (modo != TipoFormulario.tpNenhum) {
                    await buscarCidades(estado);
                }
            }

        }

        fetchBuscarCidades(estado);
    }, [estado, modo]);

    const handleOnShow = async () => {
        setTipoPeriodicidadePagamento(TipoPeriodicidadePagamento.Nenhum);
        setDesejoDefinirDias(false);
        setMascaraDocumento('999.999.999-99');
        const novasOpcoes = ESTADOS_BRASIL.map((uf) => ({
            codigo: uf.sigla,
            valor: uf.sigla,
            label: uf.nome,
        }));

        setEstados(novasOpcoes);
        setCarregando(false);

    }

    return (
        <>
        {consultandoPlaca && (
            <div style={{
                position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.6)', zIndex: 9999,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                backdropFilter: 'blur(4px)',
            }}>
                <div style={{
                    background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
                    borderRadius: '16px', padding: '40px 48px',
                    display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px',
                    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.4)',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    animation: 'fadeInPlaca 0.3s ease',
                }}>
                    <div style={{
                        width: '56px', height: '56px',
                        border: '4px solid rgba(255, 255, 255, 0.1)',
                        borderTopColor: '#4fc3f7', borderRadius: '50%',
                        animation: 'spinPlaca 0.8s linear infinite',
                    }} />
                    <div style={{ textAlign: 'center' }}>
                        <p style={{ color: '#fff', fontSize: '18px', fontWeight: 600, margin: '0 0 6px 0' }}>
                            Consultando placa...
                        </p>
                        <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '13px', margin: 0 }}>
                            Buscando dados do veículo
                        </p>
                    </div>
                    <button
                        onClick={() => setConsultandoPlaca(false)}
                        style={{
                            marginTop: '8px', background: 'transparent',
                            border: '1px solid rgba(255,255,255,0.25)',
                            color: 'rgba(255,255,255,0.7)', padding: '8px 24px',
                            borderRadius: '8px', cursor: 'pointer', fontSize: '13px',
                        }}
                    >
                        Inserir Manualmente
                    </button>
                </div>
                <style>{`
                    @keyframes spinPlaca { to { transform: rotate(360deg); } }
                    @keyframes fadeInPlaca { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }
                `}</style>
            </div>
        )}
        <LocaSmartLayout>
            {onboarding.ativo && !exibirFormModal && (
                <BotaoRetomarOnboarding type="button" onClick={abrirLocacaoDoOnboarding}>Continuar criando a locação</BotaoRetomarOnboarding>
            )}
            {!onboarding.ativo && <Listagem
                permissoes={crudDe('locacao')}
                colunas={colunas}
                linhas={locacoes}
                carregando={carregando}
                IconeEntidade={FaHandshake}
                nomeEntidade="Locação"
                exibirAcoesDeCrud={true}
                nomePropriedade="veiculo.placa;locatario.nome"
                handleEditar={handleEditar}
                handleCriar={handleCadastrar}
                handleExclusao={handleExclusao}
                handleVisualizacao={handleVisualizacao}
                handleSelecionarEntidade={setLocacaoSelecionado}
                acoesExtras={acoesExtras}
                rowCount={rowCount}
                paginationModel={paginationModel}
                onPaginationModelChange={(model) => {
                    setPaginationModel(model);
                    setRealizarConsulta(true);
                }}
                paginationMode="server"
                filtros={configFiltros}
                acoesEmLote={[
                    ...(getAcaoEmLoteFilial('Locacao', () => setRealizarConsulta(true)) ? [getAcaoEmLoteFilial('Locacao', () => setRealizarConsulta(true))!] : []),
                ]}
                exportOptions={[
                    {
                        field: 'locacao',
                        headerName: 'Locatário',
                        valueGetter: ({ row }: { row: any }) => row.locatario?.nome || ''
                    },
                    {
                        field: 'veiculo',
                        headerName: 'Veículo',
                        valueGetter: ({ row }: { row: any }) => {
                            const v = row.veiculo;
                            return v ? `${v.placa} - ${v.marca} ${v.modelo}` : '';
                        }
                    },
                    {
                        field: 'dataInicio',
                        headerName: 'Data de Início',
                        valueGetter: ({ row }: { row: any }) => formatarDataHora(row.dataInicio)
                    },
                    {
                        field: 'kmInicial',
                        headerName: 'Km Inicial'
                    },
                    {
                        field: 'periodicidadePagamento',
                        headerName: 'Recorrência',
                        valueGetter: ({ row }: { row: any }) => converterPeriodicidadePagamentoParaTexto(row.periodicidadePagamento)
                    },
                    {
                        field: 'valorAluguel',
                        headerName: 'Valor',
                        valueGetter: ({ row }: { row: any }) => formatarParaReais(row.valorAluguel)
                    },
                    {
                        field: 'status',
                        headerName: 'Status',
                        valueGetter: ({ row }: { row: any }) => converterStatusLocacaoParaTexto(row.status)
                    }
                ]}
                tituloExportacao="Locacoes"
                onExportarBuscarTudo={async () => {
                    const idEmpresa = obterIdTenent(token);
                    const params = new URLSearchParams();
                    params.append('page', '1');
                    params.append('pageSize', '100000');
                    params.append('idEmpresa', idEmpresa);
                    if (idVeiculoEscolhido) params.append('idVeiculo', idVeiculoEscolhido);
                    if (idLocatarioEscolhido) params.append('idLocatario', idLocatarioEscolhido);
                    if (dataInicio) params.append('dataInicial', dataInicio.toISOString());
                    if (dataFim) params.append('dataFinal', dataFim.toISOString());
                    if (statusFiltro) params.append('status', statusFiltro);
                    if (periodicidadeFiltro) params.append('periodicidade', periodicidadeFiltro);
                    const response = await api.get(`/locacao/filtrar?${params.toString()}`);
                    if (response.data?.items) return response.data.items;
                    return Array.isArray(response.data) ? response.data : [response.data];
                }}
            />}

            <ModalForm
                urlTutorial="https://youtu.be/Zulbvw_4w6s"
                guia={onboarding.ativo ? guiaPrimeiraLocacao : undefined}
                embutido={onboarding.ativo}
                modo={modo}
                tamanho="lg"
                campos={campos}
                titulo={modo == TipoFormulario.tpCadastro ? "Criar Locação" : modo == TipoFormulario.tpVisualizacao ? "Visualizando Locação" : "Editando Locação"}
                pages={pages}
                onSave={onSave}
                onShow={handleOnShow}
                atualizacaoEntidade={{
                    entidadeUsadaParaAtualizacao: entidadeParaAtualizarLocacao,
                    forcarAtualizacao: forcarAtualizacaoDeEntidadeLocacao
                }}
                show={exibirFormModal}
                carregando={carregando}
                onHide={handleFecharModal}
                onCancel={handleFecharModal}
                entidadeSelecionada={locacaoSelecionado}
                isSaving={isSaving}
                apiConfig={{
                    endpoint: 'locacao',
                    idTenentCampo: 'idEmpresa',
                    requisicaoBemSucedida: requisicaoBemSucedida,
                    tratarErro: tratarErro,
                }}
                planoPremium={!estaEmPeriodoDeTeste(token) && !ehPlanoGratuito(token)}
                onFileRemoved={(campo: string) => {
                    setArquivoRemovido(true);
                }}
                footerContent={integradoAsaas ? (
                    <LinhaToggleComAjuda>
                        <ToggleSwitch
                            id="switch-enviar-locacao-asaas"
                            checked={enviarParaAsaas}
                            disabled={modo !== TipoFormulario.tpCadastro}
                            onChange={setEnviarParaAsaas}
                            label="Enviar esta locação para o Asaas"
                        />
                        <Ajudinha
                            texto={modo !== TipoFormulario.tpCadastro
                                ? 'Ligado, as cobranças desta locação são geradas na sua conta do Asaas. Desligado, as parcelas ficam só no sistema. A escolha é feita na criação. Para passar a cobrar pelo Asaas, use "Vincular Locação existente ao Asaas" no menu da locação. Para parar de cobrar, encerre a locação.'
                                : 'Ligado, as cobranças desta locação são geradas na sua conta do Asaas. Desligado, nada é enviado para lá e as parcelas ficam só no sistema. Serve para contratos acertados em dinheiro ou cobrados por fora.'}
                            autoCloseTime={12}
                        />
                    </LinhaToggleComAjuda>
                ) : undefined}
            />

            <ModalForm
                modo={TipoFormulario.tpCadastro}
                tamanho="lg"
                campos={camposAlterarDataPagamento}
                onSave={onSaveAlterarData}
                show={exibirFormModalAlterarDataPagamento}
                carregando={carregandoAlterarDataPagamento}
                onHide={() => setExibirFormModalAlterarDataPagamento(false)}
                onCancel={() => setExibirFormModalAlterarDataPagamento(false)}
                entidadeSelecionada={locacaoSelecionado}
                onShow={atualizarCamposAlterarData}
                atualizacaoEntidade={{
                    entidadeUsadaParaAtualizacao: entidadeParaAtualizarAlterarData,
                    forcarAtualizacao: forcarAtualizacaoDeEntidadeAlterarData
                }}
                isSaving={isSaving}
                titulo="Alterar Data de Pagamento"
                apiConfig={{
                    endpoint: 'locacao',
                    idTenentCampo: 'idEmpresa',
                    requisicaoBemSucedida: requisicaoBemSucedida,
                    tratarErro: tratarErro,
                }}
            />

            <ModalForm
                modo={TipoFormulario.tpCadastro}
                tamanho="lg"
                campos={camposAlterarValorPagamento}
                onSave={onSaveAlterarValorPagamento}
                show={exibirFormModalAlterarValorPagamento}
                carregando={carregandoAlterarValorPagamento}
                onHide={() => setExibirFormModalAlterarValorPagamento(false)}
                onCancel={() => setExibirFormModalAlterarValorPagamento(false)}
                entidadeSelecionada={locacaoSelecionado}
                isSaving={isSaving}
                titulo="Alterar Valor do Aluguel"
                apiConfig={{
                    endpoint: 'locacao',
                    idTenentCampo: 'idEmpresa',
                    requisicaoBemSucedida: requisicaoBemSucedida,
                    tratarErro: tratarErro,
                }}
            />

            <ModalForm
                modo={TipoFormulario.tpCadastro}
                tamanho="lg"
                campos={camposEscolhaAssinatura}
                pages={paginasEscolhaAssinatura}
                show={exibirModalEscolhaAssinatura}
                onSave={async () => {
                    if (assinaturaEscolhida !== escolhaAplicadaAoFormularioRef.current)
                        aplicarDadosDaAssinaturaEscolhida(assinaturaEscolhida);
                    escolhaAplicadaAoFormularioRef.current = assinaturaEscolhida;
                    setExibirModalEscolhaAssinatura(false);
                }}
                onHide={descartarEscolhaDeAssinaturaNaoConfirmada}
                onCancel={descartarEscolhaDeAssinaturaNaoConfirmada}
                entidadeSelecionada={{}}
                titulo="Assinatura no Asaas"
                tituloBotaoOk="Confirmar"
                carregando={carregandoAssinaturasAsaas}
                apiConfig={{
                    endpoint: 'locacao',
                    idTenentCampo: 'idEmpresa',
                    requisicaoBemSucedida: requisicaoBemSucedida,
                    tratarErro: tratarErro,
                }}
            />

            <ModalForm

                modo={TipoFormulario.tpCadastro}

                tamanho="lg"

                campos={camposConciliacao}

                onSave={onSaveConciliacao}

                show={exibirModalConciliacao}

                carregando={carregandoConciliacao || salvandoConciliacao}

                onHide={() => setExibirModalConciliacao(false)}

                onCancel={() => setExibirModalConciliacao(false)}

                isSaving={salvandoConciliacao}

                titulo="Conciliar cobranças do Asaas"

                tituloBotaoOk="Confirmar conciliação"

                apiConfig={{

                    endpoint: 'locacao',

                    idTenentCampo: 'idEmpresa',

                    requisicaoBemSucedida: requisicaoBemSucedida,

                    tratarErro: tratarErro,

                }}

            />


            <ModalForm
                modo={TipoFormulario.tpCadastro}
                tamanho="lg"
                campos={camposVincularAsaas}
                onSave={onSaveVincularAsaas}
                show={exibirModalVincularAsaas}
                carregando={carregandoVincularAsaas || carregandoAssinaturasAsaas}
                onHide={() => setExibirModalVincularAsaas(false)}
                onCancel={() => setExibirModalVincularAsaas(false)}
                entidadeSelecionada={locacaoSelecionado}
                onShow={atualizarCamposVincularAsaas}
                atualizacaoEntidade={{
                    entidadeUsadaParaAtualizacao: entidadeParaAtualizarVincularAsaas,
                    forcarAtualizacao: forcarAtualizacaoDeEntidadeVincularAsaas
                }}
                isSaving={isSaving}
                titulo="Vincular Locação ao Asaas"
                tituloBotaoOk="Vincular"
                apiConfig={{
                    endpoint: 'locacao',
                    idTenentCampo: 'idEmpresa',
                    requisicaoBemSucedida: requisicaoBemSucedida,
                    tratarErro: tratarErro,
                }}
            />

            <ModalForm
                modo={TipoFormulario.tpCadastro}
                tamanho="lg"
                campos={camposPagamentos}
                onSave={onSavePagamentos}
                show={exibirFormModalPagamentos}
                carregando={carregandoPagamentos}
                onHide={handleFecharModalPagamentos}
                onCancel={handleFecharModalPagamentos}
                isSaving={isSavingPagamentos}
                onShow={atualizarCamposPagamentos}
                atualizacaoEntidade={{
                    entidadeUsadaParaAtualizacao: entidadeParaAtualizarPagamentos,
                    forcarAtualizacao: forcarAtualizacaoDeEntidadeNoModalPagamentos
                }}
                titulo={locacaoSelecionado.status === StatusLocacao.Encerrada ? "Renovar Locação" : "Prolongar Locação"}
                tituloBotaoOk="Gerar"
                apiConfig={{
                    endpoint: 'pagamentos',
                    idTenentCampo: 'idEmpresa',
                    requisicaoBemSucedida: requisicaoBemSucedida,
                    tratarErro: tratarErro,
                }}
            />

            <ModalForm
                modo={TipoFormulario.tpCadastro}
                tamanho="lg"
                campos={camposNovaPrevisaoEncerramento}
                onSave={onSaveNovaPrevisaoEncerramento}
                show={exibirModalNovaPrevisaoEncerramento}
                carregando={salvandoNovaPrevisao}
                onHide={() => setExibirModalNovaPrevisaoEncerramento(false)}
                onCancel={() => setExibirModalNovaPrevisaoEncerramento(false)}
                isSaving={salvandoNovaPrevisao}
                onShow={atualizarCamposNovaPrevisao}
                atualizacaoEntidade={{
                    entidadeUsadaParaAtualizacao: entidadeParaAtualizarNovaPrevisao,
                    forcarAtualizacao: forcarAtualizacaoNovaPrevisao
                }}
                titulo="Nova Previsão de Encerramento"
                tituloBotaoOk="Atualizar"
                apiConfig={{
                    endpoint: 'locacao',
                    idTenentCampo: 'idEmpresa',
                    requisicaoBemSucedida: requisicaoBemSucedida,
                    tratarErro: tratarErro,
                }}
            />

            <ModalForm
                modo={TipoFormulario.tpCadastro}
                tamanho="lg"
                campos={camposConfirmarDataEncerramento}
                onSave={onSaveEncerramento}
                show={exibirFormModalEncerramento}
                carregando={carregandoEncerramento}
                onHide={() => { setExibirFormModalEncerramento(false) }}
                onCancel={() => { setExibirFormModalEncerramento(false) }}
                isSaving={carregandoEncerramento}
                onShow={atualizarCamposEncerramento}
                atualizacaoEntidade={{
                    entidadeUsadaParaAtualizacao: entidadeParaAtualizarEncerramento,
                    forcarAtualizacao: forcarAtualizacaoDeEntidadeNoModalEncerramento
                }}
                titulo="Encerrar Locação"
                tituloBotaoOk="Confirmar"
                apiConfig={{
                    endpoint: 'locacao',
                    idTenentCampo: 'idEmpresa',
                    requisicaoBemSucedida: requisicaoBemSucedida,
                    tratarErro: tratarErro,
                }}
            />

            <ModalLancamentosPendentes
                show={exibirModalPendentes}
                lancamentos={lancamentosPendentes}
                pagamentos={pagamentosPendentes}
                carregando={carregandoRemocaoPendentes}
                onClose={() => { setExibirModalPendentes(false); setLancamentosPendentes([]); setPagamentosPendentes([]); setLocacaoEncerradaId(null); }}
                onConfirmar={removerSelecionadosDoEncerramento}
            />

            <ModalForm
                modo={TipoFormulario.tpCadastro}
                tamanho="lg"
                campos={
                    [
                        { label: 'Informações da Locação', nome: '', required: true, tipo: 'label', largura: 12, coluna: 1, linha: 1, visible: true },
                        {
                            label: 'Locatário', nome: 'idLocatario', required: true, tipo: 'select', largura: 12, coluna: 1, linha: 2,
                            visible: true, opcoes: locatariosOptions, apenasLeitura: true
                        },
                        {
                            label: 'Veículo', nome: 'idVeiculo', required: true, tipo: 'select', largura: 12, coluna: 1, linha: 3,
                            visible: true, opcoes: veiculosOptions, apenasLeitura: true
                        },
                        { label: 'Contrato:', nome: '', required: true, tipo: 'label', largura: 12, coluna: 1, linha: 4, visible: true },

                        {
                            label: 'Modelo de Contrato', nome: 'modeloContrato', required: false, tipo: 'select', largura: 12, coluna: 1, linha: 5, novo: true, tutorialLink: "https://youtu.be/K--okUsfQxI",
                            visible: true, ajudinha: {
                                texto: "Este campo define o modelo utilizado para a geração do contrato no sistema. Ao selecioná-lo, o contrato será criado automaticamente com base nas informações da locação",
                                autoCloseTime: 3
                            }, opcoes: modelosContratoOptions

                        },
                    ]
                }
                onSave={gerarContrato}
                show={exibirGerarContrato}
                carregando={carregandoGerarContrato}
                onHide={() => { setExibirGerarContrato(false) }}
                onCancel={() => { setExibirGerarContrato(false) }}
                isSaving={carregandoGerarContrato}
                onShow={atualizarCamposGerarContrato}
                atualizacaoEntidade={{
                    entidadeUsadaParaAtualizacao: entidadeParaAtualizarGerarContrato,
                    forcarAtualizacao: forcarAtualizacaoDeEntidadeNoModalGerarContrato
                }}
                titulo="Gerar Contrato"
                tituloBotaoOk="Gerar"
                apiConfig={{
                    endpoint: 'locacao',
                    idTenentCampo: 'idEmpresa',
                    requisicaoBemSucedida: requisicaoBemSucedida,
                    tratarErro: tratarErro,
                }}
            />

            <ModalForm
                modo={TipoFormulario.tpCadastro}
                tamanho="lg"
                campos={camposVariaveisManuais}
                onSave={(entidade: any) => {
                    // Envia TODAS as variáveis pendentes, inclusive as deixadas em branco: o backend
                    // aplica vazio (contrato sai sem o token cru) em vez de manter "{variavel}".
                    const manuais: Record<string, string> = {};
                    variaveisPendentes.forEach(v => {
                        manuais[v.chave] = entidade[v.chave] ?? "";
                    });

                    // Cenário 1: salvando uma locação inteira (modelo de contrato selecionado no form)
                    if (cenarioVariaveisManuaisRef.current === 'salvar-locacao') {
                        valoresManuaisContratoRef.current = manuais;
                        setExibirModalVariaveisManuais(false);
                        const entidadePendente = entidadeLocacaoPendenteRef.current;
                        if (entidadePendente) {
                            // Re-chama onSave; agora a ref está populada e o fluxo passa direto
                            onSave(entidadePendente);
                        }
                        return;
                    }

                    // Cenário 2 (default): gerando contrato isoladamente pelo menu de 3 pontinhos
                    const escolha = escolhaGerarContratoRef.current;
                    finalizarGeracaoContrato(
                        modeloContratoSelecionadoId,
                        manuais,
                        escolha.adicionarComoNovo,
                        escolha.nome,
                        escolha.descricao,
                        escolha.naoEnviarAssinatura,
                    );
                }}
                show={exibirModalVariaveisManuais}
                carregando={carregandoGerarContrato}
                onHide={() => setExibirModalVariaveisManuais(false)}
                onCancel={() => setExibirModalVariaveisManuais(false)}
                isSaving={carregandoGerarContrato}
                titulo="Preencher Dados do Contrato"
                footerText={[{ text: 'Não foi possível preencher automaticamente esses campos no seu contrato. Por favor, preencha-os manualmente.', color: '#1F467E' }]}
                tituloBotaoOk="Gerar"
                apiConfig={{
                    endpoint: 'locacao',
                    idTenentCampo: 'idEmpresa',
                    requisicaoBemSucedida: requisicaoBemSucedida,
                    tratarErro: tratarErro,
                }}
            />

            <Modal show={exibirFormModalSubstituirVeiculo} onHide={() => setExibirFormModalSubstituirVeiculo(false)} onShow={abrirModalSubstituirVeiculo} size="lg">
                <Modal.Header>
                    <Modal.Title>Substituir Veículo</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col md={12}>
                            <Form.Group className="mb-3">
                                <Form.Label>Veículo Atual</Form.Label>
                                <Form.Control type="text" readOnly disabled
                                    value={locacaoSelecionado.veiculo ? `${locacaoSelecionado.veiculo?.placa} - ${locacaoSelecionado.veiculo?.marca} ${locacaoSelecionado.veiculo?.modelo} ${locacaoSelecionado.veiculo?.ano}` : ''} />
                            </Form.Group>
                        </Col>
                        <Col md={8}>
                            <Form.Group className="mb-3">
                                <Form.Label>Novo Veículo <span style={{ color: 'red' }}>*</span></Form.Label>
                                <Form.Control as="select" value={novoVeiculoSelecionado} onChange={(e: any) => setNovoVeiculoSelecionado(e.target.value)}>
                                    <option value="">Selecione...</option>
                                    {veiculosParaSubstituicao.map((v: any) => (
                                        <option key={v.valor} value={v.valor}>{v.label}</option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group className="mb-3">
                                <Form.Label>Data da Substituição <span style={{ color: 'red' }}>*</span></Form.Label>
                                <Form.Control type="datetime-local" value={dataSubstituicao} onChange={(e: any) => setDataSubstituicao(e.target.value)} />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>KM do veículo atual (na saída)</Form.Label>
                                <Form.Control type="number" min={0} placeholder="Ex: 50000" value={kmFinalVeiculoAtual}
                                    onChange={(e: any) => setKmFinalVeiculoAtual(e.target.value)} />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>KM do novo veículo (na entrada)</Form.Label>
                                <Form.Control type="number" min={0} placeholder="Ex: 15000" value={kmInicialNovoVeiculo}
                                    onChange={(e: any) => setKmInicialNovoVeiculo(e.target.value)} />
                            </Form.Group>
                        </Col>
                    </Row>

                    {historicoSubstituicao.length > 0 && (
                        <>
                            <hr />
                            <h6 style={{ marginBottom: 12, fontWeight: 600 }}>Histórico de Substituições</h6>
                            <div style={{ position: 'relative', paddingLeft: 20 }}>
                                <div style={{ position: 'absolute', left: 8, top: 0, bottom: 0, width: 2, background: '#dee2e6' }} />
                                {historicoSubstituicao.map((h: any, i: number) => (
                                    <div key={h.Id || h.id} style={{ position: 'relative', marginBottom: 16, paddingLeft: 16 }}>
                                        <div style={{
                                            position: 'absolute', left: -16, top: 4, width: 12, height: 12,
                                            borderRadius: '50%', background: i === historicoSubstituicao.length - 1 ? '#0d6efd' : '#adb5bd',
                                            border: '2px solid #fff', zIndex: 1
                                        }} />
                                        <div style={{ fontSize: 13, color: '#6c757d', fontWeight: 500 }}>
                                            {formatarDataHora(h.DataSubstituicao || h.dataSubstituicao)}
                                        </div>
                                        <div style={{ fontSize: 14 }}>
                                            <span style={{ color: '#dc3545' }}>{h.veiculoAnterior || h.VeiculoAnterior}</span>
                                            {' '}<FaExchangeAlt size={12} style={{ color: '#6c757d' }} />{' '}
                                            <span style={{ color: '#198754' }}>{h.veiculoNovo || h.VeiculoNovo}</span>
                                        </div>
                                        {(h.kmFinalVeiculoAnterior != null || h.kmInicialVeiculoNovo != null) && (
                                            <div style={{ fontSize: 12, color: '#6c757d' }}>
                                                {h.kmFinalVeiculoAnterior != null && <>Saiu com {Number(h.kmFinalVeiculoAnterior).toLocaleString('pt-BR')} km</>}
                                                {h.kmFinalVeiculoAnterior != null && h.kmInicialVeiculoNovo != null && ' • '}
                                                {h.kmInicialVeiculoNovo != null && <>Entrou com {Number(h.kmInicialVeiculoNovo).toLocaleString('pt-BR')} km</>}
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setExibirFormModalSubstituirVeiculo(false)}>Cancelar</Button>
                    <Button variant="primary" onClick={onSaveSubstituirVeiculo} disabled={carregandoSubstituirVeiculo}>
                        {carregandoSubstituirVeiculo ? 'Substituindo...' : 'Substituir'}
                    </Button>
                </Modal.Footer>
            </Modal>

            <ModalAlerta
                message={messagem}
                show={showAlertaSimNao}
                ehDeSimNao={true}
                onHide={() => setShowAlertaSimNao(false)}
                onSim={handleOnSim}
            />

            <ModalAlerta
                message={messagemConfirmarRegeracao}
                show={showAlertaConfirmarRegeracao}
                ehDeSimNao={true}
                onHide={() => setShowAlertaConfirmarRegeracao(false)}
                onSim={handleRegerarPagamentosPrevistos}
            />

            <ModalLink
                show={exibirLinkAssinaturaModal}
                onClose={() => setExibirLinkAssinaturaModal(false)}
                title="Link para Assinatura"
                actions={[
                    {
                        label: "Copiar Link",
                        onClick: () => {
                            navigator.clipboard.writeText(linkAssinatura);
                            toast.success("Link copiado para a área de transferência!");
                        },
                    },
                    {
                        label: "Fechar",
                        onClick: () => setExibirLinkAssinaturaModal(false),
                    },
                ]}
            >
                <p>Copie o link abaixo e envie para o locatário assinar o contrato.</p>
                <TextField
                    fullWidth
                    value={linkAssinatura}
                    InputProps={{
                        readOnly: true,
                    }}
                    variant="outlined"
                    margin="normal"
                />
            </ModalLink>

            <ContratoViewer
                open={exibirVisualizadorContrato}
                onClose={() => setExibirVisualizadorContrato(false)}
                link={linkContratoPreview}
                titulo={tituloContratoVisualizador}
            />

            <ModalResumoLocacao
                show={exibirResumoLocacao}
                onHide={() => { setExibirResumoLocacao(false); setIdLocacaoResumo(null); }}
                idLocacao={idLocacaoResumo}
            />

            <ModalRelatorioLocacao
                show={showRelatorioLocacao}
                onClose={() => { setShowRelatorioLocacao(false); setLocacaoSelecionadaParaRelatorio(null); }}
                locacao={locacaoSelecionadaParaRelatorio}
            />

            <ModalConciliarBanco
                show={exibirModalConciliar}
                locacao={locacaoConciliacao}
                onClose={() => setExibirModalConciliar(false)}
                onSuccess={() => setRealizarConsulta(true)}
            />

            <ModalDocumentosLocacao
                show={exibirModalDocumentos}
                locacao={locacaoDocumentos}
                onClose={() => setExibirModalDocumentos(false)}
            />

            <ModalLoginApp
                show={exibirModalLoginApp}
                idLocatario={loginAppLocatarioId}
                idEmpresa={obterIdTenent(token)}
                onClose={() => setExibirModalLoginApp(false)}
            />

            <ModalEscolhaGerarContrato
                show={exibirEscolhaContrato}
                onClose={() => setExibirEscolhaContrato(false)}
                onConfirmar={async ({ adicionarComoNovo, nome, descricao, naoEnviarAssinatura }) => {
                    if (!escolhaContratoModeloId) return;
                    // O modal mantém o spinner ativo enquanto a Promise não resolve.
                    // prosseguirGerarContrato re-throw em caso de erro para o spinner liberar.
                    await prosseguirGerarContrato(
                        escolhaContratoModeloId,
                        adicionarComoNovo,
                        adicionarComoNovo ? nome : '',
                        adicionarComoNovo ? descricao : '',
                        naoEnviarAssinatura,
                    );
                }}
            />
        </LocaSmartLayout>
        </>
    );
}

export default LocacaoListagem;